<style>
  /* Absolute Center Spinner */
  .loading {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  
  /* Transparent Overlay */
  .loading:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
      background: radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0, .8));
  
    background: -webkit-radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0,.8));
  }
  
  /* :not(:required) hides these rules from IE9 and below */
  .loading:not(:required) {
    /* hide "loading..." text */
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
  }
  
  .loading:not(:required):after {
    content: '';
    display: block;
    font-size: 10px;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    -webkit-animation: spinner 150ms infinite linear;
    -moz-animation: spinner 150ms infinite linear;
    -ms-animation: spinner 150ms infinite linear;
    -o-animation: spinner 150ms infinite linear;
    animation: spinner 150ms infinite linear;
    border-radius: 0.5em;
    -webkit-box-shadow: rgba(255,255,255, 0.75) 1.5em 0 0 0, rgba(255,255,255, 0.75) 1.1em 1.1em 0 0, rgba(255,255,255, 0.75) 0 1.5em 0 0, rgba(255,255,255, 0.75) -1.1em 1.1em 0 0, rgba(255,255,255, 0.75) -1.5em 0 0 0, rgba(255,255,255, 0.75) -1.1em -1.1em 0 0, rgba(255,255,255, 0.75) 0 -1.5em 0 0, rgba(255,255,255, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(255,255,255, 0.75) 1.5em 0 0 0, rgba(255,255,255, 0.75) 1.1em 1.1em 0 0, rgba(255,255,255, 0.75) 0 1.5em 0 0, rgba(255,255,255, 0.75) -1.1em 1.1em 0 0, rgba(255,255,255, 0.75) -1.5em 0 0 0, rgba(255,255,255, 0.75) -1.1em -1.1em 0 0, rgba(255,255,255, 0.75) 0 -1.5em 0 0, rgba(255,255,255, 0.75) 1.1em -1.1em 0 0;
  }
  
  /* Animation */
  
  @-webkit-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-moz-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-o-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  </style>
 
      <div  class="loading" id="bestgiftsloader" style="display: none;">Loading&#8230;</div>

<section   *ngIf="config.title=='ShubhCards' || config.title=='SriSenbaga'" class="rounder-corner-nav rotate-dot banner_bestgifts desktop-only"  style="position: relative;">
  
    
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel"  >
      <div class="carousel-inner" >
        <div class="carousel-item" *ngFor="let item of imageAssets; let i = index" [class.active]="i==0"   >
          
            <div class="container">
              <img class="d-block w-100"[src]="item.image_source"  style="object-fit: contain;height: 120vh;">
           
            

          </div>
          
        </div>
        <!-- <div class="carousel-item">
          <img class="d-block w-100" src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/shubcards/StoreGallery/1715157059263%20-%20Untitled%20design%20%284%29-min.png" alt="Second slide">
        </div>
        <div class="carousel-item">
          <img class="d-block w-100" src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/shubcards/StoreGallery/1715157059263%20-%20Untitled%20design%20%284%29-min.png" alt="Third slide">
        </div> -->
      </div>
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  
</section>

<section *ngIf="config.title!=='LinenRaj'">
  <app-alerts></app-alerts>
  <div class="schift-detail-background">
  <div class="product-details-wrapper schift-white-back">
    <div class="details-top container" id="product_breadcrumbs">
      <div class="aside-group"></div>
    </div>
    <div class="titleCase-product-taazah" *ngIf="config.title == 'Taazah'">
    
      <div class="breadCrumb-productTitle taz_headlink" style="color:white;margin-top:1%;padding-top: 0.8%;
      padding-left: 1.5%">
        <span class="home-breadcrumb"  id="breadCrumbProductDetails" routerLink="">Home</span>
        <span class="customer-breadcrumb" id="breadCrumbProductDetails" (click)="backToCategory(product.categories[0].categories)">
          <i class="px-2" id="breadCrumbProductDetails" >/</i>{{product.categories[0].categories|titlecase}}</span>
           <span class="customer-breadcrumb" id="breadCrumbProductDetails">
              <i class="px-2" id="breadCrumbProductDetails">/</i>{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo)}}</span>
</div>
</div>
<div class="row container details-wrapper con-hig" *ngIf="config.title === 'Taazah'">
  <div class="col-sm-Taz vistas-imgcol">
    <div class="slider desktop-only">
      <div class="desktop-only" *ngIf="config.title === 'Taazah'">
        
        <div class="productDetailImage" *ngIf="config.title === 'Taazah'"  style="margin-left: 2%;">
        <div
        *ngIf="!image_preview && !video_preview">
        <lib-ngx-image-zoom  [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
          [lensWidth]="300" [lensHeight]="275" class="vistas-detailimage"></lib-ngx-image-zoom>
        
      </div>
      <div
                  *ngIf="image_preview">
                  <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                    [enableLens]="true" [lensWidth]="300" [lensHeight]="275"></lib-ngx-image-zoom>
                </div>
      </div>
      <div style="display: flex;height:100px" class="image-highlight-taazah">
      <div *ngFor="let item of imageAssets; let i = index">
        <div *ngIf="item.image_source != ''" class="image-highlight">
          <img [src]="item.image_source" class="image-preview-product-taazah" style="width: 90px;"
            [class.active]="isActive === i || newActive === i" (click)="imagePreview(item, i)" />
      
        </div>
      </div>
      </div>
      </div>
      <div class="mobile-only" *ngIf="config.title === 'Taazah'">
            
        <div class="productDetailImage" *ngIf="config.title === 'Taazah'"  style="width: 80%; margin-left: 5%;">
        <div
        *ngIf="!image_preview && !video_preview">
        <lib-ngx-image-zoom  [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
          [lensWidth]="300" [lensHeight]="275" class="vistas-detailimage"></lib-ngx-image-zoom>
        
      </div>
      <div
                  *ngIf="image_preview">
                  <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                    [enableLens]="true" [lensWidth]="300" [lensHeight]="275"></lib-ngx-image-zoom>
                </div>
      </div>
      <div style="width: 100%;display: flex;">
      <div *ngFor="let item of imageAssets; let i = index">
        <div *ngIf="item.image_source != ''" class="image-highlight">
          <img [src]="item.image_source" class="image-preview-product" style="margin-right: 20px;"
            [class.active]="isActive === i || newActive === i" (click)="imagePreview(item, i)" />
      
        </div>
      </div>
      </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6 example detail-align pro_detail kat_height" id="" *ngIf="newProductDetails"
        style="overflow-y: hidden; height: 100%; ">
        <div class="col-left" *ngIf="groups[0].showondetailpage">
          <div class="product-detail">
<h2 class="product-name desktop-only" id="prodName" style="font-weight: bolder; margin-bottom: 20px !important; margin-top:12%;" *ngIf="groups[0].fields[0].visibility">
                    <div style="font-size: 18px;font-family: system-ui; margin-bottom: 20px; color: rgb(27 81 164);
                    ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div>

                    <div style="display: flex;justify-content: space-between;width: 50%;"> <p class="product-det">Product No: {{product.id}}</p>
                     <p class="product-det" *ngIf="product.stock_status == 'Available'">{{product.stock_status}} (In Stock)</p> 
                    </div>
                      </h2>

</div>
</div>
<h2 class="product-name mobile-only" id="prodName" style="font-weight: bolder;margin-bottom: 20px;" *ngIf="groups[0].fields[0].visibility && config.title === 'Taazah'">
                  <div style="font-weight: 700;font-size: 24px;font-family: system-ui; margin-bottom: 10px; color: #1b52a4;
                  ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo)}} </div>
                 
                    
                    </h2>

<div  *ngIf="config.title === 'Taazah'" class="mobile-only">
          <!-- <h4 style="font-size: 15px; font-weight: 700;">Description</h4> -->
          <div class="breadcurmb">
            <div class="normalSize specialsize" [innerHTML]="shortDescription">
            </div>
          </div>
    <hr/>
        </div>
 <div class="col-right" id="simple" *ngIf="config.title ==='Taazah' && product.stock_status=='Available' && product.product_type=='Variable'">
          <div class="col-right">
            <p class="sizeText" style="font-weight: 500;font-size: 14px;font-family: system-ui;">{{ variantName }}</p>
          </div>
          
          <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
            <button type="button" id="button" 
                          class="choisebuttonbaby" [class.active]="items.is_default" (click)="onConfirm1(items,items.id,j)" value="items.id">
                          {{ items.option }}
                        </button>
            <hr />
          </div>

        </div>
        <div style="font-size: 14px;font-weight: 700;color: #d98614;margin-top: 20px;margin-bottom: 10px;" *ngIf="!showtype && product.product_type=='Variable' && product.variant.variant_child">
          Select options to proceed with the order
        </div>
        <div *ngIf="product.product_type=='Variable' && product.variant.option_values[current_index].child && showtype && product.stock_status=='Available'">
          <label for="part">Weight : </label>
          <div style="display: flex;">
          <div *ngFor="let child of product.variant.option_values[current_index!=null?current_index:0].child;let k=index">
            <button type="button" id="button" [class.active]="child.is_default"
            class="choisebuttonbaby" aria-haspopup="true" aria-expanded="false" (click)="selectColour(child.type,product.id,k)">
            {{child.type}}
            </button>
          </div>
        </div>
        </div>
        <div  *ngIf="config.title === 'Taazah'">
          <!-- <h4 style="font-size: 15px; font-weight: 700;">Description</h4> -->
          <div class="breadcurmb">
            <div class="normalSize specialsize" [innerHTML]="content1">
            </div>
          </div>
      <div style="display: flex;margin-bottom: 10px;" class="taazah-price" *ngIf="product.product_type=='Variable' && !product.variant.variant_child"> 
        <div class="col-right deera-price-row" style="display: flex;">
            <div  *ngIf="current_index==0" style="display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;" class="product-list-price-taazah" >
              Discount Price ₹{{product.variant.option_values[0].pricing.raw.price}}.00
             </div>
             <div  *ngIf="current_index!=0" style="display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;" class="product-list-price-taazah" >
              Discount Price ₹{{product.variant.option_values[current_index].pricing.raw.price}}.00
             </div>
       <div *ngIf="current_index==0" style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{product.variant.option_values[0].pricing.raw.msrp}}.00</div>
       <div *ngIf="current_index!=0" style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{product.variant.option_values[current_index].pricing.raw.msrp}}.00</div>
        </div></div>
        <div style="display: flex;margin-bottom: 10px;" class="taazah-price" *ngIf="product.product_type=='Variable' && product.variant.variant_child && showtype"> 
          <div class="col-right deera-price-row" style="display: flex;">
              <div  *ngIf="current_index==0" style="display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;" class="product-list-price-taazah" >
                Discount Price ₹{{product.variant.option_values[0].child[0].pricing.raw.price}}.00
               </div>
               <div  *ngIf="current_index!=0" style="display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;" class="product-list-price-taazah" >
                Discount Price ₹{{product.variant.option_values[current_index].child[child_index].pricing.raw.price}}.00
               </div>
         <div *ngIf="current_index==0" style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{product.variant.option_values[0].child[0].pricing.raw.msrp}}.00</div>
         <div *ngIf="current_index!=0" style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{product.variant.option_values[current_index].child[child_index].pricing.raw.msrp}}.00</div>
          </div></div>
        <div *ngIf="product.product_type=='Simple'" style="display: flex;margin-bottom: 10px;" class="taazah-price"> 
          <div class="col-right deera-price-row" style="display: flex;">
        <div style=" display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;">
          Discount Price ₹{{newProductDetails.pricing.raw.price}}.00
         </div>
         
          </div>
          <div style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{newProductDetails.pricing.raw.msrp}}.00</div>
        </div>
        </div>

<div class="col-right" *ngIf="groups[1].showondetailpage">
          <div class="add-to">


<div style="display: flex;">
<span *ngIf="config.title === 'Taazah' && product.product_type=='Simple'&&product.stock_status=='Available'">
<button class="btn inq-btn taazah-cart-btn1"
  (click)="addTocart()" *ngIf="
(appService.productIdinCart.indexOf(newProductDetails.id) ==
  -1 ) ||
(showSize &&
  appService.productIdinCart.indexOf(checkVariantInCart) ==
    -1)
">
 
  <span> <i class="fa fa-shopping-cart"></i></span>
  {{ groups[1].fields[0].labelname }}
</button>
</span>

<span *ngIf="(appService.productIdinCart.indexOf(newProductDetails.id) != -1 || appService.productIdinCart.indexOf(checkVariantInCart) != -1)" class="width_Taz_20">
                <div *ngFor="let cart of appService.cartProducts.results; let i = index">
                  <span *ngIf=" product.product_type=='Simple'">
                    <div class="DetailsviewCart_Taz"
                      *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                      <span>
                        <i class="fa fa-minus mr-2" (click)="decreaseItem(i)"
                          style="font-size: 12px; cursor: pointer"></i></span>
                      <span class="inq-sp-2" style="color: white">{{ cart.quantity }}</span>
                      <span>
                        <i class="fa fa-plus ml-2" (click)="increaseItem(i)"
                          style="font-size: 12px; cursor: pointer"></i></span>
                    </div>
                  </span>
                </div>
              </span>
<span *ngIf="
(config.title === 'Taazah' && product.product_type=='Simple' && product.stock_status=='Available' &&
!showSize)
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px;
">
<button class="btn inq-btn-sm ml-1 order-btn-taazah" (click)="buyNow()">Order Now</button>


</span>
</div>
<span *ngIf="config.title === 'Taazah' && product.product_type=='Variable' && product.stock_status=='Available' && !product.variant.variant_child" class="cartaddfun">
<div class="deercar taz_caraaa">
<div class="" *ngFor="let price of product.variant.option_values;let i = index" style="">

  <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="btn inq-btn taazah-cart-btn1" (click)="addToCartTaz(price.id)">
    <span> <i class="fa fa-shopping-cart"></i></span> Add to Cart
  </button>   
  
  <div class="DetailsviewCart_Taz" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
      
        <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
            (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
            <!-- <input type="number" style="width: 46%; text-align: center" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1"  *ngIf="config.title == 'Deera'"
            (input)="changeDeeraValue(i, $event)" [(ngModel)]="cart.quantity" /> -->
            <span class="inq-sp-2"
                      style="padding-left: 15px;
                padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[current_index].id)].quantity}}</span>
        <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
            (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>


      </div>
      
  </div>
</div>
  <span *ngIf="
(product.product_type=='Variable')
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px;
">
<button class="btn inq-btn-sm ml-1 order-btn-taazah" (click)="buyNowBaby()">
Order Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
</span>
<span *ngIf="config.title === 'Taazah' && product.product_type=='Variable' && product.stock_status=='Available' && product.variant.variant_child && showtype" class="cartaddfun">
  <div class="deercar taz_caraaa">
  <div class="" style="">
  
    <!-- <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="btn inq-btn ml-1 taazah-cart-btn1" (click)="addToCartLush(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id)">
      <span> <i class="fa fa-shopping-cart"></i></span> Add to Cart
    </button>    -->
    <div *ngFor="let price of product.variant.option_values[current_index!=-1?current_index:0].child;let i = index">
      <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id) ==
      -1" class="btn inq-btn taazah-cart-btn1" (click)="addToCartLush(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id )" >
      <span> <i class="fa fa-shopping-cart"></i></span> Add to Cart
      </button>
    </div>
        <div *ngFor="let rate of appService.cartProducts.results;let j = index">
          <div class="DetailsviewCart_Taz"
           id="quantity_button" *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id) != -1 && (rate.product_id == product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id)">
          <span><i class="fa fa-minus mr-3 margin_top_12"  style="font-size: 12px; cursor: pointer" (click)="decreaseItemNew(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id))"></i></span>
          <!-- <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1"
          (input)="changeSpecialValue(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id)].quantity" /> -->
          <span class="inq-sp-2"
                         style="padding-left: 15px;
                   padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id)].quantity}}</span> 
           <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"  (click)="increaseItem(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id))"></i></span>
          </div>
        </div>
    </div>
  </div>
    <span *ngIf="
  (product.product_type=='Variable')
  " style="
  font-size: 16px !important;
  color: grey !important;
  margin-left: 5px;
  ">
  <button class="btn inq-btn-sm ml-1 order-btn-taazah" (click)="buyNowLush(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id)">
  Order Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>
  
  
  </span>
  </span>
</div>
</div>
      </div>
</div>
    <div class=" row container details-wrapper con-hig details-top container"  *ngIf="config.title !== 'Taazah'" id="product_breadcrumbs">
      <div class="col-sm-6 vistas-imgcol">
        <div class="slider desktop-only">
          <div class="desktop-only" *ngIf="config.title === 'Babys Pride'" style="display: flex;">
            <div style="width: 15%;">
          <div *ngFor="let item of imageAssets; let i = index">
            <div *ngIf="item.image_source != ''" class="image-highlight">
              <img [src]="item.image_source" class="image-preview-product" style="width: 80px; height: 100px;margin-top: 20px;"
                [class.active]="isActive === i || newActive === i" (click)="imagePreview(item, i)" />

            </div>
          </div>
        </div>
          <div class="productDetailImage" *ngIf="config.title === 'Babys Pride'"  style="width: 80%; margin-left: 5%;">
          <div
          *ngIf="!image_preview && !video_preview">
          <lib-ngx-image-zoom  [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
            [lensWidth]="300" [lensHeight]="275" class="vistas-detailimage"></lib-ngx-image-zoom>
          
        </div>
        <div
                    *ngIf="image_preview">
                    <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                      [enableLens]="true" [lensWidth]="300" [lensHeight]="275"></lib-ngx-image-zoom>
                  </div>
      </div>
    </div>
      <div class="desktop-only" *ngIf="config.title === 'LushNGreen'">
        
      <div class="productDetailImage" *ngIf="config.title === 'LushNGreen'"  style="margin-left: 2%;">
      <div
      *ngIf="!image_preview && !video_preview">
      <lib-ngx-image-zoom  [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
        [lensWidth]="300" [lensHeight]="275" class="vistas-detailimage"></lib-ngx-image-zoom>
      
    </div>
    <div
                *ngIf="image_preview">
                <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                  [enableLens]="true" [lensWidth]="300" [lensHeight]="275"></lib-ngx-image-zoom>
              </div>
  </div>
  <div style="display: flex">
    <div *ngFor="let item of imageAssets; let i = index">
      <div *ngIf="item.image_source != ''" class="image-highlight">
        <img [src]="item.image_source" class="image-preview-product" style="width: 90px; height: 100px;margin-top: 20px;margin-left: 10px;"
          [class.active]="isActive === i || newActive === i" (click)="imagePreview(item, i)" />

      </div>
    </div>
  </div>
</div>
<div class="desktop-only" *ngIf="config.title === 'KatbookStore'">
        
  <div
  *ngIf="!image_preview && !video_preview" style="margin-left: 10%; margin-right: 10%; box-shadow: 0 0 1rem #00000026!important;padding: 10% 3%;    border: 2px solid #dfdfdf;"> 
  <lib-ngx-image-zoom [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true" style="height: 600px;height: auto;"
    [lensWidth]="375" [lensHeight]="325" class="vistas-detailimage"></lib-ngx-image-zoom>
  
</div>
</div>
    <div class="mobile-only" *ngIf="config.title === 'Babys Pride'">
      
    <div class="productDetailImage" *ngIf="config.title === 'Babys Pride'"  style="width: 80%; margin-left: 5%;">
    <div
    *ngIf="!image_preview && !video_preview">
    <lib-ngx-image-zoom  [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
      [lensWidth]="300" [lensHeight]="275" class="vistas-detailimage"></lib-ngx-image-zoom>
    
  </div>
  <div
              *ngIf="image_preview">
              <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                [enableLens]="true" [lensWidth]="300" [lensHeight]="275"></lib-ngx-image-zoom>
            </div>
</div>
<div style="width: 100%;display: flex;">
  <div *ngFor="let item of imageAssets; let i = index">
    <div *ngIf="item.image_source != ''" class="image-highlight">
      <img [src]="item.image_source" class="image-preview-product" style="margin-right: 20px;"
        [class.active]="isActive === i || newActive === i" (click)="imagePreview(item, i)" />

    </div>
  </div>
</div>
</div>
<div class="mobile-only" *ngIf="config.title === 'LushNGreen'">
      
  <div class="productDetailImage" *ngIf="config.title === 'LushNGreen'"  style="width: 80%; margin-left: 5%;">
  <div
  *ngIf="!image_preview && !video_preview">
  <lib-ngx-image-zoom  [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
    [lensWidth]="300" [lensHeight]="275" class="vistas-detailimage"></lib-ngx-image-zoom>
  
</div>
<div
            *ngIf="image_preview">
            <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
              [enableLens]="true" [lensWidth]="300" [lensHeight]="275"></lib-ngx-image-zoom>
          </div>
</div>
<div style="width: 100%;display: flex;">
<div *ngFor="let item of imageAssets; let i = index">
  <div *ngIf="item.image_source != ''" class="image-highlight">
    <img [src]="item.image_source" class="image-preview-product" style="margin-right: 20px;"
      [class.active]="isActive === i || newActive === i" (click)="imagePreview(item, i)" />

  </div>
</div>
</div>
</div>

<div class="mobile-only" *ngIf="config.title === 'KatbookStore'">
      
  <div class="productDetailImage" *ngIf="config.title === 'KatbookStore'"  style="width: 80%; margin-left: 5%;">
  <div
  *ngIf="!image_preview && !video_preview">
  <lib-ngx-image-zoom  [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
    [lensWidth]="300" [lensHeight]="275" class="vistas-detailimage"></lib-ngx-image-zoom>
  
</div>
</div>
</div>
<!-- for shubcards -->
<div class="breadcurmb" *ngIf="config.title === 'ShubhCards' || config.title === 'SriSenbaga' ">
  <div class="normalSize specialsize" [innerHTML]="content1" style="font-size: 14px !important; color:black; font-family: system-ui;line-height: 30px;">
    <hr />
  </div>
  <div style="margin-top: 1%;">
    <h4  *ngIf="config.title === 'ShubhCards'" style="color: #fe6602;">Additional Information</h4>
    <h4   *ngIf="config.title === 'SriSenbaga'" style="color:  #27266a;">கூடுதல் செய்தி</h4>
    <div class="breadcurmb">
      <div class="normalSize specialsize" [innerHTML]="description" style="color: black;font-family: system-ui;line-height: 30px;">
      </div>
    </div>
  </div>
</div>
<!-- for shubcards -->
    <div  *ngIf="config.title === 'Babys Pride'" class="desktop-only" style="margin-left: 20%;">
      <h4 style="font-size: 15px; font-weight: 700;">Description</h4>
      <div class="breadcurmb">
        <div class="normalSize specialsize" [innerHTML]="shortDescription">
        </div>
      </div>

    </div>
          <owl-carousel-o [options]="ProductDetailsMainSliderConfig" #owlCar
            class="homepage-banner-slider rounder-corner-nav product-slick"  *ngIf="config.title !== 'LinenRaj' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !== 'KatbookStore' && config.title !== 'ShubhCards'&& config.title !== 'Taazah' && config.title !== 'SriSenbaga'">
            <ng-container>
              <ng-template carouselSlide>
                <div class="productDetailImage">
                  <!-- <img [src]="mainImage" id="brokenImage" (error)="finndBroken()"> -->

                  <!-------set default and preview image for tams no zoom-->
                  <!-- <div *ngIf="!image_preview && !video_preview  && config.title == 'Tams' || config.title =='Mayan'"> -->

                  <div *ngIf="(!image_preview )&& ( config.title == 'Mayan'||config.title == 'Tams'||config.title == 'AvonSeals') ">
                    <lib-ngx-image-zoom [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
                      [lensWidth]="200" [lensHeight]="200"></lib-ngx-image-zoom>
                  </div>
                  <div *ngIf="(image_preview )&& ( config.title == 'Mayan'||config.title == 'Tams'||config.title == 'AvonSeals') ">
                    <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                      [enableLens]="true" [lensWidth]="200" [lensHeight]="200"></lib-ngx-image-zoom>
                  </div>
                  
                  <!-----------set default image with preview-->
                  <div
                    *ngIf="!image_preview && !video_preview && (config.title != 'Tams' && config.title != 'Mayan' && config.title != 'ShubhCards' && config.title != 'Carience' && config.title != 'Vimpro' && config.title != 'AvonSeals' && config.title != 'SpecialWires' && config.title != 'Taazah' && config.title != 'LinenRaj')">
                    <lib-ngx-image-zoom  *ngIf="config.title != 'Beaubelle'" [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true" style="height: 600px;height: auto;"
                      [lensWidth]="375" [lensHeight]="325" class="vistas-detailimage"></lib-ngx-image-zoom>
                      <lib-ngx-image-zoom  *ngIf="config.title == 'Beaubelle'"  [ngClass]="'disable-pointer-events'" [thumbImage]="mainImage"  [enableLens]="false" [lensWidth]="0" [lensHeight]="0"
                       ></lib-ngx-image-zoom>
                    
                  </div>
                 
                  <!-- <div
                    *ngIf="!image_preview && !video_preview && (config.title == 'AvonSeals')">
                     <lib-ngx-image-zoom [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
                      [lensWidth]="375" [lensHeight]="325"></lib-ngx-image-zoom>
                  </div> -->

                  <!-- <div *ngIf="config.title=='AvonSeals'">
                        <lib-ngx-image-zoom
                        [thumbImage]="mainImage"
                        [fullImage]="mainImage"
                        [enableLens]="true"
                        [lensWidth]="375"
                        [lensHeight]="325"
                      ></lib-ngx-image-zoom>                      
                    </div> -->
                  <div *ngIf="config.title=='Carience'">
                  <div    *ngFor="let img_colour of product.variant.option_values[current_index].child;let i = index" class="">
                    <div *ngIf="img_colour.is_default">
                      <div *ngIf="image_preview==false">
                        <lib-ngx-image-zoom
                      [thumbImage]="img_colour.assets[0].image_source"
                      [fullImage]="img_colour.assets[0].image_source"
                      [enableLens]="true"
                      [lensWidth]="375"
                      [lensHeight]="325"
                    ></lib-ngx-image-zoom>

                      </div>
                      
                      <div *ngIf="image_preview==true">
                        <lib-ngx-image-zoom
                      [thumbImage]="mainImagePreview"
                      [fullImage]="mainImagePreview"
                      [enableLens]="true"
                      [lensWidth]="375"
                      [lensHeight]="325"
                    ></lib-ngx-image-zoom>

                      </div>
                      <!-- <img [src]="img_colour.asset[0].image_source" id="img-list" 
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="carience-image-container" /> -->
                      </div>
                    </div>

                  </div>
                  <!-- <div *ngIf="config.title=='LinenRaj'">
                    <div class="">
                      <div *ngFor="let prod_img of product.variant.option_values; let i = index">
                        <lib-ngx-image-zoom
                        [thumbImage]="prod_img.assets[0].image_source"
                        [fullImage]="prod_img.assets[0].image_source"
                        [enableLens]="true"
                        [lensWidth]="375"
                        [lensHeight]="325"
                      ></lib-ngx-image-zoom>
                        </div>
                      </div>
  
                    </div> -->
                    <!-- <div class="col-md-12 col-12 thumb_2" style="transform: none;"  *ngIf=" config.title=='LinenRaj'">
                      <div class="row mb__50 pr_sticky_content" style="transform: none;">
                  
                        <div class="col-md-7 col-12 pr product-images img_action_zoom pr_sticky_img" data-pr-single-media-group="">
                            <div class="row theiaStickySidebar">
                              <div class="productDetailImage" style="width: 107%;">
                                <div style="display: grid; grid-template-columns: repeat(2, 1fr);margin-left: 30px;" >
                                  <div class="linen_img">
                                <img class="linendetailimg" src="../../../../../assets/images/linenraj/1.jpg">
                              </div>
                              <div class="linen_img">
                                <img class="linendetailimg" src="../../../../../assets/images/linenraj/2.jpg">
                              </div>
                                <div class="linen_img">
                                <img class="linendetailimg" src="../../../../../assets/images/linenraj/3.jpg">
                              </div>
                                <div class="linen_img">
                                <img class="linendetailimg" src="../../../../../assets/images/linenraj/4.jpg">
                              </div>
                                <div class="linen_img">
                                <img class="linendetailimg" src="../../../../../assets/images/linenraj/5.jpg">
                              </div>
                                <div class="linen_img">
                                <img class="linendetailimg" src="../../../../../assets/images/linenraj/6.jpg">
                              </div>
                              </div>
                  </div>
                         </div>
                        </div>
                      </div></div> -->
                  <div *ngIf=" config.title=='SpecialWires'&& newProductDetails.product_type=='Variable'">
                    <div *ngIf="current_index==-1">
                      <!-- <div    *ngFor="let img_colour of product.variant.option_values[0].child;let i = index" class=""> -->
                          <lib-ngx-image-zoom
                          [thumbImage]="product.variant.option_values[0].child[0].assets[0].image_source"
                          [fullImage]="product.variant.option_values[0].child[0].assets[0].image_source"
                          [enableLens]="true"
                          [lensWidth]="375"
                          [lensHeight]="325"
                        ></lib-ngx-image-zoom>
                          <!-- <img [src]="img_colour.asset[0].image_source" id="img-list" 
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                            class="carience-image-container" /> -->
                          
                        <!-- </div> -->
                      </div>
                    <div *ngIf="current_index!=-1">
                      <!-- <div    *ngFor="let img_colour of product.variant.option_values[current_index].child;let i = index" class="">
                        <div *ngIf="img_colour.is_default"> -->
                          <lib-ngx-image-zoom
                          [thumbImage]="product.variant.option_values[current_index].child[child_index].assets[asset_index].image_source"
                          [fullImage]="product.variant.option_values[current_index].child[child_index].assets[asset_index].image_source"
                          [enableLens]="true"
                          [lensWidth]="375"
                          [lensHeight]="325"
                        ></lib-ngx-image-zoom>
                          <!-- <img [src]="img_colour.asset[0].image_source" id="img-list" 
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                            class="carience-image-container" /> -->
                          <!-- </div>
                        </div> -->
                      </div>
                    </div>




                    
                  
                  <div *ngIf="config.title=='Vimpro' && newProductDetails.product_type=='Variable'&&newProductDetails.variant.variant_child">
                    <div class="">
                      <div>
                        <lib-ngx-image-zoom
                        [thumbImage]="product.variant.option_values[current_index].child[child_index].assets[asset_index].image_source"
                        [fullImage]="product.variant.option_values[current_index].child[child_index].assets[asset_index].image_source"
                        [enableLens]="true"
                        [lensWidth]="375"
                        [lensHeight]="325"
                      ></lib-ngx-image-zoom>
                        <!-- <img [src]="img_colour.asset[0].image_source" id="img-list" 
                          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                          class="carience-image-container" /> -->
                        </div>
                      </div>
  
                    </div>
                    <div *ngIf="config.title=='Vimpro' && newProductDetails.product_type=='Simple'">
                     
                          <!-- <lib-ngx-image-zoom [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
                          [lensWidth]="375" [lensHeight]="325"></lib-ngx-image-zoom> -->
                          <div *ngIf="(!image_preview )">
                            <lib-ngx-image-zoom [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
                              [lensWidth]="200" [lensHeight]="200"></lib-ngx-image-zoom>
                          </div>
                          <div *ngIf="(image_preview )">
                            <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                              [enableLens]="true" [lensWidth]="200" [lensHeight]="200"></lib-ngx-image-zoom>
                          </div>
                        
    
                      </div>
                      <div *ngIf="config.title=='SpecialWires' && newProductDetails.product_type=='Simple'">
                     
                        <!-- <lib-ngx-image-zoom [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
                        [lensWidth]="375" [lensHeight]="325"></lib-ngx-image-zoom> -->
                        <div *ngIf="(!image_preview )">
                          <lib-ngx-image-zoom [thumbImage]="mainImage" [fullImage]="mainImage" [enableLens]="true"
                            [lensWidth]="200" [lensHeight]="200"></lib-ngx-image-zoom>
                        </div>
                        <div *ngIf="(image_preview )">
                          <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                            [enableLens]="true" [lensWidth]="200" [lensHeight]="200"></lib-ngx-image-zoom>
                        </div>
                      
  
                    </div>
                      <div *ngIf="config.title=='Vimpro' && newProductDetails.product_type=='Variable'&&!newProductDetails.variant.variant_child">
                        <div  class="">
                          <div>
                            <lib-ngx-image-zoom
                            [thumbImage]="newProductDetails.variant.option_values[current_index].assets[asset_index].image_source"
                            [fullImage]="newProductDetails.variant.option_values[current_index].assets[asset_index].image_source"
                            [enableLens]="true"
                            [lensWidth]="375"
                            [lensHeight]="325"
                          ></lib-ngx-image-zoom>
                            <!-- <img [src]="img_colour.asset[0].image_source" id="img-list" 
                              onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                              class="carience-image-container" /> -->
                            </div>
                          </div>
      
                        </div>
                       
                  <div
                    *ngIf="image_preview && config.title != 'Tams' && config.title != 'Mayan' && config.title != 'Carience' && config.title != 'Vimpro' && config.title != 'AvonSeals' && config.title != 'SpecialWires'">
                    <lib-ngx-image-zoom [thumbImage]="mainImagePreview" [fullImage]="mainImagePreview"
                      [enableLens]="true" [lensWidth]="375" [lensHeight]="325"></lib-ngx-image-zoom>
                  </div>
                  <!--------video preview-->
                  <!-- <div *ngIf="video_preview">
                                        <iframe [src]="mainViewVideo"  width="600" height="350" title="YouTube video player" frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    </div> -->
                  <!-- <img [src]="mainImage" id="brokenImage" (error)="finndBroken()"> -->

                  <hr  *ngIf="config.title !=='Vistas'" />
                  <div class="rounder-corner-nav" *ngIf="config.title==='Vimpro'&& newProductDetails.product_type=='Variable'&&newProductDetails.variant.variant_child">
                    <owl-carousel-o [options]="customOptions">
                      <!------------------image---------------->
                      <ng-container *ngFor="let item of newProductDetails.variant.option_values[current_index].child[child_index].assets; let i = index">
                        <ng-template carouselSlide *ngIf="item.image_source != ''" class="image-highlight">
                          <img [src]="item.image_source" class="image-preview-product" style="width: 80px; height: 80px"
                            [class.active]="isActive === i || newActive === i" (click)="asset_selector(item, i)" />

                        </ng-template>
                      </ng-container>

                      <!-----------video--------->

                      <ng-container *ngFor="let item of ImageVideoPreview">
                        <ng-template carouselSlide>
                          <div (click)="videoPreview(item)">
                            <iframe style="pointer-events: none" [src]="item.safeLink" width="80" height="80"
                              title="YouTube video player" frameborder="0"
                              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen></iframe>
                          </div>
                        </ng-template>
                      </ng-container>
                    </owl-carousel-o>
                  </div>
                  <div class="rounder-corner-nav" *ngIf="config.title==='Vimpro'&& newProductDetails.product_type=='Variable'&&!newProductDetails.variant.variant_child">
                    <owl-carousel-o [options]="customOptions">
                      <!------------------image---------------->
                      <ng-container *ngFor="let item of newProductDetails.variant.option_values[current_index].assets; let i = index">
                        <ng-template carouselSlide *ngIf="item.image_source != ''" class="image-highlight">
                          <img [src]="item.image_source" class="image-preview-product" style="width: 80px; height: 80px"
                            [class.active]="isActive === i || newActive === i" (click)="asset_selector(item, i)" />

                        </ng-template>
                      </ng-container>

                      <!-----------video--------->

                      <ng-container *ngFor="let item of ImageVideoPreview">
                        <ng-template carouselSlide>
                          <div (click)="videoPreview(item)">
                            <iframe style="pointer-events: none" [src]="item.safeLink" width="80" height="80"
                              title="YouTube video player" frameborder="0"
                              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen></iframe>
                          </div>
                        </ng-template>
                      </ng-container>
                    </owl-carousel-o>
                  </div>
                  <div class="rounder-corner-nav" *ngIf="config.title==='Vimpro'&& newProductDetails.product_type=='Simple'">
                    <owl-carousel-o [options]="customOptions">
                      <!------------------image---------------->

                      <ng-container *ngFor="let item of imageAssets; let i = index">
                        <ng-template carouselSlide *ngIf="item.image_source != ''" class="image-highlight">
                          <img [src]="item.image_source" class="image-preview-product" style="width: 80px; height: 80px"
                            [class.active]="isActive === i || newActive === i" (click)="imagePreview(item, i)" />

                        </ng-template>
                      </ng-container>

                      <!-----------video--------->

                      <ng-container *ngFor="let item of ImageVideoPreview">
                        <ng-template carouselSlide>
                          <div (click)="videoPreview(item)">
                            <iframe style="pointer-events: none" [src]="item.safeLink" width="80" height="80"
                              title="YouTube video player" frameborder="0"
                              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen></iframe>
                          </div>
                        </ng-template>
                      </ng-container>
                    </owl-carousel-o>
                  </div>
                  <div class="rounder-corner-nav" *ngIf="config.title!=='Vimpro' && config.title!=='SpecialWires' && config.title!=='Carience' && config.title!=='LinenRaj' && config.title!=='Vistas' &&  config.title!=='ShubhCards'">
                    <owl-carousel-o [options]="customOptions">
                      <!------------------image---------------->

                      <ng-container *ngFor="let item of imageAssets; let i = index"     >
                        <ng-template carouselSlide *ngIf="item.image_source != ''" class="image-highlight">
                          <img  [src]="item.image_source" class="image-preview-product" style="width: 80px; height: 80px"
                            [class.active]="isActive === i || newActive === i" (click)="imagePreview(item, i)" />

                        </ng-template>
                        
                      </ng-container>
                      <ng-container *ngIf="productViewVideo===true">
                        <ng-template carouselSlide class="image-highlight">
                          <img  src="assets/images/bestgifts/playimage.jpg" class="image-preview-product" style="width: 80px; height: 80px"
                           (click)="productVideoPreview()" />

                        </ng-template>
                        
                      </ng-container>
                     
                      <!-----------video--------->

                      <ng-container *ngFor="let item of ImageVideoPreview">
                        <ng-template carouselSlide>
                          <div (click)="videoPreview(item)">
                            <iframe style="pointer-events: none" [src]="item.safeLink" width="80" height="80"
                              title="YouTube video player" frameborder="0"
                              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen></iframe>
                          </div>
                        </ng-template>
                      </ng-container>
                    </owl-carousel-o>
                  </div>
                  <div class="rounder-corner-nav" *ngIf="config.title=='Carience'">
                    <owl-carousel-o [options]="customOptions">
                      <!------------------image---------------->

                      <ng-container  *ngFor="let img_colour of product.variant.option_values[current_index].child[child_index].assets;let i = index"     >
                        <ng-template carouselSlide ngIf="img_colour.is_default" class="image-highlight">
                          <img  [src]="img_colour.image_source" class="image-preview-product" style="width: 80px; height: 80px"
                          [class.active]="isActive === i || newActive === i" (click)="imagePreview(img_colour, i)"  />

                        </ng-template>
                      </ng-container>
                      
                     
                      <!-----------video--------->

                      <ng-container *ngFor="let item of ImageVideoPreview">
                        <ng-template carouselSlide>
                          <div (click)="videoPreview(item)">
                            <iframe style="pointer-events: none" [src]="item.safeLink" width="80" height="80"
                              title="YouTube video player" frameborder="0"
                              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen></iframe>
                          </div>
                        </ng-template>
                      </ng-container>
                    </owl-carousel-o>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
          <div *ngIf="config.title=='LinenRaj'">
          <div *ngFor="let item of newProductDetails.assets; let i = index" style="width: fit-content">
            <div *ngIf=" newProductDetails.product_type=='Variable'" style="width: fit-content">

            <img [src]="item.image_source" style="max-width: 200px;" />
            </div>
          </div>
        </div>
        </div>
      </div>
      <!-------------->
      <!--bread crumbs-->

      <div class="col-sm-6 example detail-align pro_detail kat_height" id="size" *ngIf="newProductDetails"
        style="overflow-y: hidden; height: 100%; ">
        <div class="titleCase-product"  *ngIf="config.title != 'ShubhCards' && config.title !== 'Taazah'">
          <!-- <h2 class="text-primary" id="titleProduct">Product Detail</h2> -->
          <div class="breadCrumb-productTitle">
            <span  *ngIf="config.title !== 'Accel'"class="home-breadcrumb"  id="breadCrumbProductDetails" routerLink="">Home</span>
            <span  *ngIf="config.title == 'Accel'"class="home-breadcrumb" style="font-size: 16px;"  id="breadCrumbProductDetails" routerLink="">Home</span>
            <span *ngIf="config.title == 'EarthyWorthy'" class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="productListing()">
              <i class="px-2" id="breadCrumbProductDetails">/</i>Products</span>
            <span *ngIf="config.title != 'EarthyWorthy'&& config.title != 'Beaubelle' && config.title != 'Accel' &&  config.title !== 'Kubendran'&& config.title != 'Mayan' && config.title != 'BestGifts'&& config.title != 'Karupattiraja' && config.title != 'SpecialWires' && config.title != 'Babys Pride' && config.title != 'LushNGreen' && config.title != 'KatbookStore' && config.title != 'Schift Cosmetics'" class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="productListing()">
              <i class="px-2" id="breadCrumbProductDetails">/</i>Products</span>
              <span *ngIf="config.title == 'Accel'"  style="font-size: 16px;" id="breadCrumbProductDetails"(click)="productListing()">
                <i class="px-2" id="breadCrumbProductDetails">/</i>Courses</span>
              <span *ngIf="config.title == 'Mayan' || config.title == 'BestGifts'" class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="productListing()">
                <i class="px-2" id="breadCrumbProductDetails">/</i>Shop</span>
                <span *ngIf="config.title == 'Schift Cosmetics' && bcrumbs_category !== 'Products'" class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="productListingSchift(bcrumbs_category)">
                  <i class="px-2" id="breadCrumbProductDetails">/</i>{{bcrumbs_category}}</span>
                  <span *ngIf="config.title == 'Schift Cosmetics' && bcrumbs_category === 'Products'" class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="productListingSchift(product.categories[0].categories)">
                    <i class="px-2" id="breadCrumbProductDetails">/</i>{{newProductDetails.categories[0].categories}}</span>
              <span *ngIf="config.title == 'Beaubelle'" class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="gobacktobrand(newProductDetails.brand.name)">
                <i class="px-2" id="breadCrumbProductDetails">/</i>{{newProductDetails.brand.name}}</span>
                <!-- <span *ngIf="config.title == 'Mayan'&& bcrumbs_category " class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="gobacktoCategory(bcrumbs_category)">
                  <i class="px-2" id="breadCrumbProductDetails">/</i>{{bcrumbs_category}}</span> -->
                <span *ngIf="config.title == 'Kubendran' ||config.title == 'ShubhCards'||config.title == 'SpecialWires'||config.title == 'Babys Pride'||config.title == 'LushNGreen'||config.title == 'Karupattiraja'||config.title == 'KatbookStore'" class="customer-breadcrumb" id="breadCrumbProductDetails" (click)="backToCategory(product.categories[0].categories)">
                  <i class="px-2" id="breadCrumbProductDetails" >/</i>{{product.categories[0].categories|titlecase}}</span>
                  <span *ngIf="config.title == 'BombayHardware'" class="customer-breadcrumb" id="breadCrumbProductDetails" (click)="backToCategory(product.categorynames[0].name)">
                    <i class="px-2" id="breadCrumbProductDetails" >/</i>{{product.categorynames[0].name|titlecase}}</span>

                  <span *ngIf="config.title == 'Vimpro'" class="customer-breadcrumb" id="breadCrumbProductDetails" (click)="backToCategory(product.categories[0].categories)">
                    <i class="px-2" id="breadCrumbProductDetails" >/</i>{{product.categories[0].categories|titlecase}}</span>
                    
                  <span *ngIf="config.title == 'AvonSeals' || config.title == 'Karupattiraja'" class="customer-breadcrumb" id="breadCrumbProductDetails" (click)="backToList()">
                    <i class="px-2" id="breadCrumbProductDetails" >/</i>{{product.name|titlecase}}</span>
                    <span *ngIf="config.title == 'SpecialWires'" class="customer-breadcrumb" id="breadCrumbProductDetails">
                      <i class="px-2" id="breadCrumbProductDetails" >/</i>{{product.name|titlecase}}</span>
                    <span *ngIf="config.title == 'Vistas'" class="customer-breadcrumb" id="breadCrumbProductDetails">
                      <i class="px-2" id="breadCrumbProductDetails" >/</i>{{newProductDetails.name}}</span>
            <span *ngIf="config.title != 'BombayHardware'&&config.title != 'Vimpro'&&config.title != 'Kubendran'&&config.title != 'Vistas' && config.title != 'Carience' && config.title != 'Accel'&&config.title != 'AvonSeals'&&config.title != 'Karupattiraja'&&config.title != 'SpecialWires'" id="breadCrumbProductDetails"><i class="px-2" id="breadCrumbProductDetails">/</i>Product Details</span>
            <span *ngIf="config.title == 'Accel'"><i class="px-2" id="breadCrumbProductDetails">/</i>Course Details</span>
            <span *ngIf="config.title == 'Carience'" style="font-size: .8rem;"><i class="px-2" id="breadCrumbProductDetails">/</i>{{product.categories[0].categories|titlecase}}</span>
          </div>
        </div>
        <div>
          <img [src]="mainImage" class="detail-preview mobile-only" *ngIf="config.title === 'Schift Cosmetics'" />
          <!----------------product title price-------------------->
          <div class="mobile-only" *ngIf="config.title == 'Carience'">
          <div class="detail-preview mobile-only" *ngFor="let img_colour of product.variant.option_values[current_index].child;let i = index" class="">
            <div *ngIf="img_colour.is_default">
              <img [src]="img_colour.assets[0].image_source" class="detail-preview mobile-only"  id="img-list" 
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="carience-image-container" />
            </div>
        </div>
      </div>
      <div class="mobile-only" *ngIf="config.title == 'SpecialWires'&&newProductDetails.product_type=='Variable'">
        <h2 class="product-name" id="prodName" style="font-weight: bolder" *ngIf="groups[0].fields[0].visibility">
          <div style="font-weight: bolder;    font-size: 1.6rem;
          ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div></h2>


        <div  *ngIf="current_index==-1" class="detail-preview mobile-only">
            <img [src]="product.variant.option_values[0].child[0].assets[0].image_source" class="detail-preview mobile-only"  id="img-list" 
              onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" style="width: 100%;" alt="{{ product.name }}"
              class="carience-image-container" />
      </div>
      <div *ngIf="current_index!=-1">
      <!-- <div  class="detail-preview mobile-only" *ngFor="let img_colour of product.variant.option_values[current_index].child;let i = index">
        <div *ngIf="img_colour.is_default"> -->
          <img [src]="product.variant.option_values[current_index].child[child_index].assets[0].image_source" class="detail-preview mobile-only"  id="img-list" 
            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" style="width: 100%;" alt="{{ product.name }}"
            class="carience-image-container" />
        <!-- </div>
    </div> -->
  </div>
    </div>
    <div class="mobile-only" *ngIf="config.title == 'LinenRaj'">
      <h2 class="product-name" id="prodName" style="font-weight: bolder" *ngIf="groups[0].fields[0].visibility">
        <div style="font-weight: bolder;    font-size: 1.6rem;
        ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div></h2>


<div class="detail-preview mobile-only" *ngFor="let img_colour of product.variant.option_values;let i = index" class="">
  <div *ngIf="img_colour.is_default">
    <img [src]="img_colour.assets[0].image_source" class="detail-preview mobile-only"  id="img-list" 
      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" style="width: 100%!important;
      height: 100%!important;" alt="{{ product.name }}"
      class="carience-image-container-1" />
  </div>
</div>
  </div>
      <div class="mobile-only" *ngIf="config.title == 'Vimpro' && newProductDetails.product_type=='Variable'&&newProductDetails.variant.variant_child">
        <div class="detail-preview mobile-only" *ngFor="let img_colour of product.variant.option_values[current_index].child;let i = index" class="">
          <div *ngIf="img_colour.is_default">
            <img [src]="img_colour.assets[0].image_source" class="detail-preview mobile-only"  id="img-list" 
              onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
              class="carience-image-container-1" />
          </div>
      </div>
    </div>
  <div class="mobile-only" *ngIf="config.title == 'Vimpro' && newProductDetails.product_type=='Variable'&&!newProductDetails.variant.variant_child">
      <div class="detail-preview mobile-only" class="">
        <div >
          <h2 class="product-name" id="prodName" style="font-weight: bolder!important;font-size: 1.6rem!important;" *ngIf="groups[0].fields[0].visibility && config.title == 'Vimpro'">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}}	</h2>
          <img  [src]="newProductDetails.variant.option_values[current_index].assets[0].image_source" class="detail-preview mobile-only"  id="img-list" 
            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
            class="carience-image-container-1" />
        </div>
    </div>
  </div>
  <div class="mobile-only" *ngIf="config.title == 'Vimpro' && newProductDetails.product_type=='Simple'">
    <div class="detail-preview mobile-only" class="">
      <div >
        <h2 class="product-name" id="prodName" style="font-weight: bolder!important;font-size: 1.6rem!important;" *ngIf="groups[0].fields[0].visibility && config.title == 'Vimpro'">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}}	</h2>
        <img  [src]="newProductDetails.assets[0].image_source" class="detail-preview mobile-only"  id="img-list" 
          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
          class="carience-image-container-1" />
      </div>
  </div>
</div>

<div class="mobile-only" *ngIf="config.title == 'SpecialWires' && newProductDetails.product_type=='Simple'">
  <div class="detail-preview mobile-only" class="">
    <div >
      <h2 class="product-name" id="prodName" style="font-weight: bolder!important;font-size: 1.6rem!important;" *ngIf="groups[0].fields[0].visibility && config.title == 'SpecialWires'">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}}	</h2>
      <img [src]="newProductDetails.assets[0].image_source" class="detail-preview mobile-only"  id="img-list" 
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
        class="carience-image-container-1 special-simple-image" />
    </div>
</div>
</div>

          <div class="col-left" *ngIf="groups[0].showondetailpage">
            <div class="product-detail">

              <!-- <h2 class="product-name" id="prodName" style="font-weight: bolder;color: #0095da;" *ngIf="config.title === 'SpecialWires'">STAR ER70S-6	</h2> -->
              <h1 class="product-name desktop-only" id="prodName" style="font-weight: bolder!important;font-size: 1.6rem!important;" *ngIf="groups[0].fields[0].visibility && config.title == 'Vimpro'">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}}	</h1>
              <!-- <div
                  *ngIf="config.title === 'SpecialWires'" style="color: black; font-size: 14px;font-family: 'proxima-regular','sans-serif'!important;">
                  star brand highly used in automotive component manufacturing industry,construction,fabrication,thin sheet metal welding ,pipe welding and pressure vessel fabrication industries
                </div> -->
                <h2 class="product-name desktop-only" id="prodName" style="font-weight: bolder;" *ngIf="groups[0].fields[0].visibility && config.title == 'SpecialWires'">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}}	</h2>
                <h2 class="product-name desktop-only" id="prodName" style="font-weight: bolder; margin-bottom: 20px !important;" *ngIf="groups[0].fields[0].visibility && config.title === 'Babys Pride'">
                  <h1 style="font-weight: 500;font-size: 18px;font-family: system-ui; margin-bottom: 20px; text-transform: uppercase; color: gray;
                  ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </h1>
                  <div style="display: flex;"> 
                    <div class="col-right deera-price-row" style="display: flex;">
                  <div style=" display:flex;justify-content: center;font-weight: 500;height: 21px;" class="product-list-price2-baby" >
                    ₹{{product.variant.option_values[0].pricing.raw.price}}.00
                   </div>
                   
                   <div style="font-weight: 300;font-size: 12px;margin-top: 5px;height: 21px;margin-left: 5px;" *ngIf="config.title === 'Babys Pride'">(Inclusive of all taxes)</div>
                    </div></div>
                    <div *ngIf="config.title === 'Babys Pride'" style="font-size: 15px !important;text-decoration: line-through;color: #8080806e !important;">₹{{product.variant.option_values[0].pricing.raw.msrp}}.00</div>
                    </h2>
                    <!-- <h2 class="product-name desktop-only" id="prodName" style="font-weight: bolder; margin-bottom: 20px !important; margin-top:12%;" *ngIf="groups[0].fields[0].visibility && config.title === 'Taazah'">
                      <div style="font-size: 18px;font-family: system-ui; margin-bottom: 20px; color: rgb(27 81 164);
                      ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div>
  
                      <div style="display: flex;justify-content: space-between;width: 50%;"> <p class="product-det">Product No: {{product.id}}</p>
                       <p class="product-det" *ngIf="product.stock_status == 'Available'">{{product.stock_status}} (In Stock)</p> 
                      </div>
                        </h2> -->
                <h2 class="product-name desktop-only" id="prodName" style="font-weight: bolder; margin-bottom: 20px !important;" *ngIf="groups[0].fields[0].visibility && config.title === 'LushNGreen'">
                <div style="font-weight: 500;font-size: 18px;font-family: system-ui; margin-bottom: 20px; text-transform: uppercase; color: black;
                ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div>
                <div style="display: flex;"> 
                  <div class="col-right deera-price-row" style="display: flex;">
                <div style=" display:flex;justify-content: center;font-weight: 500;height: 21px;" class="product-list-price2-baby" >
                  ₹{{product.variant.option_values[0].child[0].pricing.raw.price}}.00
                 </div>
                 <div style="font-size: 13px !important;margin-top: 3px;margin-left: 7px; text-decoration: line-through;color: #8080806e !important;">₹{{product.variant.option_values[0].child[0].pricing.raw.msrp}}.00</div>
                  </div></div>
                  <div style="display: inline" *ngIf="groups[3].showondetailpage" class="deera-price-row1" >
                    <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
                      style="font-size: 15px !important;color: #6a975c !important;"></span>
                    <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
                      style="font-size: 15px !important;color: #6a975c !important;"></span>
                    <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
                      style="font-size: 15px !important;color: #6a975c !important;"></span>
                    <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
                      style="font-size: 15px !important;color: #6a975c !important;"></span>
                    <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
                      style="font-size: 15px !important;color: #6a975c !important;"></span>
                  
                    <a style="font-size: small !important; margin-left: 5px;" routerLink="/product-review/{{
                        newProductDetails.id
                      }}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} customer reviews</a>
                  </div>
                  
                  </h2>
                  <h2 class="product-name desktop-only" id="prodName" style="font-weight: bolder; margin-bottom: 20px !important;" *ngIf="groups[0].fields[0].visibility && config.title === 'KatbookStore'">
                    <div style="font-weight: 500;font-size: 30px;font-family: system-ui; margin-bottom: 7px; text-transform: uppercase; color: black;
                    ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div>
                    
                    <div class="breadcurmb">
                      <div class="normalSize specialsize" [innerHTML]="content1" style="font-size: 12px !important; font-weight: 400; color: rgb(86, 86, 86); font-family: system-ui;line-height: 30px;">
                        <hr />
                      </div>
                    </div>
                    <div class="col-right" id="simple" style="margin-top: 20px;" >
                      <div class="col-right">
                        <p class="sizeText" style="font-weight: 500;font-size: 14px;font-family: system-ui;">{{ variantName }}</p>
                      </div>
                      <div style=" width: 100%;">
                      <div class="col-right btn-group"  *ngFor="let items of product.variant.option_values; let j = index" style="width: 100%;">
                        <input type="radio" name=items.id
                                      class="choisebuttonbaby1" (click)="onConfirm1(items,items.id,j)" value="items.id" [checked]="items.is_default == true">
                                      <p style="font-size: 15px;font-weight: 500;border-radius: 30px;padding: 2.5% 5% 2.5% 2%;color: rgb(75, 75, 75); line-height: 2;" (click)="onConfirm1(items,items.id,j)" [class.active]="items.is_default" >{{ items.option }}</p>
                                    
                        <hr />
                      </div>
                    </div>
                    </div>
                    <div style="display: flex;"> 
                      <div class="col-right deera-price-row" style="display: flex;">
                    <div  *ngIf="current_index==0" style=" display:flex;justify-content: center;font-weight: 500;height: 21px;font-size: 30px; color: #23a6f0;" class="product-list-price2-baby" >
                      ₹{{product.variant.option_values[0].pricing.raw.price}}.00
                     </div>
                     <div  *ngIf="current_index!=0" style=" display:flex;justify-content: center;font-weight: 500;height: 21px;font-size: 30px; color: #23a6f0;" class="product-list-price2-baby" >
                      ₹{{product.variant.option_values[current_index].pricing.raw.price}}.00
                     </div>
                     <!-- <div style="font-size: 24px !important;margin-top: 5px;margin-left: 20px; text-decoration: line-through;color: #8080806e !important;font-weight: 400;">₹{{product.pricing.raw.msrp}}.00</div> -->
                      </div></div>
                      <!-- <div style="display: inline" *ngIf="groups[3].showondetailpage" class="deera-price-row1" >
                        <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: #6a975c !important;"></span>
                        <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: #6a975c !important;"></span>
                        <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: #6a975c !important;"></span>
                        <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: #6a975c !important;"></span>
                        <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: #6a975c !important;"></span>
                      
                        <a style="font-size: small !important; margin-left: 5px;" routerLink="/product-review/{{
                            newProductDetails.id
                          }}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} customer reviews</a>
                      </div> -->
                      
                      </h2>
              <h2 class="product-name" id="prodName" style="font-weight: bolder" *ngIf="groups[0].fields[0].visibility">
                <!-- {{newProductDetails.name | titlecase }} -->
                <div  *ngIf="config.title!='Vimpro'  && config.title !== 'SpecialWires' && config.title !== 'Taazah' && config.title !== 'Schift Cosmetics'  && config.title !== 'ShubhCards' && config.title !== 'LushNGreen' && config.title !== 'KatbookStore' && config.title !== 'Babys Pride' && config.title !== 'Vistas' && config.title !== 'SriSenbaga'" style="font-weight: bolder;    font-size: 1.6rem;
                ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div>
                <!-- <div  *ngIf="config.title === 'Babys Pride'" style="font-weight: 500;font-size: 18px;font-family: system-ui; margin-bottom: 20px;
                ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div> -->
                <div  *ngIf="config.title == 'Vistas'" style="font-weight: bolder;    font-size: 1.6rem;
                ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo)}} </div>
                <div  *ngIf="config.title == 'Schift Cosmetics'" style="font-family: Trebuchet MS, sans-serif !important; font-weight: bold;font-size: 1.6rem;color: black;
                ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo)}} </div>
                <div  *ngIf="config.title == 'ShubhCards'" style="font-size: 1.6rem;color: #fe6602;
                ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo)| titlecase }}</div>
                  <div  *ngIf="config.title == 'SriSenbaga'" style="font-size: 1.6rem;color: #27266a;
                ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo)| titlecase }}</div>
                
                <div class="col-right">
                  <div class="price-wrapper">
                    
                
                    
                    

<!-- old -->
<div *ngIf=" config.title !== 'LushNGreen' && config.title !== 'Schift Cosmetics' && config.title !== 'KatbookStore' && product.product_type=='Variable' && config.title !== 'AvonSeals' && config.title !== 'Babys Pride' && config.title !== 'Taazah'" style="display: flex;"> 
  <div class="col-right deera-price-row" *ngFor="let items of product.variant.option_values; let j = index" style="display: flex;">
    <div *ngIf="items.is_default && config.title !== 'Babys Pride' && config.title !== 'Vimpro'" style=" display:flex;justify-content: center;font-weight: 500; margin-bottom: 10px;" class="product-list-price1" >
      ₹{{items.pricing.raw.price}}
     </div>
     <!-- <div *ngIf="items.is_default && config.title === 'Babys Pride'" style=" display:flex;justify-content: center;font-weight: 500; margin-bottom: 10px;height: 21px;" class="product-list-price2-baby" >
      ₹{{items.pricing.raw.price}}.00
     </div><div style="font-weight: 300;font-size: 14px;height: 21px;" *ngIf="items.is_default && config.title === 'Babys Pride'">(Inclusive of all taxes)</div> -->
     <span *ngIf="items.is_default && config.title !== 'Babys Pride' && config.title !== 'Vimpro'" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;" class="deera-strike">₹{{ items.pricing.raw.msrp }}</span>
  <span *ngIf="items.is_default && config.title !== 'Babys Pride' && config.title !== 'Vimpro'" style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;" class="deera-strike">₹{{items.pricing.raw.price / items.unit| number : "1.2-2"}}/piece</span>
</div>
<div style="display: inline" *ngIf="groups[3].showondetailpage && config.title !== 'Babys Pride' && config.title !== 'Vimpro'" class="deera-price-row1" >
  <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
    style="font-size: 15px !important;color: orange !important;"></span>
  <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
    style="font-size: 15px !important;color: orange !important;"></span>
  <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
    style="font-size: 15px !important;color: orange !important;"></span>
  <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
    style="font-size: 15px !important;color: orange !important;"></span>
  <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
    style="font-size: 15px !important;color: orange !important;"></span>

  <a style="font-size: small !important;margin-left: 7px;" routerLink="/product-review/{{
      newProductDetails.id
    }}" *ngIf="groups[3].fields[1].visibility">{{ total_rating }} customer reviews</a>
</div>
</div>
                    <h4 class="priceRange"
                      *ngIf="newProductDetails.product_type == 'Variable'&& config.title !== 'Carience' && config.title !== 'Vimpro' && config.title !== 'SpecialWires' && config.title !== 'Accel' && config.title !=='LushNGreen' && config.title !=='Babys Pride' && config.title !=='Deera' && config.title !== 'KatbookStore' && config.title !== 'Taazah'">
                      <span *ngIf="config.title !== 'AvonSeals'">  {{config.title === "LuckMe" || config.title === "Murgasen" ? "SR " : "₹" }}
                        {{ newProductDetails.pricing.raw.price_range_from
                        }}-{{newProductDetails.pricing.raw.price_range_to}}&nbsp;</span>
                     

                      <!-----rating and reviews------------------>
                      <div style="display: inline" *ngIf="groups[3].showondetailpage">
                        <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>

                        <a style="font-size: small !important;margin-left: 1%;" routerLink="/product-review/{{
                            newProductDetails.id
                          }}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} customer reviews</a>
                        <!-----------mini review----->
                        <!-------->
                      </div>
                    </h4>
                    <a
                      *ngIf="config.title !== 'BombayHardware' && config.title !== 'Mayan'  && config.title !== 'Vistas' && config.title !== 'Accel' && config.title !== 'Taazah' && newProductDetails.pricing.raw.price!==0 ">
                      <!-- <h4 class="priceRange" *ngIf="newProductDetails.product_type == 'Simple' || newProductDetails.product_type == 'Variation'">{{config.title === 'LuckMe' || config.title === 'Murgasen' ? 'SR ' : '₹'}} {{newProductDetails.pricing.raw.price }}&nbsp; -->
                      <h4 class="priceRange schift-price-detail price-color padding-top-bottom" *ngIf="
                          newProductDetails.product_type == 'Simple' ||
                          newProductDetails.product_type == 'Variation'
                        ">
                        {{
                        config.title === "LuckMe" ||
                        config.title === "Murgasen"
                        ? "SR "
                        : "₹"
                        }}
                        {{ newProductDetails.pricing.raw.price }}
                        <div *ngIf="config.title === 'Babys Pride'" style="display: inline;">
                          <span
                            style="font-size: 16px !important;text-decoration: line-through;color: grey!important;margin-left:7px;">₹{{newProductDetails.pricing.raw.msrp}}</span>

                        </div>
                        <!-- <span *ngIf="config.title === 'Deera'" style="font-size: 16px !important;color: grey!important;">(incl of all taxes)</span>  -->
                        <!-- <span *ngIf="config.title === 'Babys Pride'"
                          style="font-size: 16px !important;color: grey!important;margin-left:5px;">-
                          ₹{{perPeice}}/piece</span> -->
                        <div *ngIf="config.title === 'Deera'" style="display: inline;">
                          <span
                            style="font-size: 16px !important;text-decoration: line-through;color: grey!important;margin-left:7px;">₹{{newProductDetails.pricing.raw.msrp}}</span>

                        </div>
                        <!-- <span *ngIf="config.title === 'Deera'" style="font-size: 16px !important;color: grey!important;">(incl of all taxes)</span>  -->
                        <span *ngIf="config.title === 'Deera'"
                          style="font-size: 16px !important;color: grey!important;margin-left:5px;">-
                          ₹{{perPeice}}/piece</span>

                        <!-----rating and reviews------------------>
                        <div style="display: inline; margin-left: 8px !important" *ngIf="groups[3].showondetailpage && config.title !== 'Schift Cosmetics'">
                          <!-- <ngb-rating [max]="5"  [(rate)]="currentRating" [readonly]="true"></ngb-rating> -->
                          <span [class]="
                              currentRating >= 1
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 2
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 3
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 4
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 5
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>

                          <a style="font-size: small !important; cursor: pointer;margin-left: 1%;" (click)="reviewredirect()" *ngIf="groups[3].fields[1].visibility && config.title !== 'Schift Cosmetics' " class="rating-color">{{ reviews }} customer reviews</a>

                          <a style="font-size: small !important; cursor: pointer;margin-left: 1%;" (click)="reviewredirect()" *ngIf="groups[3].fields[1].visibility && config.title === 'Schift Cosmetics'">{{ total_rating }} customer reviews</a>
                          
                        </div>
                        <div style="display: inline; margin-left: 8px !important" *ngIf="groups[3].showondetailpage && config.title == 'Schift Cosmetics'">
                          <!-- <ngb-rating [max]="5"  [(rate)]="currentRating" [readonly]="true"></ngb-rating> -->
                          <span [class]="
                          product_rating >= 0.6
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                          product_rating >= 1.6
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                          product_rating >= 2.6
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                          product_rating >= 3.6
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                          product_rating >= 4.6
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>

                          <a style="font-size: small !important; cursor: pointer;" (click)="reviewredirect()" *ngIf="groups[3].fields[1].visibility && config.title !== 'Schift Cosmetics' ">{{ reviews }} customer reviews</a>

                          <a style="font-size: small !important; cursor: pointer;" (click)="reviewredirect()" *ngIf="groups[3].fields[1].visibility && config.title === 'Schift Cosmetics'">{{ total_rating }} customer reviews</a>
                          
                        </div>
                      </h4>
                    </a>
                    <a
                      *ngIf="config.title == 'Vistas' && newProductDetails.pricing.raw.price!==0 " class="desktop-only">
                      <!-- <h4 class="priceRange" *ngIf="newProductDetails.product_type == 'Simple' || newProductDetails.product_type == 'Variation'">{{config.title === 'LuckMe' || config.title === 'Murgasen' ? 'SR ' : '₹'}} {{newProductDetails.pricing.raw.price }}&nbsp; -->
                      <h4 class="priceRange" *ngIf="
                          newProductDetails.product_type == 'Simple' ||
                          newProductDetails.product_type == 'Variation'
                        ">
                        {{ "₹" }}
                        {{ newProductDetails.pricing.raw.price }}<span style="font-size: 10px;">(per Ream)</span>
                        <!-----rating and reviews------------------>
                        <div style="display: inline; margin-left: 8px !important" *ngIf="groups[3].showondetailpage">
                          <!-- <ngb-rating [max]="5"  [(rate)]="currentRating" [readonly]="true"></ngb-rating> -->
                          <span [class]="
                              currentRating >= 1
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 2
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 3
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 4
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 5
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>

                          <a style="font-size: small !important;margin-left: 1%;" routerLink="/product-review/{{
                              newProductDetails.id
                            }}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} customer reviews</a>
                        </div>
                      </h4>
                    </a>
                    <!-- mayan price -->
                    <a *ngIf=" config.title == 'Mayan' && newProductDetails.pricing.raw.price!==0 ">
                      <!-- <h4 class="priceRange" *ngIf="newProductDetails.product_type == 'Simple' || newProductDetails.product_type == 'Variation'">{{config.title === 'LuckMe' || config.title === 'Murgasen' ? 'SR ' : '₹'}} {{newProductDetails.pricing.raw.price }}&nbsp; -->
                      <h4 class="priceRange" *ngIf="
                          newProductDetails.product_type == 'Simple' ||
                          newProductDetails.product_type == 'Variation'
                        ">

                        ₹{{ newProductDetails.pricing.raw.price }}


                        <!-- <span *ngIf="config.title === 'Deera'" style="font-size: 16px !important;color: grey!important;">(incl of all taxes)</span>  -->

                        <!-----rating and reviews------------------>
                        <div style="display: inline; margin-left: 8px !important" *ngIf="groups[3].showondetailpage">
                          <!-- <ngb-rating [max]="5"  [(rate)]="currentRating" [readonly]="true"></ngb-rating> -->
                          <span [class]="
                              currentRating >= 1
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 2
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 3
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 4
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 5
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>

                          <a style="font-size: small !important; margin-left: 3px;" routerLink="/product-review/{{
                              newProductDetails.id
                            }}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} customer reviews</a>
                        </div>
                      </h4>
                    </a>
                    <a *ngIf="!newProductDetails.pricing.raw.price && config.title == 'Mayan'  ">
                      <!-- <h4 class="priceRange" *ngIf="newProductDetails.product_type == 'Simple' || newProductDetails.product_type == 'Variation'">{{config.title === 'LuckMe' || config.title === 'Murgasen' ? 'SR ' : '₹'}} {{newProductDetails.pricing.raw.price }}&nbsp; -->
                      <h4 class="priceRange" *ngIf="
                          newProductDetails.product_type == 'Simple' ||
                          newProductDetails.product_type == 'Variation'
                        ">

                        Out of Stock


                        <!-- <span *ngIf="config.title === 'Deera'" style="font-size: 16px !important;color: grey!important;">(incl of all taxes)</span>  -->

                        <!-----rating and reviews------------------>
                        <div style="display: inline; margin-left: 8px !important" *ngIf="groups[3].showondetailpage">
                          <!-- <ngb-rating [max]="5"  [(rate)]="currentRating" [readonly]="true"></ngb-rating> -->
                          <span [class]="
                              currentRating >= 1
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 2
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 3
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 4
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>
                          <span [class]="
                              currentRating >= 5
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: orange !important;
                            "></span>

                          <a style="font-size: small !important;margin-left: 1%;" routerLink="/product-review/{{
                              newProductDetails.id
                            }}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} customer reviews</a>
                        </div>
                      </h4>
                    </a>


                    
                    <div *ngIf="config.title=='Carience'">
                      <!-- <div style="display: inline;position: relative;top:10px;" *ngIf="groups[3].showondetailpage">
                        <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>

                        <a style="font-size: small !important" *ngIf="groups[3].fields[1].visibility">{{ reviews }}
                          </a>
                      
                      </div> -->




                      <div *ngFor="let price of product.variant.option_values[current_index].child;let i = index"
                        class="">
                        <div *ngIf="price.is_default">
                          <div style="display:flex;margin-top: 20px;">
                            <div class="carience-listing-price">
                              ₹{{price.pricing.raw.price}}

                            </div>
                           
                          </div>
                            <div style="display:flex;">
                          <div class="prod-detail-strike">MRP ₹{{price.pricing.raw.sale_price}}
                          </div>
                          <div style="font-size: 12px!important;color: grey !important;margin-top: 6px;margin-left: 1%;">(inclusive of
                            all taxes)</div></div>
                          <div style="display:flex;margin-top: 6px;">
                            <div class="carience-discount-detail">{{price.pricing.raw.discount_percentage}}% off
                            </div>
                            <div style=" font-size: 12px;color:#42bf42;margin-left:7px;margin-top: 2px">You Save</div>
                            <div class="carience-discount-percent">
                              {{price.pricing.raw.discount_amount}}
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div *ngIf="config.title=='Vimpro' && newProductDetails.product_type=='Variable'&&newProductDetails.variant.variant_child">
                      <div style="display: inline;position: relative;top:10px;" *ngIf="groups[3].showondetailpage">
                        <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>

                        <a style="font-size: small !important" *ngIf="groups[3].fields[1].visibility">{{ reviews }}
                          reviews</a>
                        <!-----------mini review----->
                        <!-------->
                      </div>




                      <div *ngFor="let price of product.variant.option_values[current_index].child;let i = index"
                        class="">
                        <div *ngIf="price.is_default">
                          <div style="display:flex;margin-top: 20px;" *ngIf="config.title !== 'Vimpro'">
                            <div class="carience-listing-price">
                              ₹{{price.pricing.raw.price}}

                            </div>
                            <div class="prod-detail-strike">
                              MRP ₹{{price.pricing.raw.sale_price}}
                            </div>
                            <div style="font-size: 10px!important;color: grey !important;margin-top: 5px;">(taxes extra)</div>
                          </div>
                          <div style="display:flex;margin-top: 20px;" *ngIf="config.title === 'Vimpro'">
                            <div class="carience-listing-price">
                              ₹{{price.pricing.raw.sale_price}}

                            </div>
                            <div class="prod-detail-strike">
                              MRP ₹{{price.pricing.raw.price}}
                            </div>
                            <div style="font-size: 10px!important;color: grey !important;margin-top: 5px;">(taxes extra)</div>
                          </div>
                          <div style="display:flex;margin-top: 10px;">
                            <div class="carience-discount-detail">
                              {{price.pricing.raw.discount_percentage}}% off
                            </div>
                            <div style=" font-size: 12px;color:black;margin-left:7px" *ngIf="config.title!=='Vimpro'">You SAVE</div>
                            <div class="carience-discount-percent" *ngIf="config.title!=='Vimpro'">
                              {{price.pricing.raw.discount_amount}}
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div *ngIf="config.title=='Vimpro' && newProductDetails.product_type=='Simple'">
                      <div style="display: inline;position: relative;top:10px;" *ngIf="groups[3].showondetailpage">
                        <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>

                        <a style="font-size: small !important" *ngIf="groups[3].fields[1].visibility">{{ reviews }}
                          reviews</a>
                        <!-----------mini review----->
                        <!-------->
                      </div>
                    </div>
                    <div *ngIf="config.title=='Vimpro' && newProductDetails.product_type=='Variable'&&!newProductDetails.variant.variant_child">
                      <div style="display: inline;position: relative;top:10px;" *ngIf="groups[3].showondetailpage">
                        <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>
                        <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
                          style="font-size: 15px !important;color: orange !important;"></span>

                        <a style="font-size: small !important" *ngIf="groups[3].fields[1].visibility">{{ reviews }}
                          reviews</a>
                        <!-----------mini review----->
                        <!-------->
                      </div>




                      <div
                        class="">
                        <div>
                          <div style="display:flex;margin-top: 20px;">
                            <div class="carience-listing-price">
                              ₹{{product.variant.option_values[current_index].pricing.raw.price}}

                            </div>
                            <!-- <div class="prod-detail-strike">
                              MRP ₹{{product.variant.option_values[current_index].pricing.raw.sale_price!=null?product.variant.option_values[current_index].pricing.raw.sale_price:product.variant.option_values[current_index].pricing.raw.price}}
                            </div> -->
                            <!-- <div style="font-size: 10px!important;color: grey !important;margin-top: 5px;">(taxes extra)</div> -->
                          </div>
                          <!-- <div style="display:flex;margin-top: 10px;">
                            <div class="carience-discount-percent">
                              {{product.variant.option_values[current_index].pricing.raw.discount_percentage!=null?product.variant.option_values[current_index].pricing.raw.discount_percentage:0}}% off
                            </div>
                            <div style=" font-size: 12px;color:black;margin-left:7px">You SAVE</div>
                            <div class="carience-discount-percent">
                              {{product.variant.option_values[current_index].pricing.raw.discount_amount!=null?product.variant.option_values[current_index].pricing.raw.discount_amount:0}}
                            </div>
                          </div> -->

                        </div>
                      </div>
                    </div>
                    <!-- end -->
                    <span *ngIf="config.title === 'Deera'"
                      style="font-size: 16px !important; color: grey !important">(taxes extra)</span>
                  </div>
                  <div class="moq-color"
                    *ngIf="config.title !== 'Tams' && config.title !== 'Deera' && config.title !== 'Babys Pride'  && config.title !== 'Carience' && config.title !== 'LushNGreen' && config.title !== 'Accel' && config.title !== 'Vimpro' && config.title !== 'BestGifts' && config.title !== 'BombayHardware'&&  config.title !== 'Beaubelle'&&  config.title !== 'Mayan'&& config.title !== 'AvonSeals' && config.title != 'Vistas' && config.title !== 'SpecialWires'&& config.title !== 'Karupattiraja' && config.title !== 'Schift Cosmetics' && config.title !== 'KatbookStore' && config.title !=='Taazah'">
                    Minimum Order Quantity :
                    {{ newProductDetails.pricing.raw.minimumorderquantity }}
                  </div>
                  <div
                    *ngIf="config.title === 'Vimpro'&&newProductDetails.pricing.raw.minimumorderquantity>1" style="margin-top: 2%;">
                    Minimum Order Quantity :
                    {{ newProductDetails.pricing.raw.minimumorderquantity }}
                  </div>
                  <!-- <div
                  *ngIf="config.title === 'AvonSeals'" style="color: black; font-size: 18px;">
                <span style="font-family: 'proxima-regular','sans-serif'!important;">The advantages of sealing pumps with dual pressurized dry gas seals are becoming widely recognized throughout industry. AVONSEALS® has developed a range of pump dry gas seals to suit every application.</span>
                </div> -->
                </div>
              </h2>
              <hr
                *ngIf="config.title !== 'BombayHardware' &&  config.title !== 'Taazah' &&  config.title !== 'SriSenbaga' && config.title !== 'ShubhCards' && config.title !== 'Babys Pride' && config.title !== 'AvonSeals' && config.title !== 'LushNGreen' && config.title !== 'KatbookStore' && config.title !== 'SpecialWires' && config.title !== 'Mayan' && config.title !== 'Carience' && config.title !== 'Vimpro' && config.title !== 'Vistas' && config.title !== 'Accel' 
                " />
            </div>
            
            <img [src]="mainImage" class="detail-preview mobile-only" *ngIf="config.title!='Carience' && config.title !== 'Vimpro' && config.title !== 'SpecialWires' && config.title !== 'Schift Cosmetics'" />
              <hr class="border-color mobile-only"    />
              <div *ngIf="config.title == 'ShubhCards'" class="normalSize specialsize mobile-only" [innerHTML]="content1" style="font-size: 14px !important; color:black; font-family: system-ui;line-height: 30px;">

            </div>
            <div *ngIf="config.title == 'SriSenbaga'" class="normalSize specialsize mobile-only" [innerHTML]="description" style="font-size: 14px !important; color:black; font-family: system-ui;line-height: 30px;">

            </div>
            <hr class="mobile-only"
              *ngIf="config.title !== 'Deera' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !== 'KatbookStore' && config.title !== 'BestGifts' && config.title !== 'Mayan' && config.title !== 'Carience' && config.title !== 'Vimpro' && config.title !== 'Taazah' && config.title !== 'SriSenbaga'">
            <div class="col-right" *ngIf="config.title === 'Deera' && eligibleBannerMessage.length>0">
              <h6>Available Discounts</h6>
              <!-- <span *ngFor="let item of promotionData; let k = index"> -->
                <!-- <span *ngIf="item.automate_discount_values===false"> -->
                  <div style="font-size: 15px; padding-left: 30px"
                    *ngFor="let item of eligibleBannerMessage; let i = index">
                    <div class="innerHTML" [innerHTML]="item"></div>
                  </div>
                <!-- </span> -->
              <!-- </span> -->
              <div style="font-size: 15px; padding-left: 30px" *ngFor="let item of promotionData; let j = index">
                <span *ngIf="item.automate_discount_values===true">
                  <span
                    *ngFor="let data of item.quantity_discount.amount_or_percentage.discount_type_values; let m = index">
                    <span
                      *ngFor="let data1 of item.quantity_discount.amount_or_percentage.discount_type; let n = index">
                      <span *ngIf="data1==='Amount'">
                        <span>
                          Buy {{data.quantity}} and get ₹{{data.fixed_value}} discount. <br>
                        </span>
                      </span>
                      <span *ngIf="data1==='Percentage'">
                        <span>
                          Buy {{data.quantity}} and get {{data.percentage_value}}% discount. <br>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <!-- </ng-container> -->
              <!-- </div> -->
              <!-- </div> -->
              <!-- <h6>Discounts Available</h6>                             -->
              
             
              <hr *ngIf="config.title === 'Deera' || config.title === 'Beaubelle'|| config.title === 'Karupattiraja'||config.title === 'Vistas'" class="hr-align" />
            </div>
            <a
            *ngIf="config.title == 'Vistas' && newProductDetails.pricing.raw.price!==0 " class="mobile-only">
            <!-- <h4 class="priceRange" *ngIf="newProductDetails.product_type == 'Simple' || newProductDetails.product_type == 'Variation'">{{config.title === 'LuckMe' || config.title === 'Murgasen' ? 'SR ' : '₹'}} {{newProductDetails.pricing.raw.price }}&nbsp; -->
            <h4 class="priceRange" *ngIf="
                newProductDetails.product_type == 'Simple' ||
                newProductDetails.product_type == 'Variation'
              ">
              {{ "₹" }}
              {{ newProductDetails.pricing.raw.price }}<span style="font-size: 10px;">(per Ream)</span>
              <!-----rating and reviews------------------>
              <div style="display: inline; margin-left: 8px !important" *ngIf="groups[3].showondetailpage">
                <!-- <ngb-rating [max]="5"  [(rate)]="currentRating" [readonly]="true"></ngb-rating> -->
                <span [class]="
                    currentRating >= 1
                      ? 'fa fa-star checked'
                      : 'fa fa-star-o'
                  " style="
                    font-size: 15px !important;
                    color: orange !important;
                  "></span>
                <span [class]="
                    currentRating >= 2
                      ? 'fa fa-star checked'
                      : 'fa fa-star-o'
                  " style="
                    font-size: 15px !important;
                    color: orange !important;
                  "></span>
                <span [class]="
                    currentRating >= 3
                      ? 'fa fa-star checked'
                      : 'fa fa-star-o'
                  " style="
                    font-size: 15px !important;
                    color: orange !important;
                  "></span>
                <span [class]="
                    currentRating >= 4
                      ? 'fa fa-star checked'
                      : 'fa fa-star-o'
                  " style="
                    font-size: 15px !important;
                    color: orange !important;
                  "></span>
                <span [class]="
                    currentRating >= 5
                      ? 'fa fa-star checked'
                      : 'fa fa-star-o'
                  " style="
                    font-size: 15px !important;
                    color: orange !important;
                  "></span>

                <a style="font-size: small !important;" routerLink="/product-review/{{
                    newProductDetails.id
                  }}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} customer reviews</a>
              </div>
            </h4>
          </a>
          <hr *ngIf="config.title === 'Vistas'" />

            <div class="breadcurmb" *ngIf="config.title!=='BombayHardware' && config.title!=='ShubhCards'&& config.title !== 'Taazah' && config.title!=='Babys Pride' && config.title!=='Schift Cosmetics' && config.title!=='Carience' && config.title!=='LushNGreen' && config.title!=='KatbookStore'">
              <div class="normalSize specialsize" [innerHTML]="shortDescription">
                <hr  ngIf="config.title!=='ShubhCards'"/>
              </div>
            </div>
            <div class="breadcurmb" *ngIf="config.title=='Carience'" style="margin-top: 3%;">
              <div class="normalSize specialsize" [innerHTML]="shortDescription">
                <hr />
              </div>
            </div>


            <hr class="border-color" *ngIf="config.title !== 'BombayHardware' && config.title !== 'Taazah' && config.title !== 'Carience' && config.title !== 'Schift Cosmetics' && config.title !== 'Babys Pride' && config.title !== 'Vimpro' && config.title !== 'KatbookStore'" />
          </div>
          <div *ngIf="config.title=='LinenRaj'" >
           


<div>
            <div 
            class="">
            <!-- <div *ngIf="price.is_default"> -->
              <div style="display:flex;margin-top: 20px; justify-content: center;">
                <div class="specialwire-listing-price" style="font-size: 20px;
                font-style: italic;">
                 ₹{{linenRajPrice}}

                </div>
                <!-- <div style="font-size: 10px!important;color: grey !important;margin-top: 5px;">(inclusive of
                  all taxes)</div> -->
              </div>
            <!-- </div> -->
          </div>
        </div>
        <!-- <div style="display: inline;position: relative;top:10px;" *ngIf="groups[3].showondetailpage">

          <a style="font-size: small !important" *ngIf="groups[3].fields[1].visibility">{{ reviews }}
            reviews</a>
        </div> -->
        <div class="row4" style="display: flex;justify-content: center;">
          <div class="inner-star-icon review-mob2 pd-1">
            <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
            <span style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
            <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
            <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
            <span style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
          </div>
          <span class="jdgm-qa-badge__text" style="margin-top: 4px; margin-left: 5px;">
            No reviews
          </span>
          <!-- <span class="jdgm-qa-badge " style="height: 16px; transform: translate(0px, 6px);">
  
            <i class="fa fa-comments" style="color: #a77737; transform: translate(0px, -5px);"></i>
          <span class="jdgm-qa-badge__text" style=" transform: translate(0px, -5px); margin-left: 5px;">
            No questions
          </span>
        </span> -->

        
          </div>
          </div>
          <div *ngIf="newProductDetails.product_type=='Variable' && config.title=='SpecialWires'" >
            <!-- <div style="display: inline;position: relative;top:10px;" *ngIf="groups[3].showondetailpage">
              <span [class]="currentRating >= 1 ? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 15px !important;color: orange !important;"></span>
              <span [class]="currentRating >= 2 ? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 15px !important;color: orange !important;"></span>
              <span [class]="currentRating >= 3 ? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 15px !important;color: orange !important;"></span>
              <span [class]="currentRating >= 4 ? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 15px !important;color: orange !important;"></span>
              <span [class]="currentRating >= 5 ? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 15px !important;color: orange !important;"></span>

              <a style="font-size: small !important" *ngIf="groups[3].fields[1].visibility" routerLink="/product-review/{{newProductDetails.id}}">{{ reviews }}
                reviews</a>
             
            </div> -->



            <div *ngIf="current_index==-1">
            <div>
              <div style="display:flex;margin-top: 20px;">
                <div class="specialwire-listing-price">
                  MRP ₹{{product.variant.option_values[0].child[0].pricing.raw.price}} 

                </div>
              </div>
          </div>
        </div>
        <div *ngIf="current_index!==-1">
          <div>
            <div style="display:flex;margin-top: 20px;">
              <div class="specialwire-listing-price">
                MRP ₹{{product.variant.option_values[current_index].child[child_index].pricing.raw.price}} 

              </div>
            </div>
        </div>
      </div>
          </div>
          <div class="breadcurmb" *ngIf="config.title === 'ShubhCards' || config.title === 'SriSenbaga'">
            <div style="display: flex;margin-bottom: -20px;">
              <div  *ngIf="config.title !== 'SriSenbaga'">
                <h6 style="color: #6b6b6b;">Dimensions</h6>
            <div class="normalSize">
              <div class="product-addtional-details">
                <ul class="one-column">
                  <li class="normalSize">
                    <label class="list-label" style="color: #6b6b6b;">Width: </label>
                    <label class="list-value" style="color: #6b6b6b;">
                      {{ newProductDetails.size_dimension.width }}</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label" style="color: #6b6b6b;">Height: </label>
                    <label class="list-value" style="color: #6b6b6b;">
                      {{ newProductDetails.size_dimension.height }}</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label" style="color: #6b6b6b;">Length: </label>
                    <label class="list-value" style="color: #6b6b6b;">
                      {{ newProductDetails.size_dimension.length }}</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label" style="color: #6b6b6b;">Card Weight: </label>
                    <label class="list-value" style="color: #6b6b6b;">
                      {{ newProductDetails.card_weight }}</label>
                  </li>
                </ul>
              </div>
            </div>
              </div>
              <div class="align-s-rgt">
                <h6 style="color: #6b6b6b;">Product Details</h6>
                <div class="product-detail">
                  <div class="product-addtional-details" >
                    <ul class="one-column">
                     <div >
                      <li  class="normalSize schift-flec" *ngFor="let field of groups[4].fields">
                        <label class="list-label" style="color: #6b6b6b;">{{field.labelname}}: </label>
                        <label class="list-value"style="color: #6b6b6b;"
                          *ngIf="field.nestedinfo.type == 'object'">{{metaDataMapService.findData(newProductDetails,
                          field.nestedinfo)}} </label>
                        <label class="list-value" style="color: #6b6b6b;"
                          *ngIf="field.nestedinfo.type == 'array' && field.labelname == 'Category'  ">{{product.categorynames[0].name}}
                        </label>
                        <div>
                        <div *ngFor="let categories of newProductDetails.categories">
                       
                      </div>
                    </div>
                       
      
                        <label class="list-value"
                          *ngIf="field.nestedinfo.type == 'array' && field.labelname == 'Themes'">{{themes}}
                        </label>
                      </li>
                     </div>
                    
                     
                      
                     
                      
                      
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            
            <hr class="border-color1"/>
          </div>

          <!------variants------>
          <div class="col-right" id="simple" *ngIf="showSize && config.title!='Carience'&& config.title!='Babys Pride' && config.title !== 'LushNGreen' && config.title !== 'KatbookStore' && config.title != 'Vimpro' && config.title!='AvonSeals' && config.title !== 'SpecialWires' && config.title !== 'Deera' && config.title !== 'Taazah' && config.title !== 'SriSenbaga'">
            <div class="col-right">
              <p class="sizeText">{{ variantName }}</p>
            </div>
            <br />
            <div class="col-right btn-group" *ngFor="let items of variants">
              <button type="button" class="sizebox" id="button" [class.active]="activeMenu === items.option"
                class="btn btn-primary sizebox" (click)="onConfirm(items)" value="items.id">
                {{ items.option }}
              </button>
              <hr />
            </div>
          </div>
          
          <!-- <div class="col-right" id="simple" *ngIf="showSize && config.title ==='Deera'"> -->
            <div class="col-right" id="simple" *ngIf="showSize && config.title ==='Deera'">
            <div class="col-right">
              <p class="sizeText">{{ variantName }}</p>
            </div>
            
            <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
              <button type="button" id="button" 
                            class="btn btn-primary sizebox sizebutton" [class.active]="items.is_default" (click)="onConfirm1(items,items.id,j)" value="items.id">
                            {{ items.option }}
                          </button>
              <hr />
            </div>
          </div>
          <h2 class="product-name mobile-only" id="prodName" style="font-weight: bolder;margin-bottom: 30px;" *ngIf="groups[0].fields[0].visibility && config.title === 'Babys Pride'">
            <h1 style="font-weight: 500;font-size: 18px;font-family: system-ui; margin-bottom: 20px; text-transform: uppercase; color: gray;
            ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </h1>
            <div *ngIf="product.product_type=='Variable'" style="display: flex;"> 
              <div class="col-right deera-price-row" *ngFor="let items of product.variant.option_values; let j = index" style="display: flex;">
            <div *ngIf="items.is_default" style=" display:flex;justify-content: center;font-weight: 500;font-size: 17px;" class="product-list-price2-baby" >
              ₹{{items.pricing.raw.price}}.00
             </div>
            
             <div style="font-weight: 300;font-size: 14px; margin-left: 8px;font-size: 10px;
             display: contents;" *ngIf="items.is_default && config.title === 'Babys Pride'">(Inclusive of all taxes)</div>
              </div></div>
              <div style="font-size: 14px !important;text-decoration: line-through;color: #a29898 !important; margin-top: 5px;">₹{{ product.variant.option_values[0].pricing.raw.msrp }}.00</div>
              </h2>
              <h2 class="product-name mobile-only" id="prodName" style="font-weight: bolder;margin-bottom: 30px;" *ngIf="groups[0].fields[0].visibility && config.title === 'LushNGreen'">
                <div style="font-weight: 500;font-size: 18px;font-family: system-ui; margin-bottom: 20px; text-transform: uppercase; color: rgb(2, 2, 2);
                ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div>
                <div *ngIf="product.product_type=='Variable'" style="display: flex;"> 
                  <div class="col-right deera-price-row" style="display: flex;">
                <div style=" display:flex;justify-content: center;font-weight: 500;font-size: 17px;" class="product-list-price2-baby" >
                  ₹{{product.variant.option_values[0].child[0].pricing.raw.price}}.00
                 </div>
                 
                  </div>
                  <div style="font-size: 17px !important;text-decoration: line-through;color: #a29898 !important;margin-left: 10px;">₹{{ product.variant.option_values[0].child[0].pricing.raw.msrp }}.00</div>
                </div>
                  <div *ngIf="product.product_type=='Simple'" style="display: flex;"> 
                    <div class="col-right deera-price-row" style="display: flex;">
                  <div style=" display:flex;justify-content: center;font-weight: 500;font-size: 17px;" class="product-list-price2-baby" >
                    ₹{{newProductDetails.pricing.raw.price}}.00
                   </div>
                   
                    </div>
                    <div style="font-size: 17px !important;text-decoration: line-through;color: #a29898 !important;margin-left: 10px;">₹{{newProductDetails.pricing.raw.mrps }}.00</div>
                  </div>
                  </h2>
                  <h2 class="product-name mobile-only" id="prodName" style="font-weight: bolder;margin-bottom: 20px;" *ngIf="groups[0].fields[0].visibility && config.title === 'Taazah'">
                    <div style="font-weight: 700;font-size: 24px;font-family: system-ui; margin-bottom: 10px; color: #1b52a4;
                    ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo)}} </div>
                   
                      
                      </h2>
                  <h2 class="product-name mobile-only" id="prodName" style="font-weight: bolder;margin-bottom: 30px;" *ngIf="groups[0].fields[0].visibility && config.title === 'KatbookStore'">
                    <div style="font-weight: 500;font-size: 20px;font-family: system-ui; margin-bottom: 20px;text-align: center; margin-top: 10px; text-transform: uppercase; color: rgb(2, 2, 2);
                    ">{{metaDataMapService.findData(newProductDetails,groups[0].fields[0].nestedinfo) | titlecase}} </div>
                   <div style="display: flex;justify-content: center;"> 
                    <div class="col-right deera-price-row" style="display: flex;">
                      <div  *ngIf="current_index==0" style=" display:flex;justify-content: center;font-weight: 500;height: 21px;font-size: 30px; color: #23a6f0;" class="product-list-price2-baby" >
                        ₹{{product.variant.option_values[0].pricing.raw.price}}.00
                       </div>
                       <div  *ngIf="current_index!=0" style=" display:flex;justify-content: center;font-weight: 500;height: 21px;font-size: 30px; color: #23a6f0;" class="product-list-price2-baby" >
                        ₹{{product.variant.option_values[current_index].pricing.raw.price}}.00
                       </div>
                   <div style="font-size: 17px !important;margin-top: 2px;margin-left: 20px; text-decoration: line-through;color: #8080806e !important;font-weight: 400;">₹{{product.pricing.raw.msrp}}.00</div>
                    </div></div>
                    <div class="col-right" id="simple" style="margin-top: 40px;" >
                      <div class="col-right">
                        <p class="sizeText" style="font-weight: 500;font-size: 14px;font-family: system-ui;">{{ variantName }}</p>
                      </div>
                      <div style="display: grid;grid-template-columns: repeat(1, 1fr); width: 90%;">
                      <div class="col-right btn-group"  *ngFor="let items1 of product.variant.option_values; let j = index" style="margin-bottom: 20px;justify-content: center;">
                                      <input type="radio" name=items1.id
                                      class="choisebuttonbaby" (click)="onConfirm2(items1,items1.id,j)" value="items1.id" [checked]="items1.is_default == true">
                                      <p style="font-size: 14px;font-weight: 500;border-radius: 30px;border: 1px solid #23a6f0; width: 185px; margin-left: 10px;padding: 2% 5% 1% 5%;color: rgb(75, 75, 75);text-align: center;" (click)="onConfirm1(items1,items1.id,j)" [class.active]="items1.is_default" >{{ items1.option }}</p> 
                        <hr />
                      </div>
                    </div>
                    </div>
                      </h2>
                      <div  *ngIf="config.title === 'KatbookStore'" class="mobile-only">
                        <h4 style="font-size: 15px; font-weight: 700;">Description</h4>
                        <div class="breadcurmb">
                          <div class="normalSize specialsize" style="color: rgb(141, 141, 141);" [innerHTML]="content1">
                          </div>
                        </div>
                  <hr/>
                      </div>
          <div  *ngIf="config.title === 'Babys Pride'" class="mobile-only">
            <h4 style="font-size: 15px; font-weight: 700;">Description</h4>
            <div class="breadcurmb">
              <div class="normalSize specialsize" [innerHTML]="shortDescription">
              </div>
            </div>
      <hr/>
          </div>
          <div class="col-right" id="simple" *ngIf="config.title ==='Babys Pride'">
            <div class="col-right">
              <p class="sizeText" style="font-weight: 500;font-size: 14px;font-family: system-ui;">{{ variantName }}</p>
            </div>
            
            <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
              <button type="button" id="button" 
                            class="choisebuttonbaby" [class.active]="items.is_default" (click)="onConfirm1(items,items.id,j)" value="items.id">
                            {{ items.option }}
                          </button>
              <hr />
            </div>
          </div>
          <div  *ngIf="config.title === 'LushNGreen'">
            <!-- <h4 style="font-size: 15px; font-weight: 700;">Description</h4> -->
            <div class="breadcurmb">
              <div class="normalSize specialsize" [innerHTML]="content1">
              </div>
            </div>
      <hr/>
          </div>
          <div  *ngIf="config.title === 'Taazah'" class="mobile-only">
            <!-- <h4 style="font-size: 15px; font-weight: 700;">Description</h4> -->
            <div class="breadcurmb">
              <div class="normalSize specialsize" [innerHTML]="shortDescription">
              </div>
            </div>
      <hr/>
          </div>

          <div class="col-right" id="simple" *ngIf="config.title ==='Taazah' && product.stock_status=='Available' && product.product_type=='Variable'">
            <div class="col-right">
              <p class="sizeText" style="font-weight: 500;font-size: 14px;font-family: system-ui;">{{ variantName }}</p>
            </div>
            
            <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
              <button type="button" id="button" 
                            class="choisebuttonbaby" [class.active]="items.is_default" (click)="onConfirm1(items,items.id,j)" value="items.id">
                            {{ items.option }}
                          </button>
              <hr />
            </div>

          </div>
          <div  *ngIf="config.title === 'Taazah'">
            <!-- <h4 style="font-size: 15px; font-weight: 700;">Description</h4> -->
            <div class="breadcurmb">
              <div class="normalSize specialsize" [innerHTML]="content1">
              </div>
            </div>
        <div style="display: flex;margin-bottom: 10px;" class="taazah-price" *ngIf="product.product_type=='Variable' && !product.variant.variant_child"> 
          <div class="col-right deera-price-row" style="display: flex;">
              <div  *ngIf="current_index==0" style="display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;" class="product-list-price-taazah" >
                Discount Price ₹{{product.variant.option_values[0].pricing.raw.price}}.00
               </div>
               <div  *ngIf="current_index!=0" style="display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;" class="product-list-price-taazah" >
                Discount Price ₹{{product.variant.option_values[current_index].pricing.raw.price}}.00
               </div>
         <div *ngIf="current_index==0" style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{product.variant.option_values[0].pricing.raw.msrp}}.00</div>
         <div *ngIf="current_index!=0" style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{product.variant.option_values[current_index].pricing.raw.msrp}}.00</div>
          </div></div>
          <div style="display: flex;margin-bottom: 10px;" class="taazah-price" *ngIf="product.product_type=='Variable' && product.variant.variant_child"> 
            <div class="col-right deera-price-row" style="display: flex;">
                <div  *ngIf="current_index==0" style="display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;" class="product-list-price-taazah" >
                  Discount Price ₹{{product.variant.option_values[0].child[0].pricing.raw.price}}.00
                 </div>
                 <div  *ngIf="current_index!=0" style="display:flex;justify-content: center;font-weight: 700;height: 21px;color:#f33601;font-size:14px;" class="product-list-price-taazah" >
                  Discount Price ₹{{product.variant.option_values[current_index].child[child_index].pricing.raw.price}}.00
                 </div>
           <div *ngIf="current_index==0" style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{product.variant.option_values[0].child[0].pricing.raw.msrp}}.00</div>
           <div *ngIf="current_index!=0" style="font-size: 14px !important;margin-left: 30px; text-decoration: line-through;color: #8080806e !important;font-weight: 700;">MRP Price ₹{{product.variant.option_values[current_index].child[child_index].pricing.raw.msrp}}.00</div>
            </div></div>
          <div *ngIf="product.product_type=='Simple'" style="display: flex;" class="taazah-price"> 
            <div class="col-right deera-price-row" style="display: flex;">
          <div style=" display:flex;justify-content: center;font-weight: 500;font-size: 17px;color:#f33601" class="product-list-price2-baby" >
            Discount Price ₹{{newProductDetails.pricing.raw.price}}.00
           </div>
           
            </div>
            <div style="font-size: 17px !important;text-decoration: line-through;color: #a29898 !important;margin-left: 10px;">MRP Price ₹{{newProductDetails.pricing.raw.mrps }}.00</div>
          </div>
          </div>


          
          <div class="col-right" id="simple" *ngIf="config.title ==='LushNGreen' && product.stock_status=='Available' && product.product_type=='Variable'">
            <div class="col-right">
              <p class="sizeText" style="font-weight: 500;font-size: 14px;font-family: system-ui;">{{ variantName }}</p>
            </div>
            
            <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
              <button type="button" id="button" 
                            class="choisebuttonbaby" [class.active]="items.is_default" (click)="onConfirm1(items,items.id,j)" value="items.id">
                            {{ items.option }}
                          </button>
              <hr />
            </div>
            <!-- <div style="margin-left: 85px">
              <label for="part"><strong>Weight : </strong></label>
              <div class="dropdown" style="width:50%">
                <button class="dropdown-toggle dropdownstyle1 dropspecial1" type="button" id="button"
                  data-toggle="button" aria-haspopup="true" aria-expanded="false">
                  {{product.variant.option_values[current_index].child[child_index].type}}
                </button>
                <div class="dropdown-menu special-dropdownmenu" aria-labelledby="dropdownMenuButton">
                  <a *ngFor="let weight of product.variant.option_values[current_index!=null?current_index:0].child;let k=index"
                    (click)="selectColour(weight.type,product.id,k)"
                    class="dropdown-item special-dropitem">{{weight.type}}</a>
                </div>
              </div>
            </div> -->
            <div *ngIf="product.variant.option_values[current_index].child && showtype">
              <label for="part"><strong>Type : </strong></label>
              <div style="display: flex;">
              <div *ngFor="let child of product.variant.option_values[current_index!=null?current_index:0].child;let k=index">
                <button type="button" id="button" [class.active]="child.is_default"
                class="choisebuttonbaby" aria-haspopup="true" aria-expanded="false" (click)="selectColour(child.type,product.id,k)">
                {{child.type}}
                </button>
              </div>
            </div>
            </div>
          </div>
          <!-- <span *ngIf="config.title == 'Babys Pride'" style="cursor:pointer;font-size: 10px;" (click)="scrollToElement()"><strong style="color: #2554c7;font-size: 13px;">Size Chart</strong></span> -->
          <hr *ngIf=" config.title ==='LushNGreen' && product.stock_status=='Available' && product.product_type=='Variable' " />
          <hr *ngIg="config.title !=='LushNGreen' && config.title !== 'Taazah'"/>
          <!-- <div *ngIf="config.title == 'Babys Pride'">
            <div class="col-right">
              <p class="sizeText" style="font-weight: 400;font-size: 15px;font-family: system-ui;color: rgb(91 88 88);">BEST OFFERS</p>
            </div>
<hr style="border: none;
border-top: 1px dotted #f00;
color: #fff;
background-color: #fff;"/>
<p style="font-weight: 500;font-size: 14px;">Get Rs.100 OFF on your first purchase! Use Code:</p>
<div style="display: flex;margin-top: 10px;margin-bottom: 10px;">
<span class="offer-baby">NEW 100</span> 
<a style="margin-left: 10px;font-size: 12px;">Tap to copy</a>
</div>
<hr style="border: none;
border-top: 1px dotted #f00;
color: #fff;
background-color: #fff;"/>
          </div> -->
          <!-----price of variant-->
          <div class="col-right" *ngIf="showPrice && config.title!='Carience'&& config.title != 'Vimpro'&& config.title!='AvonSeals' && config.title !== 'Deera' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !== 'SpecialWires' && config.title !== 'KatbookStore' && config.title !== 'Taazah'">
            <h2 class="product-price">
              <span class="price">&#8377;{{ priceOfVariant }}</span>
            </h2>
            <hr />
          </div>
      
          <!---------note message---------->
          <div class="col-right" *ngIf="showSize && showHint && config.title!='Carience' && config.title != 'Vimpro' && config.title!='AvonSeals' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !== 'SpecialWires' && config.title !== 'KatbookStore' && config.title !== 'Taazah'">
            <label class="hint-message addSize" id="hint">Note: Please select option to add item in cart</label>
          </div>

          <div class="col-right" *ngIf="groups[1].showondetailpage">
            <div class="add-to">
              <!--------- button---------->
              <!-------------Add to cart-->
              <div *ngIf="
                  config.title === 'Deera' &&
                  productPromotion === 'Product discount' &&
                  productQuantity1 === true
                ">
                <div class="innerHTML" [innerHTML]="congratulationBanner"></div>
                <span *ngIf="percentageValue !== 0" style="
                    font-size: 17px !important;
                    color: orange !important;
                    font-weight: 600;
                  ">{{ percentageValue }}% Discount Applied</span>
                <span *ngIf="fixedAmount !== 0" style="
                    font-size: 17px !important;
                    color: orange !important;
                    font-weight: 600;
                  ">₹{{ fixedAmount }} Discount Applied</span>

                <h4 class="priceRange">
                  ₹{{ discountValue | number : "1.2-2" }}

                  <div style="display: inline">
                    <!-- <span  style="font-size: 16px !important;text-decoration: line-through;color: grey!important;margin-left:7px;">₹{{newProductDetails.pricing.raw.price}}</span> -->
                    <!-- <span  style="font-size: 16px !important;text-decoration: line-through;color: grey!important;margin-left:7px;">₹{{newProductDetails.pricing.raw.msrp}}</span>   -->
                    <span style="
                        font-size: 16px !important;
                        text-decoration: line-through;
                        color: grey !important;
                        margin-left: 7px;
                      ">₹{{
                      newProductDetails.pricing.raw.msrp * productQuantity
                      }}</span>
                  </div>
                  <!-- <span *ngIf="config.title === 'Deera'" style="font-size: 16px !important;color: grey!important;">(incl of all taxes)</span>  -->
                  <!-- <span style="font-size: 16px !important;color: grey!important;margin-left:5px;">- ₹{{discountValue / newProductDetails.unit | number : '1.2-2'}}/piece</span>    -->
                  <span style="
                      font-size: 16px !important;
                      color: grey !important;
                      margin-left: 5px;
                    ">- ₹{{
                    discountValue / (newProductDetails.unit * productQuantity)
                    | number : "1.2-2"
                    }}/piece</span>
                </h4>
                <span *ngIf="config.title === 'Deera'" style="font-size: 16px !important; color: grey !important">(taxes
                  extra)</span>
              </div>
              <div *ngIf="
                  config.title === 'Deera' &&
                  quantityPromotion === 'Quantity discount' &&
                  productQuantity1 === true
                ">
                <div class="innerHTML" [innerHTML]="congratulationBanner"></div>

                <span *ngIf="percentageValue !== 0" style="
                    font-size: 17px !important;
                    color: orange !important;
                    font-weight: 600;
                  ">{{ percentageValue }}% Discount Applied for
                  {{ productQuantity }} Quantity</span>

                <span *ngIf="fixedAmount !== 0" style="
                    font-size: 17px !important;
                    color: orange !important;
                    font-weight: 600;
                  ">₹{{ fixedAmount }} Discount Applied for
                  {{ productQuantity }} Quantity</span>

                <!-- <h4 class="priceRange">₹{{discountValue}} -->
                <h4 class="priceRange" *ngIf="fixedAmount !== 0 || percentageValue !== 0">
                  ₹{{ discountValue / productQuantity | number : "1.2-2" }}
                  <div style="display: inline" *ngIf="newProductDetails.product_type==='Simple'">
                    <!-- <span  style="font-size: 16px !important;text-decoration: line-through;color: grey!important;margin-left:7px;">₹{{newProductDetails.pricing.raw.price}}</span> -->
                    <span style="
                        font-size: 16px !important;
                        text-decoration: line-through;
                        color: grey !important;
                        margin-left: 7px;">₹{{ newProductDetails.pricing.raw.msrp }}</span>
                  </div>
                  <div style="display: inline" *ngIf="newProductDetails.product_type==='Variable'">
                    <!-- <span  style="font-size: 16px !important;text-decoration: line-through;color: grey!important;margin-left:7px;">₹{{newProductDetails.pricing.raw.price}}</span> -->
                    <span style="
                        font-size: 16px !important;
                        text-decoration: line-through;
                        color: grey !important;
                        margin-left: 7px;">₹{{ variantMSRP }}</span>
                  </div>
                  <!-- <span *ngIf="config.title === 'Deera'" style="font-size: 16px !important;color: grey!important;">(incl of all taxes)</span>  -->
                  <!-- <span style="font-size: 16px !important;color: grey!important;margin-left:5px;">- ₹{{discountValue / newProductDetails.unit | number : '1.2-2'}}/piece</span>    -->
                  <span *ngIf="newProductDetails.product_type==='Simple'" style="
                      font-size: 16px !important;
                      color: grey !important;
                      margin-left: 5px;
                    ">- ₹{{
                    discountValue / newProductDetails.unit / productQuantity
                    | number : "1.2-2"
                    }}/piece</span>
                    <span *ngIf="newProductDetails.product_type==='Variable'" style="
                      font-size: 16px !important;
                      color: grey !important;
                      margin-left: 5px;
                    ">- ₹{{
                    discountValue / variantUnit / productQuantity
                    | number : "1.2-2"
                    }}/piece</span>
                </h4>
                <span *ngIf="config.title === 'Deera' && (fixedAmount !== 0 || percentageValue !== 0)"
                  style="font-size: 16px !important; color: grey !important">(taxes extra)</span>
              </div>
            
              <div>
                <div *ngIf="config.title == 'Beaubelle'">
                  <div *ngIf="newProductDetails.pricing.raw.price!==0 ">
                    <button style="background-color: #e7762d!important;"
                      class="btn btn-primary inq-btn-st ml-1 cartButton_bb1"
                      style="color:white!important;background-color: #e7762d!important;" [disabled]="isDisabled"
                      (click)="addTocart()" *ngIf="
                      (appService.productIdinCart.indexOf(newProductDetails.id) ==
                        -1 ) ||
                      (showSize &&
                        appService.productIdinCart.indexOf(checkVariantInCart) ==
                          -1) 
                    ">
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                  </div>
                  <button class="btn btn-primary inq-btn-st ml-1 cartButton_bb1" [disabled]="isDisabled"
                    (click)="submitEnquiry(newProductDetails)" *ngIf="newProductDetails.pricing.raw.price==0">
                    Enquiry
                  </button>

                </div>
                <div *ngIf="config.title == 'Carience'" style="display:flex;margin-top:20px">
                  <div>
                    <h5>Dimension</h5>
                    <div class="dropdown" style="width:50%;height: 50%;">
                      <button class="dropdown-toggle dropdownstyle1" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{product.variant.option_values[current_index].option}}
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                        style="min-width: 80%;max-width: fit-content;">
                        <a *ngFor="let size of product.variant.option_values;let j=index"
                          (click)="selectOptionCarience(size.option,product.id,j)"
                          class="dropdown-item">{{size.option}}</a>
                      </div>
                    </div>
                  </div>
                  <div class="" 
                    *ngFor="let price of product.variant.option_values[current_index].child;let i = index">

                    <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
                  -1" class="btn btn-primary  ml-1 carience-detail-cart"
                      (click)="addToCartcarience(price.id)" style="font-weight: 600!important;">
                      <!-- {{price.id}} -->
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>

                    <!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
                    <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart viewcart_bt" style="position: relative;min-width: fit-content;
                  margin-top: 20px;" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
                      <!-- {{price.id}} -->
                      <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                          (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                      <span class="inq-sp-2"
                        style="padding-left: 10px;
                  padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
                      <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer"
                          (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                    </div>
                  </div>
                  <!-- <span  >
                  <button 
                  class="btn btn-primary inq-btn-st ml-1 carience-detail-cart"
                  
                  (click)="addTocart()"
                  *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  " 
                >
                  {{ groups[1].fields[0].labelname }}1
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
                </span> -->
                </div>
                <div *ngIf="config.title == 'Vimpro' && product.product_type=='Variable' && product.variant.variant_child" style="display:flex;margin-top:20px">
                  <div>
                    <h5>Dimension</h5>
                    <div class="dropdown" style="width:50%">
                      <button class="dropdown-toggle dropdownstyle1" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{product.variant.option_values[current_index].option}}
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                        style="min-width: 80%;max-width: fit-content;">
                        <a *ngFor="let size of product.variant.option_values;let j=index"
                          (click)="selectOptionCarience(size.option,product.id,j)"
                          class="dropdown-item">{{size.option}}</a>
                      </div>
                    </div>
                  </div>
                  <div class="" style="display: flex; justify-content: center;"
                    *ngFor="let price of product.variant.option_values[current_index].child;let i = index">

                    <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
                  -1" class="btn btn-primary inq-btn-st ml-1 vimpro-detail-cart"
                      (click)="addToCartvimpro(price.id)">
                      <!-- {{price.id}} -->
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>

                    <!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
                    <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="position: relative;min-width: fit-content;
                  margin-top: 20px;left: 60px !important;" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
                      <!-- {{price.id}} -->
                      <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                          (click)="decreasekarupattiitem(appService.productIdinCart.indexOf(price.id))"></i></span>
                      <span class="inq-sp-2"
                        style="padding-left: 10px;
                  padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
                      <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer"
                          (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                    </div>
                  </div>
                  <!-- <span  >
                  <button 
                  class="btn btn-primary inq-btn-st ml-1 carience-detail-cart"
                  
                  (click)="addTocart()"
                  *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  " 
                >
                  {{ groups[1].fields[0].labelname }}1
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
                </span> -->
                </div>
                <div *ngIf=" config.title == 'SpecialWires' && product.product_type=='Simple'" style="display:flex;margin-top:20px">
                  <div>
                    <button class="btn btn-primary inq-btn-st ml-1 button-62" 
                    (click)="submitEnquiryForSpecial(newProductDetails)">
                    Submit Enquiry
                  </button>
                  </div>
          
                </div>
                <div *ngIf=" config.title == 'Vimpro' && product.product_type=='Simple'" style="display:flex;margin-top:20px">
                  <div>
                    <button class="btn btn-primary inq-btn-st ml-1 cartButton_bb1" style="background-color: #2554c7!important"
                    (click)="submitEnquiryForVimpro(newProductDetails)">
                    Submit Enquiry
                  </button>
                  </div>
          
                </div>
                <div *ngIf=" config.title == 'Vimpro' && product.product_type=='Variable' &&!product.variant.variant_child" style="display:flex;margin-top:20px">
                  <div>
                    <h5>Dimension</h5>
                    <div class="dropdown" style="width:50%">
                      <button class="dropdown-toggle dropdownstyle1" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{product.variant.option_values[current_index].option}}
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                        style="min-width: 80%;max-width: fit-content;">
                        <a *ngFor="let size of product.variant.option_values;let j=index"
                          (click)="selectOptionCarience(size.option,product.id,j)"
                          class="dropdown-item">{{size.option}}</a>
                      </div>
                    </div>
                  </div>
                  <div class="" style="display: flex; justify-content: center;">

                    <button *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[current_index].id) ==
                  -1" class="btn btn-primary inq-btn-st ml-1 vimpro-detail-cart"
                      (click)="addToCartcarience(product.variant.option_values[current_index].id)">
                      <!-- {{price.id}} -->
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>

                    <!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
                    <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="position: relative;min-width: fit-content;
                  margin-top: 20px;left: 60px !important;" *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[current_index].id) >=0">
                      <!-- {{price.id}} -->
                      <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                          (click)="decreaseItem(appService.productIdinCart.indexOf(product.variant.option_values[current_index].id))"></i></span>
                      <span class="inq-sp-2"
                        style="padding-left: 10px;
                  padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[current_index].id)].quantity}}</span>
                      <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer"
                          (click)="increaseItem(appService.productIdinCart.indexOf(product.variant.option_values[current_index].id))"></i></span>
                    </div>
                  </div>
                  <!-- <span  >
                  <button 
                  class="btn btn-primary inq-btn-st ml-1 carience-detail-cart"
                  
                  (click)="addTocart()"
                  *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  " 
                >
                  {{ groups[1].fields[0].labelname }}1
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
                </span> -->
                </div>
                <div  *ngIf="config.title =='Accel'"> 
                  <button type="button" class="btn btn-primary" (click)="submitEnquiry_accel(newProductDetails)">APPLY NOW</button>
                </div>
                <div
                  *ngIf="config.title != 'ShubhCards'&& config.title != 'Beaubelle' && config.title != 'SriSenbaga' && config.title != 'BombayHardware'" > 
                  <span *ngIf="config.title != 'BestGifts' && config.title != 'Deera' && config.title != 'Babys Pride' && config.title !== 'LushNGreen' && config.title != 'Accel' && config.title != 'Mayan' && config.title != 'Carience' && config.title != 'AvonSeals' && config.title != 'Vistas' && config.title !== 'SpecialWires' && config.title != 'Vimpro' && config.title != 'Schift Cosmetics' && config.title != 'Karupattiraja' && config.title != 'KatbookStore' && config.title !== 'Taazah'">
                    <button class="btn btn-primary inq-btn-st ml-1 cartButton schift-add-cart" [disabled]="isDisabled"
                      (click)="addTocart()" *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  ">
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                  </span>
                  <hr *ngIf="config.title === 'Schift Cosmetics'">
                  <span *ngIf="config.title === 'Schift Cosmetics'">
                    <button class="btn inq-btn-st ml-1 btn-primary schift-add-cart" [disabled]="isDisabled"
                      (click)="addTocart()" *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  ">
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                  </span>


                  <div style="width: 100%"
                  *ngIf="(appService.productIdinCart.indexOf(newProductDetails.id) != -1 || appService.productIdinCart.indexOf(checkVariantInCart) != -1) && (config.title ==='Schift Cosmetics')">
                  <div style="width: 100%" *ngFor="let cart of appService.cartProducts.results; let i = index" class="flex_schift_view">
                    <span *ngIf="newProductDetails.product_type=='Simple'" class="schiftpp_1">
                      <div class="btn btn-primary inq-btn-st ml-1 schift-detail-cart"
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <span class="fix_schift_but">
                        <span>
                          <i class="fa fa-minus mr-2" (click)="decreaseItem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                        <!-- <input type="number" style="width: 46%; text-align: center" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1"
                          (input)="changeDeeraValue(i, $event)" [(ngModel)]="cart.quantity" /> -->
                        <span class="inq-sp-2" style="color: white">{{ cart.quantity }}</span>
                        <span>
                          <i class="fa fa-plus ml-2" (click)="increaseItem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                          </span>
                          </div>
                    
                    </span>
                    <span *ngIf="(config.title === 'Schift Cosmetics') && (cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart)">
                      <button class="btn btn-primary inq-btn-st ml-1 button-62" [disabled]="isDisabled"  (click)="buyNow1()">
                        Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>
                      </span>
                  </div>
                </div>

                <span *ngIf="config.title === 'Schift Cosmetics' && appService.productIdinCart.indexOf(newProductDetails.id) ==
                -1 &&
              !showSize" style="font-size: 16px !important;color: grey !important;margin-left: 5px;">
                <button class="btn btn-primary inq-btn-st ml-1 button-62" [disabled]="isDisabled" (click)="buyNow2()">
                  Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>
              </span>

              <!-- <span *ngFor="let cart of appService.cartProducts.results; let i = index" style="font-size: 16px !important;color: grey !important; margin-left: 5px;">

                

                  </span> -->


                  <span *ngIf="config.title === 'Deera' && product.product_type=='Simple'&&product.stock_status=='Available'">
                    <button class="btn btn-primary inq-btn-st ml-1 cartButton" [disabled]="isDisabled"
                      (click)="addTocart()" *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  ">
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                    <!-- <button class="btn btn-primary inq-btn-st ml-1" (click)="buyNow()">
                      Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button> -->
                  </span>
                  <span *ngIf="config.title === 'LushNGreen' && product.product_type=='Simple'&&product.stock_status=='Available'">
                    <button class="btn btn-primary inq-btn-st ml-1 cartButton"
                      (click)="addTocart()" *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  ">
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                  </span>
                  <span *ngIf="
(config.title === 'LushNGreen' && product.product_type=='Simple' && product.stock_status=='Available' &&
  appService.productIdinCart.indexOf(newProductDetails.id) ==
    -1 &&
  !showSize)
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px;
">
<button class="btn btn-primary inq-btn-st ml-1" (click)="buyNow()">
  Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
<!-- <div style="display: flex;">
<span *ngIf="config.title === 'Taazah' && product.product_type=='Simple'&&product.stock_status=='Available'">
  <button class="btn inq-btn ml-1 taazah-cart-btn"
    (click)="addTocart()" *ngIf="
  (appService.productIdinCart.indexOf(newProductDetails.id) ==
    -1 ) ||
  (showSize &&
    appService.productIdinCart.indexOf(checkVariantInCart) ==
      -1)
">
   
    <span> <i class="fa fa-shopping-cart"></i></span>
    {{ groups[1].fields[0].labelname }}
  </button>
</span>

<span *ngIf="(appService.productIdinCart.indexOf(newProductDetails.id) != -1 || appService.productIdinCart.indexOf(checkVariantInCart) != -1)" class="width_Taz_20">
                  <div *ngFor="let cart of appService.cartProducts.results; let i = index">
                    <span *ngIf=" product.product_type=='Simple'">
                      <div class="DetailsviewCart_Taz"
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <span>
                          <i class="fa fa-minus mr-2" (click)="decreaseItem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                        <span class="inq-sp-2" style="color: white">{{ cart.quantity }}</span>
                        <span>
                          <i class="fa fa-plus ml-2" (click)="increaseItem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                      </div>
                    </span>
                  </div>
                </span>
<span *ngIf="
(config.title === 'Taazah' && product.product_type=='Simple' && product.stock_status=='Available' &&
!showSize)
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px;
">
<button class="btn inq-btn-sm ml-1 order-btn-taazah" (click)="buyNow()">Order Now</button>


</span>
</div>
<span *ngIf="config.title === 'Taazah' && product.product_type=='Variable' &&product.stock_status=='Available'" class="cartaddfun">
  <div class="deercar taz_caraaa">
  <div class="Taz_center_wid" *ngFor="let price of product.variant.option_values;let i = index" style="">

    <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="btn inq-btn ml-1 taazah-cart-btn1" (click)="addToCartTaz(price.id)">
      <span> <i class="fa fa-shopping-cart"></i></span> Add to Cart
    </button>   
    
    <div class="DetailsviewCart_Taz" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
        
          <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
              (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
           
              <span class="inq-sp-2"
                        style="padding-left: 15px;
                  padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[current_index].id)].quantity}}</span>
          <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
              (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>


        </div>
        
    </div>
  </div>
    <span *ngIf="
(product.product_type=='Variable')
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px;
">
<button class="btn inq-btn-sm ml-1 order-btn-taazah" (click)="buyNow()">
Order Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
</span> -->
                  <span *ngIf="config.title === 'Deera' && product.product_type=='Variable' &&product.stock_status=='Available'" class="cartaddfun">
                    <div class="deercar">
                    <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
                    justify-content: center;">
  
                      <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="btn btn-primary inq-btn-st ml-1 cartButtonvar" (click)="addToCartDeera(price.id)">
                      Add to Cart
                      </button>   
                      
                      <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="position: relative;
                          min-width: fit-content;
                          width: 160px" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
                          
                            <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                                (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                                <!-- <input type="number" style="width: 46%; text-align: center" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1"  *ngIf="config.title == 'Deera'"
                                (input)="changeDeeraValue(i, $event)" [(ngModel)]="cart.quantity" /> -->
                                <input type="number" style="width: 46%; text-align: center" onkeypress="return event.charCode >= 48"
                        (input)="changeDeeraVarValue(appService.productIdinCart.indexOf(price.id),$event)" inputmode="numeric" pattern="[0-9]*"  onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" />
                            <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                                (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
        
        
                          </div>
                          
                      </div>
                    </div>
                      <span *ngIf="
(config.title === 'Deera' && product.product_type=='Variable')
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px; margin-top: 2px;
">
<button class="btn btn-primary inq-btn-st ml-1" (click)="buyNow()">
  Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
                  </span>
<div *ngIf="config.title == 'LushNGreen'&&product.stock_status=='Out of Stock'">
  <p style="color: #539a18;font-weight: 700;font-size: x-large;">Out of Stock </p>
  <button class="cartButtonvarbaby" style="margin-top: 50px;width: 50%;" (click)="remindLater()">
    Remind when Available
    </button>
  </div>
  <span *ngIf="config.title === 'LushNGreen' && current_index==-1">
  <button class="button-62" [disabled]="current_index==-1" style="margin-left: 79px;margin-top: 10px;" >
    Add to Cart
    </button>     
  </span>
  <span *ngIf="config.title === 'LushNGreen' && !showtype">
    <p style="font-size: 20px;font-weight: 600;">Select Size to continue</p>
  </span>
<span *ngIf="config.title === 'LushNGreen' && product.stock_status=='Available' && product.product_type=='Variable' && product.variant.option_values[current_index].child && current_index!==-1 && showtype" class="cartaddfun">
  <div class="babycar">
    <div >
      <div *ngFor="let price of product.variant.option_values[current_index!=-1?current_index:0].child;let i = index">
         <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id) ==
         -1" class="cartButtonvarbaby" (click)="addToCartLush(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id )" >
         Add to Cart
         </button>
       </div>
       <div *ngFor="let rate of appService.cartProducts.results;let j = index">
         <div class="baby_detail_view" style="position: relative; min-width: fit-content;"
          id="quantity_button" *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id) != -1 && (rate.product_id == product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id)">
         <span><i class="fa fa-minus mr-3 margin_top_12"  style="font-size: 12px; cursor: pointer" (click)="decreaseItemNew(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id))"></i></span>
         <!-- <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1"
         (input)="changeSpecialValue(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id)].quantity" /> -->
         <span class="inq-sp-2 baby_top"
                        style="padding-left: 10px;
                  padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id)].quantity}}</span> 
          <span><i class="fa fa-plus ml-3 margin_top_12" style="font-size: 12px; cursor: pointer"  (click)="increaseItem(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id))"></i></span>
         </div>
       </div>
        </div>
  </div>
    <span *ngIf="
(config.title === 'LushNGreen' && product.product_type=='Variable') && current_index !== -1
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px; width: 30%;
">
<button class="cartButtonvarbaby2" (click)="buyNowLush(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id)">
Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
</span>  
<span *ngIf="config.title === 'KatbookStore' && product.product_type=='Variable'" class="cartaddfun" style="margin-top: 5%;">
  <div class="babycar">
  <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
  justify-content: center;">

    <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="cartButtonvarbaby" (click)="addToCartBaby(price.id)">
    Add to Cart
    </button>   
    
    <div class="baby_detail_view" style="position: relative;
        min-width: fit-content;" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
        
          <span class="baby_top"><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
              (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
              <!-- <input type="number" style="width: 46%; text-align: center" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1"  *ngIf="config.title == 'Deera'"
              (input)="changeDeeraValue(i, $event)" [(ngModel)]="cart.quantity" /> -->
              <!-- <input type="number" style="width: 46%; text-align: center" onkeypress="return event.charCode >= 48"
      (input)="changeBabyVarValue(appService.productIdinCart.indexOf(price.id),$event)" inputmode="numeric" pattern="[0-9]*"  onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" /> -->
      <span class="inq-sp-2 baby_top"
      style="padding-left: 10px;
padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span> 
      <span class="baby_top"><i class="fa fa-plus mr-2 " style="font-size: 12px; cursor: pointer;padding-left: 7px;"
              (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>


        </div>
        
    </div>
  </div>
    <span *ngIf="
(config.title === 'KatbookStore' && product.product_type=='Variable')
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px; width: 30%;
">
<button class="cartButtonvarbaby2" (click)="buyNowBaby()">
Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
</span>
<!-- <div class="flex_kat">
  <div class="Kat_widre">
<span *ngIf="config.title == 'KatbookStore'" class="wid_katAdd">
  <button class="cartButtonvarkat" [disabled]="isDisabled"
    (click)="addtocartVistas(product)" *ngIf="
  (appService.productIdinCart.indexOf(newProductDetails.id) ==
    -1 ) ||
  (showSize &&
    appService.productIdinCart.indexOf(checkVariantInCart) ==
      -1)
">
    Add to Purchase List
    <span> <i class="fa fa-shopping-cart"></i></span>
  </button>
  
</span>

<div class="vistas-addbutton wid_katAdd"
*ngIf="(appService.productIdinCart.indexOf(newProductDetails.id) != -1 || appService.productIdinCart.indexOf(checkVariantInCart) != -1)">
<div *ngFor="let cart of appService.cartProducts.results; let i = index">
  <span *ngIf="config.title === 'KatbookStore' ">
    <div class="cartButtonvarkatplus"
      *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
      <span>
        <i class="fa fa-minus mr-2" (click)="decreaseItemVistas(i)"
          style="font-size: 12px; cursor: pointer"></i></span>

      <span class="inq-sp-2" style="color: white;margin-left:10px;margin-right:10px;">{{ cart.quantity }}</span>
      <span>
        <i class="fa fa-plus ml-2" (click)="increaseItemVistas(i)"
          style="font-size: 12px; cursor: pointer"></i></span>
    </div>
  </span>
</div>
</div> 
</div>
<span *ngIf="
(config.title === 'KatbookStore')
" class="Kat_added_cart">
<button class="cartButtonvarkat2" (click)="buyNowBaby()">
Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
</div> -->
<!-- <span *ngIf="config.title === 'KatbookStore' && product.product_type=='Variable'" class="cartaddfun">
  <div class="babycar">
  <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
  justify-content: center;">

    <button class="cartButtonvarkat" (click)="addToCartBaby(price.id)">
    Add to Cart
    </button>   
    
    <div class="baby_detail_view" style="position: relative;
        min-width: fit-content;" *ngIf="appService.productIdinCart.indexOf(price.id) >=0">
        
          <span class="baby_top"><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
              (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
      <span class="inq-sp-2 baby_top"
      style="padding-left: 10px;
padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span> 
      <span class="baby_top"><i class="fa fa-plus mr-2 " style="font-size: 12px; cursor: pointer;padding-left: 7px;"
              (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>


        </div>
        
    </div>
  </div>
    
</span>  -->
                  <span *ngIf="config.title === 'Babys Pride' && product.product_type=='Variable'" class="cartaddfun">
                    <div class="babycar">
                    <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
                    justify-content: center;">
  
                      <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="cartButtonvarbaby" (click)="addToCartBaby(price.id)">
                      Add to Cart
                      </button>   
                      
                      <div class="baby_detail_view" style="position: relative;
                          min-width: fit-content;" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
                          
                            <span class="baby_top"><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                                (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                                <!-- <input type="number" style="width: 46%; text-align: center" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1"  *ngIf="config.title == 'Deera'"
                                (input)="changeDeeraValue(i, $event)" [(ngModel)]="cart.quantity" /> -->
                                <!-- <input type="number" style="width: 46%; text-align: center" onkeypress="return event.charCode >= 48"
                        (input)="changeBabyVarValue(appService.productIdinCart.indexOf(price.id),$event)" inputmode="numeric" pattern="[0-9]*"  onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" /> -->
                        <span class="inq-sp-2 baby_top"
                        style="padding-left: 10px;
                  padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span> 
                        <span class="baby_top"><i class="fa fa-plus mr-2 " style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                                (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
        
        
                          </div>
                          
                      </div>
                    </div>
                      <span *ngIf="
(config.title === 'Babys Pride' && product.product_type=='Variable')
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px; width: 30%;
">
<button class="cartButtonvarbaby2" (click)="buyNowBaby()">
  Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
</span>   
                  <hr style="border: none;
border-top: 1px dotted #f00;
color: #fff;
background-color: #fff;" *ngIf="config.title === 'Babys Pride'"/>
<h4 style="font-size: 14px;font-weight: 500;text-align: center;font-family: system-ui;" *ngIf="config.title === 'Babys Pride'">MATERIALS , FABRIC & ORIGIN</h4>
<hr style="border: none;
border-top: 1px dotted #f00;
color: #fff;
background-color: #fff;" *ngIf="config.title === 'Babys Pride'"/>
<div style="display: flex;" *ngIf="config.title === 'Babys Pride'">
  <a (click)="windowOpen(facebookLink)" style="cursor: pointer;"><img src="../../../../../assets/images/babyspride/facebook1.png" alt="" style="width: 20px;margin-right: 10px;cursor: pointer;" ></a>
  <a (click)="windowOpen(twitterLink)" style="cursor: pointer;"><img src="../../../../../assets/images/babyspride/twitter1.png" alt="" style="width: 20px;margin-right: 10px;cursor: pointer;"></a>
  <a (click)="windowOpen(whatsappLink)" style="cursor: pointer;"><img src="../../../../../assets/images/babyspride/whatsapplogo1-removebg-preview.png" alt="" style="width: 20px;margin-right: 10px;cursor: pointer;"></a>
  <a (click)="windowOpen(instagramLink)" style="cursor: pointer;"><img src="../../../../../assets/images/babyspride/instagram1.png" alt="" style="width: 20px;"></a>
</div>
<!-- <h4  *ngIf="config.title === 'Babys Pride'" style="margin-top: 10px ;color: #6a975c; font-size: 15px; font-weight: 400;font-family: system-ui;">CHECK PINCODE FOR DELIVERY</h4>
<div *ngIf="config.title === 'Babys Pride'" class="desktop-only">
<input type="text" placeholder="Enter Your Pincode" class="email" style="width: 35%;height: 30px;">
                    <button class="vimpro-subbtn" style="background-color: #6a975c;border: none;width: 50px;height: 30px;width: 12%;margin-left: 5px;">
                        <p style="
                        color: white;">Check</p>
                    </button>
                  </div>
                  <div *ngIf="config.title === 'Babys Pride'" class="mobile-only">
                    <input type="text" placeholder="Enter Your Pincode" class="email" style="width: 40%;height: 30px;">
                                        <button class="vimpro-subbtn" style="background-color: #6a975c;border: none;width: 50px;height: 30px;width: 18%;margin-left: 5px;">
                                            <p style="
                                            color: white;">Check</p>
                                        </button>
                                      </div> -->
                  <div *ngIf="config.title === 'Babys Pride'">
                    <div style="display: flex; margin-top: 10px;">
                      <img src="../../../../../assets/images/babyspride/return.png" alt="" style="width: 20px;height: 20px;">
                      <p style="font-family: system-ui;font-size: 13px; color: #6c6868;margin-left: 10px;font-weight: 500;">15 days return policy</p>
                    </div>
                    <div style="display: flex; margin-top: 10px;">
                      <img src="../../../../../assets/images/babyspride/newstyle.png" alt="" style="width: 20px;height: 20px;">
                      <p style="font-family: system-ui;font-size: 13px; color: #6c6868;margin-left: 10px;font-weight: 500;">New styles every week</p>
                    </div>
                    <div style="display: flex; margin-top: 10px;">
                      <img src="../../../../../assets/images/babyspride/easycheck.png" alt="" style="width: 20px;height: 20px;">
                      <p style="font-family: system-ui;font-size: 13px; color: #6c6868;margin-left: 10px;font-weight: 500;">Easy checkout with multiple payment options</p>
                    </div>

                  </div>
                  <span *ngIf="
(config.title === 'Deera' && product.product_type=='Simple' && product.stock_status=='Available' &&
  appService.productIdinCart.indexOf(newProductDetails.id) ==
    -1 &&
  !showSize)
" style="
font-size: 16px !important;
color: grey !important;
margin-left: 5px;
">
<button class="btn btn-primary inq-btn-st ml-1" (click)="buyNow()">
  Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


</span>
<span *ngIf="config.title == 'Deera'&&product.stock_status=='Out of Stock'">
<span style="color: #2554c7;font-weight: 700;font-size: x-large;">Out of Stock </span>
</span>
                  <span *ngIf="config.title == 'Karupattiraja' && product.pricing.raw.price>0 &&product.stock_status=='Available'">
                    <button class="btn btn-primary inq-btn-st ml-1 cartButton2" [disabled]="isDisabled"
                      (click)="addtocartKarupatti()" *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  ">
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                  </span>
                  <span *ngIf="config.title == 'Karupattiraja'&&(product.pricing.raw.price<=0||product.stock_status!='Available')">
                   <p style="font-size: 27px;
                   color: #3c707c;
                   font-weight: 600!important;">Out of Stock</p>
                  </span>
                  <div style="display: flex;" *ngIf="config.title === 'Vistas'">
                  <span *ngIf="config.title == 'Vistas'">
                    <button class="btn btn-primary inq-btn-st ml-1 button-62 button_vistas" [disabled]="isDisabled"
                      (click)="addtocartVistas(product)" *ngIf="
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  ">
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                    
                  </span>

                  <div class="vistas-addbutton"
                  *ngIf="(appService.productIdinCart.indexOf(newProductDetails.id) != -1 || appService.productIdinCart.indexOf(checkVariantInCart) != -1)">
                  <div *ngFor="let cart of appService.cartProducts.results; let i = index">
                    <span *ngIf="config.title === 'Vistas' ">
                      <div class="btn btn-primary inq-btn-st ml-1  vistas-detailadd" style=" background:linear-gradient(to bottom right,#0095da,#33507a);"
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <span>
                          <i class="fa fa-minus mr-2" (click)="decreaseItemVistas(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                            <input type="number" style="width: 40%; text-align: center"  onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1" 
                            (input)="changeVistasValue(i, $event)" [(ngModel)]="cart.quantity" />
                        <!-- <span class="inq-sp-2" style="color: white;margin-left:10px;margin-right:10px;">{{ cart.quantity }}</span> -->
                        <span>
                          <i class="fa fa-plus ml-2" (click)="increaseItemVistas(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                      </div>
                    </span>
                  </div>
                  </div>
                  <span *ngIf="config.title === 'Vistas' && appService.productIdinCart.indexOf(newProductDetails.id) ==
                  -1 &&
                !showSize" style="font-size: 16px !important;color: grey !important;margin-left: 5px;">
                  <button class="btn btn-primary inq-btn-st ml-1 button-62" [disabled]="isDisabled" (click)="buyNow2()">
                    Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>
                </span>
                <span *ngFor="let cart of appService.cartProducts.results; let i = index" style="font-size: 16px !important;color: grey !important; margin-left: 5px;">

                  <div *ngIf="(config.title === 'Vistas') && (cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart)">
                      <button class="btn btn-primary inq-btn-st ml-1 button-62" [disabled]="isDisabled"  (click)="buyNow1()">
                        Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>
                      </div>

                    </span>
              </div>
                  <!-- <span *ngIf="config.title == 'Vistas'&&(product.pricing.raw.price<=0||product.stock_status!='Available')">
                   <p style="font-size: 27px;
                   color: #3c707c;
                   font-weight: 600!important;">Out of Stock</p>
                  </span> -->
                  <div *ngIf="config.title === 'AvonSeals'" style="margin-top: 2%;">
                    <h5 style="font-size: 18px!important;"> <span style="color:#f33601">Price:</span> ₹ {{avonSealsPrice}}</h5>
                    <h5 style="font-size: 18px!important;"> <span style="color:#f33601">Application:</span> {{avonSealsDescription}}</h5>
                    <h5 style="font-size: 18px!important;"> <span style="color:#f33601">Weight:</span> {{avonSealsWeight}} (gm)per piece</h5>
                  </div>
                  <div *ngIf="config.title === 'AvonSeals'" class="cartscr">    
                    <div class="listdetail">   
                    <h5 style="color:#f33601">Avon Part No</h5>
                      <div class="dropdown">
                        <button class="dropdown-toggle dropdownstyle1" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:
                        100%">
                      <span class="droptext">{{product.variant.option_values[current_index].option}}</span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                      style="position: absolute;
                      transform: translate3d(8px, -75px, 0px);
                      top: 0px;
                      left: 0px;
                      max-height: 150px;
                      overflow-y: scroll;
                      will-change: transform;width: 100%;">
                      <a *ngFor="let size of product.variant.option_values;let j=index"
                        (click)="selectOptionAvonSeals(size.option,product.id,j)"
                        class="dropdown-item">{{size.option}}</a>
                    </div>
                    </div>
                    </div>
                  <!-- </div> -->
                  <!-- <div class="" style="display: flex; justify-content: center;"
                  *ngFor="let price of product.variant.option_values[current_index];let i = index"> -->
                  
                  <div class="" style=" width: 100%; margin-left: auto;margin-right: auto;"
                  *ngFor="let price of product.variant.option_values;let i = index">
                  <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
                  -1" class="btn btn-primary inq-btn-st ml-1 avon-detail-cart" style="margin-bottom: 12px!important;"
                    (click)="addToCartAvonSeals(price.id)">
                    <!-- {{price.id}} -->
                    <!-- {{ groups[1].fields[0].labelname }} -->
                    ADD TO CART
                    <span> <i class="fa fa-shopping-cart"></i></span>
                  </button>

                  <!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
                  <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="position: relative;
                  min-width: fit-content;
                  margin-top: 20px; width: 160px" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
                    <!-- {{price.id}} -->
                    <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                        (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                        <!-- <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1" 
                              (input)="changeAvonSealsValue(appService.productIdinCart.indexOf(price.id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" /> -->
                              
                              <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1" 
                              (input)="changeAvonSealsValue(appService.productIdinCart.indexOf(price.id),$event)"  inputmode="numeric" pattern="[0-9]*"  onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" />
                    <!-- <span class="inq-sp-2"
                      style="padding-left: 10px;
                padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span> -->
                    <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                        (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>


                  </div>

                </div>
               
                <!-- <div *ngIf="config.title === 'AvonSeals'" style="margin-top: 2%;margin-left:21%">
                  <h5 style="font-size: 18px!important;"> <span style="color:#f33601">Price:</span> ₹{{avonSealsPrice}}</h5>
                </div> -->
              </div>
              <div *ngIf="config.title === 'LinenRaj'" class="cartscr">    
                <div class="listdetail" style="display: flex;margin-top: 30px;">
                 <div>
                  <label for="part"><strong>Size</strong></label>
                  <!-- <div class="dropdown">
                    <p style="color: #f33601; font-size: 14px;">select size</p>
                    <button class="dropdown-toggle dropdownstyle1 dropspecial1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Size
                    </button>
                    <div class="dropdown-menu special_click" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
                      <a *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionSpecialWires1(size.option,product.id,j)" class="dropdown-item special-dropitem">{{size.option}}</a>
                    </div>
                    </div> -->
                    <!-- <div style="width:50%">
                      <button class="dropdown-toggle dropdownstyle1 dropspecial1" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{product.variant.option_values[current_index].option}}
                      </button>
                      <div class="dropdown-menu special-dropdownmenu" aria-labelledby="dropdownMenuButton">
                        <a *ngFor="let size of product.variant.option_values;let j=index"
                          (click)="selectOptionCarience(size.option,product.id,j)"
                          class="dropdown-item special-dropitem">{{size.option}}</a>
                      </div>
                    </div> -->
                    <div
                class="colour-select-image" style="margin-left:15px;margin-right: -16px;display: flex; margin-bottom: 50px;width: 100%;">

                <button *ngFor="let size of product.variant.option_values;let j=index"
                          (click)="selectOptionLinenRaj(size.option,product.id,j)" style="display: flex;justify-content: center;width:13%;margin-right: 35px;border: 2px solid #a77737!important"
                          class="dropdown-item special-dropitem">{{size.option}}</button>
              </div>
                    </div>
                  </div>
                  <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
                  justify-content: center;">

                    <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="button-62 special-addtocart" (click)="addToCartLinenRaj(price.id)" >
                    Add to Cart
                    </button>   
                    
                    
                    <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="position: relative;
                        min-width: fit-content;
                        margin-top: 20px; width: 160px" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
                        
                          <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                              (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                          <span class="inq-sp-2"
                            style="padding-left: 10px;
                      padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
                          <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                              (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
      
      
                        </div>
                       
                    </div>
                    <!-- <div class="row" style="justify-content: space-around !important; margin-left: 20px;"*ngIf="config.title == 'LinenRaj'">
                                            
                                            
                      <div class="col-4" style="max-width: 23% !important;">
                        <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/delivery-status.png?v=1660022911" width="40px" style="box-shadow: none;">
                        <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">60 Day Returns</p>
                      </div>
            
                      <div class="col-4" style="max-width: 23% !important;">
                        <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/delivery-truck.png?v=1660022911" width="40px" style="box-shadow: none;">
                        <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">Free Shipping</p>
                      </div>
            
                      <div class="col-4" style="max-width: 23% !important;">
                        <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-cash-on-delivery.png?v=1677139182" width="40px" style="box-shadow: none;">
                        <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">Cash On Delivery</p>
                      </div>
                      
                    </div> -->

                    <div class="delivery-option">
              
                <form [formGroup]="detailForm" *ngIf="config.title !== 'LinenRaj'">
                <h6 style="margin-top: 30px;margin-bottom: 15px;">
                  CHECK DELIVERY <span> <i class="fa fa-truck"></i></span>
                </h6>
                <!-- <div class="inner-html-list" *ngIf="config.title == 'Accel'" [innerHTML]="shortDescription"></div> -->
                <div style="margin-left: 20%;">
                <input id="zipcode" class="zipcode" formControlName="zipcode"
                  [class.is-invalid]="validateForm && f.zipcode.errors" type="text" value="" style="height: 40px" />

                <button class="btn btn-primary inq-btn-st ml-1" (click)="checkServiceAvailablity()">
                  Check<span *ngIf="showSpinner" class="spinner-border spinner-border-sm" style="
                      margin-left: 20px !important;
                      padding-top: 10px !important;
                    "></span>
                </button>
              </div>
                <br/>
                <div class="invalid-feedback" *ngIf="f.zipcode.errors">
                  <div *ngIf="f.zipcode.errors.minlength">Invalid Pincode</div>
                  <div *ngIf="f.zipcode.errors.pattern">Invalid Pincode</div>
                  <div *ngIf="f.zipcode.errors.maxlength">Invalid Pincode</div>
                </div>
                <label class="hint-message note zipcode-nonavailable" *ngIf="notAvailableLocation">We are currently not
                  delivering at this location</label>
                <label class="hint-message note zipcode-available" *ngIf="availableLocation">Delivery available
                  <br/>
                  <span class="hint-message addSize" style="font-size: large; color: black; font-weight: normal">
                    Get it by </span><span class="estd-delivery">{{ estdDelivery }}</span></label><br/>
              </form>
              
            </div>
            <!-- <div class="social-wrapper">
              <h6 class="text-light ml__10 mb__10" style="color: black !important;font-family: 'Lato', sans-serif !important;
              text-transform: uppercase;
              letter-spacing: 2.5px !important;
              font-size: 10px !important;
              margin-left: 20px;
              font-weight: 600 !important; margin-top: 10px;">Share</h6>
              <a data-no-instant="" rel="noopener noreferrer nofollow" href="https://www.facebook.com/sharer/sharer.php?u=https://www.andamen.com/products/lilac-grid-linen" target="_blank" class="facebook cb ttip_nt tooltip_top" data-bss-pl="active" data-position="5">
                  
                  <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/002-facebook_986e113b-f806-4c65-b6fd-e0d3e8809ad3.png?v=1646371857" style="height: 23px;margin-left: 20px; box-shadow: none;">
               </a><a data-no-instant="" rel="noopener noreferrer nofollow" href="mailto:?subject=Lilac%20Grid%20Linen&amp;body=https://www.andamen.com/products/lilac-grid-linen" target="_blank" class="email cb ttip_nt tooltip_top" data-bss-pl="active" data-position="6">
                  
                  <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-email.png?v=1646371636" style="height: 27px;margin-left: 20px; box-shadow: none;">
               </a><a data-no-instant="" rel="nofollow" target="_blank" class="whatsapp cb ttip_nt tooltip_top" href="https://wa.me/?text=Lilac%20Grid%20Linen https://www.andamen.com/products/lilac-grid-linen" data-bss-pl="active" data-position="7"> 
                  
                   <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-whatsapp.png?v=1646371846" style="height: 21px;margin-left: 20px; box-shadow: none;">
                </a></div> -->
                </div>

            </div>
            
           
             <!-- <div *ngIf="config.title === 'AvonSeals'" style="margin-top: 2%;margin-left:21%">
              <h5 style="font-size: 18px!important;"> <span style="color:#f33601">Price:</span> ₹{{avonSealsPrice}}</h5>
            </div> -->
            
           
          </div>
              <div *ngIf="newProductDetails.product_type=='Variable' && config.title === 'SpecialWires'" class="cartscr">    
                <div class="listdetail" style="display: flex;">
                 <div>
                  <label for="part"><strong>Size</strong></label>
                  <div class="dropdown"  *ngIf="current_index==-1">
                    <p style="color: #f33601; font-size: 14px;">select size</p>
                    <button class="dropdown-toggle dropdownstyle1 dropspecial1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Size
                    </button>
                    <div class="dropdown-menu special_click" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
                      <a *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionSpecialWires1(size.option,product.id,j)" class="dropdown-item special-dropitem">{{size.option}}</a>
                    </div>
                    </div>
                  <div class="dropdown" style="width:50%" *ngIf="product.variant.option_values !=0">
                    <button class="dropdown-toggle dropdownstyle1 dropspecial1" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" *ngIf="current_index!=-1">
                      {{product.variant.option_values[current_index].option}}
                    </button>
                    <div class="dropdown-menu special-dropdownmenu" aria-labelledby="dropdownMenuButton">
                      <a *ngFor="let size of product.variant.option_values;let j=index"
                        (click)="selectOptionCarience(size.option,product.id,j)"
                        class="dropdown-item special-dropitem">{{size.option}}</a>
                    </div>
                  </div>
                </div>
                <!-- <div class="select_quantity">
                <p *ngFor="let price of product.variant.option_values[current_index!=null?current_index:0].child;let i = index">{{price.type}}</p>
              </div>   -->
              <div style="margin-left: 85px"  *ngIf="current_index!=-1">
              <label for="part"><strong>Weight : </strong></label>
              <div class="dropdown" style="width:50%">
                <button class="dropdown-toggle dropdownstyle1 dropspecial1" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{product.variant.option_values[current_index].child[child_index].type}}
                </button>
                <div class="dropdown-menu special-dropdownmenu" aria-labelledby="dropdownMenuButton">
                  <a *ngFor="let weight of product.variant.option_values[current_index!=null?current_index:0].child;let k=index"
                    (click)="selectColour(weight.type,product.id,k)"
                    class="dropdown-item special-dropitem">{{weight.type}}</a>
                </div>
              </div>
            </div>
            </div>
           
            <!-- <div class="" *ngFor="let price of product.variant.option_values[current_index!=-1?current_index:0].child;let i = index">
              <div *ngFor="let rate of appService.cartProducts.results;let j = index">
              <button *ngIf="(rate.product_id !== price.id)" class="button-62 special-addtocart" [disabled]="current_index==-1" (click)="addToCartSpecialWires(price.id)" >
              Add to Cart
              </button>
              </div>   
              <div *ngFor="let rate of appService.cartProducts.results;let j = index">
              <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="position: relative;
                  min-width: fit-content;
                  margin-top: 20px; width: 160px" *ngIf="(rate.product_id == price.id)">
                    <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                        (click)="decreaseItemSpecial(appService.productIdinCart.indexOf(price.id))"></i></span>
                       
                              <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1" 
                              (input)="changeSpecialValue(appService.productIdinCart.indexOf(price.id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" />
                    <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                        (click)="increaseItemSpecial(appService.productIdinCart.indexOf(price.id))"></i></span>


                  </div>
                </div>
              </div> -->

              <div *ngIf="current_index==-1">
                <button class="button-62" [disabled]="current_index==-1" style="margin-left: 79px;margin-top: 10px;" >
                Add to Cart
                </button>  
               </div>
               <div *ngIf="current_index!==-1">
              <div *ngFor="let price of product.variant.option_values[current_index!=-1?current_index:0].child;let i = index">
                 <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id) ==
                 -1" class="button-62 special-addtocart" [disabled]="current_index==-1" (click)="addToCartSpecialWires(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id )" >
                 Add to Cart
                 </button>
               </div>
               <div *ngFor="let rate of appService.cartProducts.results;let j = index">
                 <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="position: relative; min-width: fit-content; margin-top: 20px; width: 160px"
                  id="quantity_button" *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id) != -1 && (rate.product_id == product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id)">
                 <span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItemSpecial(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id))"></i></span>
                 <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1"
                 (input)="changeSpecialValue(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=-1?child_index:0].id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id)].quantity" />
                  <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItemSpecial(appService.productIdinCart.indexOf(product.variant.option_values[current_index!=-1?current_index:0].child[child_index!=null?child_index:0].id))"></i></span>
                 </div>
               </div>
                </div>
                 <!-- </div> -->
             <!-- <div *ngIf="config.title === 'AvonSeals'" style="margin-top: 2%;margin-left:21%">
              <h5 style="font-size: 18px!important;"> <span style="color:#f33601">Price:</span> ₹{{avonSealsPrice}}</h5>
            </div> -->
            
           
          </div>
                  <span *ngIf="config.title === 'Mayan' ">
                    <button class="btn btn-primary inq-btn-st ml-1 cartButton cardbutton-12" (click)="addTocart()" *ngIf="product.pricing.raw.price &&
                    (appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)
                  ">

                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                    <div *ngIf=" !product.pricing.raw.price && config.title=='Mayan'"
                      style="font-size: 16px;font-weight: 300;">
                      We will update soon
                    </div>


                  </span>

                  <!-- bestgifts add to cart modal trigger -->
                  <span *ngIf="config.title == 'BestGifts'">
                    <!-- <button data-toggle="modal" 
                      class="btn btn-primary inq-btn-st ml-1 cartButton" (click)="redirectLogin()" [disabled]="isDisabled" *ngIf="!customer_id &&
                    ((appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)) && (numberOfMaskUploads > 0)"
                    >
                      Add to Cart
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button> -->
                    <!-- <button data-toggle="modal" data-target="#bestGiftsUploadModal"
                    class="btn btn-primary inq-btn-st ml-1 cartButton" (click)="closeModalWithRefresh()" [disabled]="isDisabled" *ngIf="customer_id &&
                  ((appService.productIdinCart.indexOf(newProductDetails.id) ==
                    -1 ) ||
                  (showSize &&
                    appService.productIdinCart.indexOf(checkVariantInCart) ==
                      -1)) && (numberOfMaskUploads > 0)"
                  >
                    {{ groups[1].fields[0].labelname }}
                    <span> <i class="fa fa-shopping-cart"></i></span>
                  </button> -->

                  <button data-toggle="modal" data-target="#bestGiftsUploadModal"
                  class="btn btn-primary inq-btn-st ml-1 cartButton best_cart_button" (click)="closeModalWithRefresh()" [disabled]="isDisabled" *ngIf="((appService.productIdinCart.indexOf(newProductDetails.id) ==
                  -1 ) ||
                (showSize &&
                  appService.productIdinCart.indexOf(checkVariantInCart) ==
                    -1)) && (numberOfMaskUploads > 0)"
                >
                  {{ groups[1].fields[0].labelname }}
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>

                    <button
                      class="btn btn-primary inq-btn-st ml-1 cartButton" (click)="addTocart()" [disabled]="isDisabled" *ngIf="
                    ((appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 ) ||
                    (showSize &&
                      appService.productIdinCart.indexOf(checkVariantInCart) ==
                        -1)) && (numberOfMaskUploads == 0)"
                    >
                      {{ groups[1].fields[0].labelname }}
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                  </span>
                  
                  <span *ngIf="
                      ((config.title === 'Deera') &&
                        appService.productIdinCart.indexOf(
                          newProductDetails.id
                        ) == -1 &&
                        !showSize) ||
                      (showSize &&
                        appService.productIdinCart.indexOf(checkVariantInCart) ==
                          -1)
                    " style="
                      font-size: 16px !important;
                      color: grey !important;
                      margin-left: 5px;
                    " class="innerHTML" [innerHTML]="upsellBannerMessage"></span>

                </div>

                <div *ngIf="config.title =='BombayHardware'">
                  <hr class="desktop-only">
                  <div>
                    <div><a>Subproduct: {{ product.subname | titlecase }}</a></div>
                  </div>
                  <hr>
                  <div *ngIf="product.dropdown_consider.length==1"
                    style="position: relative; left: -4%; width: 40%;height:50px">
                    <div *ngIf="product.childs.type !=0">
                      <div class="dropdown dropdownstyle1">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          type
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                          style="min-width: 80%;max-width: fit-content;">
                          <a *ngFor="let size of product.childs.type" (click)="selectOption1(size.value)"
                            class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.size !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <div
                            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">
                            {{ product.size[0]}}{{product.dropdown_consider[0]}}
                          </div>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                          style="min-width: 80%;max-width: fit-content;">
                          <a *ngFor="let size of product.childs.size" (click)="selectOption1(size.value)"
                            class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.size_pipe !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          {{product.size[0]}}{{product.dropdown_consider[0]}}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                          style="min-width: 80%;max-width: fit-content;">
                          <a *ngFor="let size of product.childs.size_pipe;let i = index" class="dropdown-item">
                            <div *ngIf="product.dropdown_consider == 'inch'" (click)="selectOption1(size.inch)">
                              {{ size.inch }}
                            </div>
                            <div *ngIf="product.dropdown_consider == 'mm'" (click)="selectOption1(size.mm)">
                              {{ size.mm }}
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.size_ml !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          {{product.size[0]}}{{product.dropdown_consider[0]}}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                          style="min-width: 80%;max-width: fit-content;">
                          <a *ngFor="let size of product.childs.size_ml" (click)="selectOption1(size.value)"
                            class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.size_pn !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          {{product.size[0]}}{{product.dropdown_consider[0]}}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                          style="min-width: 80%;max-width: fit-content;">
                          <a *ngFor="let size of product.childs.size_pn;let i = index" class="dropdown-item">
                            <div *ngIf="product.dropdown_consider == 'pn'" (click)="selectOption1(size.pn)">
                              {{ size.pn }}
                            </div>
                            <div *ngIf="product.dropdown_consider == 'mm'" (click)="selectOption1(size.mm)">
                              {{ size.mm }}
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.diameter !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          {{product.size[0]}}{{product.dropdown_consider[0]}}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                          style="min-width: 80%;max-width: fit-content;">
                          <a *ngFor="let size of product.childs.diameter" (click)="selectOption1(size.value)"
                            class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                    </div>

                    <div class="bombayhardware-submit-btn" style="position: relative; left: 100%; margin-top: -3%;">
                      <button class="bh-temp-cart btn btn-primary shubhcards-btn atc-details1"
                        *ngIf="!this.appService.subProductinCart.includes(product.subname)"
                        [disabled]="selectedboth==false || product.name==product.subname"
                        (click)="addSubProduct(product)">
                        Add to Cart
                      </button>

                      <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
                        <div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
                          <div *ngFor="let c of cart.subcart;let j= index">
                            <div class="btn btn-primary inq-btn-st ml-1 bombayViewCart-details1"
                              *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
                              <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j)"
                                  style="font-size: 12px; cursor: pointer"></i></span>
                              <input type="number" class="inq-sp-2 bombay-input-details"
                                [(ngModel)]="cart.subquantity[j]" (input)="minQuantity0(i,j,$event)">
                              <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j)"
                                  style="font-size: 12px; cursor: pointer"></i></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <a *ngIf="(product.size.length==0)"
                      class="select-size1">Select&nbsp;{{product.dropdown_consider[0]}}</a>
                  </div>

                  <div *ngIf="product.dropdown_consider.length==2" class="dropdown2-container">
                    <div *ngIf="product.childs.type !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle-default"
                          type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                          aria-expanded="false" style="width:120px !important">
                          <div
                            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">
                            {{product.size[0]}}{{product.dropdown_consider[1]}}
                          </div>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.type" (click)="selectFirstSCH(size.sch_value)"
                            class="dropdown-item">{{size.sch_value}}</a>
                        </div>
                      </div>
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle2-details"
                          type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                          aria-expanded="false" style="width:120px !important;">
                          <div
                            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">
                            {{product.size[1]}}{{product.dropdown_consider[0]}}
                          </div>

                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.type">
                            <div *ngIf="size.sch_value == selectedSCH">
                              <div *ngFor="let v of size.values" class="dropdown-item">
                                <div *ngIf="product.dropdown_consider[0] == 'inch'" (click)="selectSecondSCH(v.inch)">
                                  {{ v.inch }}
                                </div>
                                <div *ngIf="product.dropdown_consider[0] == 'mm'" (click)="selectSecondSCH(v.mm)">
                                  {{ v.mm }}
                                </div>
                                <div
                                  *ngIf="product.dropdown_consider[0] == 'Thickness/Class' || product.dropdown_consider[0] == 'Thickness'"
                                  (click)="selectSecondSCH(v.Thickness)">
                                  {{ v.Thickness }}
                                </div>
                                <div *ngIf="product.dropdown_consider[0] == 'class'" (click)="selectSecondSCH(v.class)">
                                  {{ v.class }}
                                </div>
                                <div *ngIf="product.dropdown_consider[0] == 'SCH'" (click)="selectSecondSCH(v.sch)">
                                  {{ v.sch }}
                                </div>
                              </div>
                            </div>
                          </a>
                          <div *ngIf="product.size.length!=3">
                            <div class="dropdown-item">
                              <div>
                                Select {{product.dropdown_consider[1]}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.size !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          size
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          sch
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.size_pipe !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          size_pipe
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          sch
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.size_ml !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          size_ml
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          sch
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.size_pn !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          {{product.size[0]}}{{ product.dropdown_consider[0] }}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size_pn" class="dropdown-item">
                            <div *ngIf="product.dropdown_consider[0] == 'inch'"
                              (click)="selectFirst(size.inch,product.id)">
                              {{ size.inch }}
                            </div>
                            <div *ngIf="product.dropdown_consider[0] == 'mm'" (click)="selectFirst(size.mm,product.id)">
                              {{ size.mm }}
                            </div>
                            <div *ngIf="product.dropdown_consider[0] == 'pn'" (click)="selectFirst(size.pn,product.id)">
                              {{ size.pn }}
                            </div>
                          </a>
                        </div>
                      </div>
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle2-details"
                          type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                          aria-expanded="false" style="width:120px !important">
                          {{product.size[1]}}{{product.dropdown_consider[1]}}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size_pn" class="dropdown-item">
                            <div *ngIf="product.dropdown_consider[1] == 'inch'"
                              (click)="selectSecond(size.inch,product.id)">
                              {{ size.inch }}
                            </div>
                            <div *ngIf="product.dropdown_consider[1] == 'mm'"
                              (click)="selectSecond(size.mm,product.id)">
                              {{ size.mm }}
                            </div>
                            <div *ngIf="product.dropdown_consider[1] == 'pn'"
                              (click)="selectSecond(size.pn,product.id)">
                              {{ size.pn }}
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="product.childs.diameter !=0">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          dia
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          style="width:120px !important">
                          sch
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                        </div>
                      </div>
                    </div>

                    <div class="bh-submit">
                      <button class="bh-temp-cart btn btn-primary shubhcards-btn atc-details"
                        *ngIf="!this.appService.subProductinCart.includes(product.subname)"
                        [disabled]="selectedboth==false || product.name==product.subname"
                        (click)="addSubProduct(product)">
                        Add to Cart
                      </button>

                      <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
                        <div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
                          <div *ngFor="let c of cart.subcart;let j= index">
                            <div class="btn btn-primary inq-btn-st ml-1 bombayViewCart-details"
                              *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
                              <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j)"
                                  style="font-size: 12px; cursor: pointer"></i></span>
                              <input type="number" class="inq-sp-2 bombay-input-details"
                                [(ngModel)]="cart.subquantity[j]" (input)="minQuantity0(i,j,$event)">
                              <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j)"
                                  style="font-size: 12px; cursor: pointer"></i></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <a *ngIf="(product.size.length==0)"
                      class="select-size2">Select&nbsp;{{product.dropdown_consider[1]}}</a>
                    <a *ngIf="product.size[1]==''"
                      class="select-size2-1">Select&nbsp;{{product.dropdown_consider[0]}}</a>
                  </div>


                </div>
                <hr *ngIf="config.title == 'Schift Cosmetics'">
                <div *ngIf="config.title == 'Schift Cosmetics'"><h6 class="schift-key-descti"> Key Ingredients: </h6><span class="schift-key-desc" [innerHTML]="Description"></span></div>
                <!-- !important keep these values at 100%  -->
                <div style="width: 100%;"
                  *ngIf="(appService.productIdinCart.indexOf(newProductDetails.id) != -1 || appService.productIdinCart.indexOf(checkVariantInCart) != -1) && (config.title!=='BombayHardware')&& (config.title!=='Carience') && (config.title !== 'Vimpro')&& (config.title !== 'AvonSeals')   && (config.title !== 'SpecialWires')">
                  <div style="width: 86%;" *ngFor="let cart of appService.cartProducts.results; let i = index">
                    <span class="shub-d-flex" *ngIf="config.title !== 'BestGifts' && config.title !== 'Mayan'&& config.title !== 'Karupattiraja' && config.title !== 'Vistas' && config.title !=='Schift Cosmetics' && config.title !=='Taazah' && product.product_type=='Simple'">
                      <div class="pad-top border-shub btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="width:30%"
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <span>
                          <i class="fa fa-minus mr-2" (click)="decreaseItem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                        <input type="number" style="width: 50%; text-align: center" *ngIf="config.title == 'ShubhCards'"
                          (change)="ChangeValue(i)" [(ngModel)]="cart.quantity" />
                        <input type="number" style="width: 46%; text-align: center" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1"  *ngIf="config.title == 'Deera' && product.product_type=='Simple'"
                          (input)="changeDeeraValue(i, $event)" [(ngModel)]="cart.quantity" />
                        <span class="inq-sp-2" *ngIf="
                            config.title != 'ShubhCards' && config.title != 'Deera' && config.title != 'Babys Pride'
                          " style="color: white">{{ cart.quantity }}</span>
                        <span>
                          <i class="fa fa-plus ml-2" (click)="increaseItem(i)"
                            style="font-size: 12px; cursor: pointer" ></i></span>
                      </div>
                      <button    *ngIf="(cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart) && (config.title == 'ShubhCards' || config.title == 'SriSenbaga')"
                       class="btn btn-primary inq-btn-st ml-1 button-62" [disabled]="isDisabled"  (click)="buyNow2()" style="border-radius: 5px !important;">
                        Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px;"></i></button>
                    </span>
                    <span *ngIf="config.title === 'Karupattiraja' ">
                      <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="width:30%"
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <span>
                          <i class="fa fa-minus mr-2" (click)="decreasekarupattiitem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
            
                        <span class="inq-sp-2" 
                           style="color: white;margin-left:10px;margin-right:10px;">{{ cart.quantity }}</span>
                        <span>
                          <i class="fa fa-plus ml-2" (click)="increaseItem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                      </div>
                    </span>
                    <!-- <span *ngIf="config.title === 'Vistas' ">
                      <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart vistas-detailadd" style="width:30%; background:linear-gradient(to bottom right,#0095da,#33507a);"
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <span>
                          <i class="fa fa-minus mr-2" (click)="decreaseItemVistas(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                            <input type="number" style="width: 40%; text-align: center"  onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1" 
                            (input)="changeVistasValue(i, $event)" [(ngModel)]="cart.quantity" />                        <span>
                          <i class="fa fa-plus ml-2" (click)="increaseItemVistas(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                      </div>
                    </span> -->
                    <span *ngIf="config.title == 'Mayan' && product.pricing.raw.price">
                      <div class="btn btn-primary ml-1 viewCart-mayan viewcard-que " style="margin-bottom: 3px;padding: 10px 0px;"
                        
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <span>
                          <i class="fa fa-minus mr-2" (click)="decreaseItem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>


                        <span class="inq-sp-2" style="color: white">{{ cart.quantity }}</span>
                        <span>
                          <i class="fa fa-plus ml-2" (click)="increaseItem(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                      </div>
                    </span>


                    <span *ngIf="config.title === 'BestGifts' && numberOfMaskUploads > 0">
                      <div class="btn btn-primary inq-btn-st ml-1 viewCart best_view_cart"
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <div style="display: flex; justify-content: center;">
                        <div class="best_after-cart">
                        <span>
                          <i class="fa fa-edit mr-2" data-toggle="modal" id="editButtonBestGifts" data-target="#bestGiftsUploadModal"
                             style="font-size: 12px; cursor: pointer"></i></span>


                        <span class="inq-sp-2" style="color: white">{{ cart.quantity }}</span>
                        <span>
                          <i class="fa fa-plus ml-2" data-toggle="modal" data-target="#bestGiftsUploadModal"
                            (click)="incrementNumberOfProductsForBestGifts()" style="font-size: 12px; cursor: pointer"></i></span>
                          </div>
                        </div>
                      </div>
                      <span *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart"
                        style="
                      font-size: 16px !important;
                      color: grey !important;
                      margin-left: 5px;
                    " (click)="buyNow()">
                        <button class="btn btn-primary inq-btn-st ml-1" (click)="buyNow1()">
                          Checkout</button>
                      </span>
                    </span>

                    <span *ngIf="config.title === 'BestGifts' && numberOfMaskUploads == 0">
                      <div class="btn btn-primary inq-btn-st ml-1 viewCart"
                        style="width: 44% !important;left: 0px!important;"
                        *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart">
                        <span>
                          <i class="fa fa-minus mr-2" (click)="decreaseItem(i)"
                             style="font-size: 12px; cursor: pointer"></i></span>


                        <span class="inq-sp-2" style="color: white">{{ cart.quantity }}</span>
                        <span>
                          <i class="fa fa-plus ml-2"
                            (click)="increaseItemBestGiftsNew(i)" style="font-size: 12px; cursor: pointer"></i></span>
                      </div>
                      <span *ngIf="cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart"
                        style="
                      font-size: 16px !important;
                      color: grey !important;
                      margin-left: 5px;
                    " (click)="buyNow()">
                        <button class="btn btn-primary inq-btn-st ml-1" (click)="buyNow1()">
                          Checkout</button>
                      </span>
                    </span>

                    <span
                      *ngIf="(config.title === 'Deera') && (product.product_type === 'Simple') && (cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart)"
                      style="
                        font-size: 16px !important;
                        color: grey !important;
                        margin-left: 5px;
                      ">


                      <button class="btn btn-primary inq-btn-st ml-1" (click)="buyNow1()">
                        Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>


                    </span>
                    <!-- <span
                      *ngIf="
                        ((config.title === 'BestGifts') && (cart.product_id == newProductDetails.id || cart.product_id === checkVariantInCart))
                      "
                      style="
                        font-size: 16px !important;
                        color: grey !important;
                        margin-left: 5px;
                      "
                      (click)="buyNow()"
                    > -->
                    <!-- <button class="btn btn-primary inq-btn-st ml-1">
                      Checkout</button>  -->
                    <!-- </span> -->
                  </div>
                </div>

                <!-- <span
                *ngIf="
                  (config.title === 'Deera' &&
                    appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 &&
                    !showSize)
                "
                style="
                  font-size: 16px !important;
                  color: grey !important;
                  margin-left: 5px;
                "
                >(Shipping will be calculated based on total quantity at check
                out)</span
              > -->

              </div>
              <span *ngIf="
                  (config.title === 'Deera' &&
                    appService.productIdinCart.indexOf(newProductDetails.id) ==
                      -1 &&
                    !showSize)
                " style="
                  font-size: 16px !important;
                  color: grey !important;
                  margin-left: 5px;
                ">(Shipping will be calculated based on total quantity at check
                out)</span>

              <div *ngIf="config.title == 'ShubhCards' || config.title == 'SriSenbaga'">
                
                  
                  
                <button class="btn  inq-btn-st ml-1 shubhcardscartButton" [disabled]="isDisabled"
                  (click)="addTocart()" *ngIf="(appService.productIdinCart.indexOf(newProductDetails.id) ==-1 && !showSize) ||
                    (showSize && appService.productIdinCart.indexOf(checkVariantInCart) == -1)">
                  {{ groups[1].fields[0].labelname }}
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
                <button  *ngIf="(appService.productIdinCart.indexOf(newProductDetails.id) ==-1 && !showSize) ||
                (showSize && appService.productIdinCart.indexOf(checkVariantInCart) == -1)" class="btn btn-primary inq-btn-st ml-1 button-62" [disabled]="isDisabled"  (click)="buyNow2()" style="border-radius: 5px !important">
                  Buy Now<i class="fa fa-shopping-bag" style="margin-left: 1px"></i></button>
              </div>

              <!---------view cart button-->

              <hr *ngIf="config.title!='Carience' && config.title !== 'Babys Pride' && config.title !== 'Vimpro' && config.title !== 'KatbookStore' && config.title !== 'ShubhCards' && config.title !== 'SriSenbaga'" />
            </div>
          
          <!--------------------------Delivery option----------------->
          <div *ngIf="groups[2].showondetailpage">
            <h5 *ngIf="config.title=='Carience'">COLORS</h5>
            <div *ngIf="config.title=='Carience'" class="colour-select-container">

              <div *ngFor="let img_colour of product.variant.option_values[current_index].child;let j = index"
                class="colour-select-image" style="margin-left:1px;margin-right: -16px">

                <img [src]="img_colour.assets[0].image_source_thumbnail" id="img-list"
                  (click)="selectColour(img_colour.color,product.id,j)" onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" [class.active]="img_colour.is_default"
                  class="colour-image detail-colour-image" />
              </div>
            </div>
            <h5 *ngIf="config.title == 'Vimpro' && newProductDetails.product_type=='Variable'">COLORS</h5>
            <div *ngIf="config.title == 'Vimpro'  && newProductDetails.product_type=='Variable'&&newProductDetails.variant.variant_child" class="colour-select-container">

              <div *ngFor="let img_colour of product.variant.option_values[current_index].child;let j = index"
                class="colour-select-image" style="margin-left:1px;margin-right: -16px">

                <img [src]="img_colour.assets[0].image_source" id="img-list"
                  (click)="selectColour(img_colour.color,product.id,j)" [class.active]="img_colour.is_default"
                  class="colour-image detail-colour-image" />
              </div>
            </div>
            <div *ngIf="config.title == 'Vimpro'  && newProductDetails.product_type=='Variable'&&!newProductDetails.variant.variant_child" class="colour-select-container" style="display: block;">

              <p class="avl_text" style=" height: 43px;" *ngFor="let name of newProductDetails.color;; let isLast=last"><b style="font-size:23px;">&#x2022;</b><span  style="margin-left: 10px;">{{name.name}}</span><em *ngIf="!isLast"></em></p>
            </div>

            <div class="row">
              <div class="col-md-6">
                <span *ngIf="config.title == 'Vimpro' && newProductDetails.product_type=='Variable'" style="font-size: 24px;font-weight: 400;">Dimensions</span>
                <h5 *ngIf="config.title == 'Vimpro' && newProductDetails.product_type=='Variable'" style="margin-top: 15px;">OUTER DIMENSIONS</h5>
                <div *ngIf="config.title == 'Vimpro'  && newProductDetails.product_type=='Variable'&&newProductDetails.variant.variant_child">
    
                  <div
                    class="colour-select-image" style="margin-left:1px;margin-right: -16px;width: 100%;">
                      <p *ngIf="product.variant.option_values[current_index].child[child_index].outer_dimensions.length !==''">
                        Length:<span style="margin-left: 25px;">{{product.variant.option_values[current_index].child[child_index].outer_dimensions.length}}</span>
                      </p>
                      <p *ngIf="product.variant.option_values[current_index].child[child_index].outer_dimensions.width !==''">
                        Width:<span style="margin-left: 30px;">{{product.variant.option_values[current_index].child[child_index].outer_dimensions.width}}</span>
                      </p>
                      <p *ngIf="product.variant.option_values[current_index].child[child_index].outer_dimensions.height !==''">
                        Height:<span style="margin-left: 25px;">{{product.variant.option_values[current_index].child[child_index].outer_dimensions.height}}</span>
                      </p>
                      <p *ngIf="product.variant.option_values[current_index].child[child_index].outer_dimensions.diameter !==''">
                        Diameter:<span style="margin-left: 7px;">{{product.variant.option_values[current_index].child[child_index].outer_dimensions.diameter}}</span>
                      </p>
                  </div>
                </div>
                <div *ngIf="config.title == 'Vimpro'  && newProductDetails.product_type=='Variable'&&!newProductDetails.variant.variant_child">
    
                  <div
                    class="colour-select-image" style="margin-left:1px;margin-right: -16px;width: 100%;">
                      <p *ngIf="newProductDetails.variant.option_values[current_index].outer_dimensions.length !==''">
                        Length:<span style="margin-left: 25px;">{{product.variant.option_values[current_index].outer_dimensions.length}}</span>
                      </p>
                      <p *ngIf="newProductDetails.variant.option_values[current_index].outer_dimensions.width !==''">
                        Width:<span style="margin-left: 30px;">{{product.variant.option_values[current_index].outer_dimensions.width}}</span>
                      </p>
                      <p *ngIf="newProductDetails.variant.option_values[current_index].outer_dimensions.height !==''">
                        Height:<span style="margin-left: 25px;">{{product.variant.option_values[current_index].outer_dimensions.height}}</span>
                      </p>
                      <p *ngIf="newProductDetails.variant.option_values[current_index].outer_dimensions.diameter !==''">
                        Diameter:<span style="margin-left: 7px;">{{product.variant.option_values[current_index].outer_dimensions.diameter}}</span>
                      </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <h5 *ngIf="config.title == 'Vimpro' && newProductDetails.product_type=='Variable'" style="margin-top: 48px;">INNER DIMENSIONS</h5>
            <div *ngIf="config.title == 'Vimpro'  && newProductDetails.product_type=='Variable'&&newProductDetails.variant.variant_child">

              <div
                class="colour-select-image" style="margin-left:1px;margin-right: -16px;width: 100%;">
                  <p *ngIf="product.variant.option_values[current_index].child[child_index].inner_dimensions.length !==''">
                    Length:<span style="margin-left: 25px;">{{product.variant.option_values[current_index].child[child_index].inner_dimensions.length}}</span>
                  </p>
                  <p *ngIf="product.variant.option_values[current_index].child[child_index].inner_dimensions.width !==''">
                    Width:<span style="margin-left: 30px;">{{product.variant.option_values[current_index].child[child_index].inner_dimensions.width}}</span>
                  </p>
                  <p *ngIf="product.variant.option_values[current_index].child[child_index].inner_dimensions.height !==''">
                    Height:<span style="margin-left: 25px;">{{product.variant.option_values[current_index].child[child_index].inner_dimensions.height}}</span>
                  </p>
                  <p *ngIf="product.variant.option_values[current_index].child[child_index].inner_dimensions.diameter !==''">
                    Diameter:<span style="margin-left: 7px;">{{product.variant.option_values[current_index].child[child_index].inner_dimensions.diameter}}</span>
                  </p>
              </div>
            </div>
            <div *ngIf="config.title == 'Vimpro'  && newProductDetails.product_type=='Variable'&&!newProductDetails.variant.variant_child">

              <div
                class="colour-select-image" style="margin-left:1px;margin-right: -16px;width: 100%;">
                  <p *ngIf="newProductDetails.variant.option_values[current_index].inner_dimensions.length !==''">
                    Length:<span style="margin-left: 25px;">{{newProductDetails.variant.option_values[current_index].inner_dimensions.length}}</span>
                  </p>
                  <p *ngIf="newProductDetails.variant.option_values[current_index].inner_dimensions.width !==''">
                    Width:<span style="margin-left: 30px;">{{newProductDetails.variant.option_values[current_index].inner_dimensions.width}}</span>
                  </p>
                  <p *ngIf="newProductDetails.variant.option_values[current_index].inner_dimensions.height !==''">
                    Height:<span style="margin-left: 25px;">{{newProductDetails.variant.option_values[current_index].inner_dimensions.height}}</span>
                  </p>
                  <p *ngIf="newProductDetails.variant.option_values[current_index].inner_dimensions.diameter !==''">
                    Diameter:<span style="margin-left: 7px;">{{newProductDetails.variant.option_values[current_index].inner_dimensions.diameter}}</span>
                  </p>
              </div>
            </div>
              </div>
            </div>
           
        
            <!-- <h5 *ngIf="config.title == 'Vimpro' && newProductDetails.product_type=='Simple'" style="margin-top: 8px;">COLORS</h5> -->
            <div *ngIf="config.title == 'Vimpro'  && newProductDetails.product_type=='Simple'" style="margin-top: 20px;">
              <span style="font-size: 25px;
              font-weight: 500;">Colors</span>
              <div class="row" style="margin-left: 4px!important;margin-bottom:15px;" *ngFor="let name of newProductDetails.color;">
                <p *ngIf="newProductDetails.color.name !==''">
                  &#x2022;<span style="margin-left: 10px;">{{name.name}}</span>
                </p>
              </div>
              <span style="font-size: 25px;
              font-weight: 500;">Material</span>
                 <div class="row" style="margin-left: 4px!important;margin-bottom:15px;" *ngFor="let name of newProductDetails.product_material;">
                    <p>
                      &#x2022;<span style="margin-left: 10px;">{{name.name}}</span>
                    </p>
                 </div>
                 <span style="font-size: 25px;
                 font-weight: 500;">Thickness</span>
                 <div class="row"  style="margin-left: 4px!important;margin-bottom:15px;" *ngFor="let name of newProductDetails.thickness;">
                    <p>
                      &#x2022;<span style="margin-left: 10px;">{{name.name}}</span>
                    </p>
                 </div>
            </div>

            <div *ngIf="config.title == 'Mayan'  && newProductDetails.product_type=='Simple'" style="margin-top: 20px;">
              
              
              <span style="font-size: 1rem;
              font-weight: 500;">MATERIAL</span>
                 <div class="row" style="margin-left: 4px!important;margin-bottom:15px;" *ngFor="let name of newProductDetails.product_material;">
                    <p>
                      &#x2022;<span style="margin-left: 10px;">{{name.name}}</span>
                    </p>
                 </div>
                 
                
            </div>
            <!-- <h5  *ngIf="config.title === 'SpecialWires'">Size Chart :</h5> -->
            <div class="breadcurmb" *ngIf="config.title === 'SpecialWires'">
              <img *ngIf="chartImages" class="avon-chart" [src]="chartImages">
            </div>
            <hr *ngIf="config.title === 'SpecialWires' && newProductDetails.product_type=='Variable'" />
            <div *ngIf="config.title == 'SpecialWires'">
              <div class="special_comp_title" *ngFor="let img_colour of product.attributes">
                <h3 style="margin-top: 30px;">
{{img_colour.section_title}} :</h3>
<div class="special_comp_content" *ngFor="let type of img_colour.attr"><span style="font-size: 18px; font-weight: 600;">{{type.attr_name}} :</span><span style="font-size: 18px; font-weight: 400; color: #3b8c9c; margin-left: 10px;"> {{type.attr_value}}</span></div>
              </div>
              
            </div>
            <!-- <div class="inner-html-list" *ngIf="config.title == 'Accel'" [innerHTML]="shortDescription"></div> -->
            <div class="delivery-option"
              *ngIf="
                config.title !== 'BombayHardware' && config.title !== 'Deera' && config.title !== 'Babys Pride'  && config.title !== 'AvonSeals' && config.title !== 'SpecialWires' && config.title !== 'BestGifts'  && config.title !=='Beaubelle' && config.title !=='ShubhCards'  && config.title !=='Mayan' && config.title !=='Carience' && config.title !== 'Vimpro' && config.title !=='AvonSeals' && config.title !== 'Vistas'&& config.title !=='Karupattiraja' && config.title !=='KatbookStore' && config.title !=='Taazah' && config.title !=='SriSenbaga'">
              
                <form [formGroup]="detailForm" >
                <h6  *ngIf="config.title !== 'Accel' && config.title !== 'Schift Cosmetics' && config.title !== 'LushNGreen'" >
                  DELIVERY OPTIONS <span> <i class="fa fa-truck"></i></span>
                </h6>
                <h6  *ngIf="config.title === 'LushNGreen'" >
                  CHECK DELIVERY <span> <i class="fa fa-truck"></i></span>
                </h6>
                <h6  *ngIf="config.title == 'Accel'" >
                  What you'll learn: <span> {{what_you_will_learn}}</span>
                </h6>
                <h6  *ngIf="config.title == 'Schift Cosmetics'" class="schift-key-descti" >
                  About this Item 
                </h6>
                <!-- <span *ngIf="config.title == 'Schift Cosmetics'" [innerHTML]="metaDescription" class="schift-key-desc"></span> -->
                  <span *ngIf="config.title == 'Schift Cosmetics'" [innerHTML]="shortDescription" class="schift-key-desc"></span>
                  <hr *ngIf="config.title == 'Schift Cosmetics'">
                  <h6  *ngIf="config.title == 'Schift Cosmetics'" class="schift-key-descti">
                    Directions for use 
                  </h6>
                  <div  *ngIf="config.title == 'Schift Cosmetics'" class="inner-html-list" [innerHTML]="instructionDesc" class="schift-key-desc"></div>
                <!-- <div class="inner-html-list" *ngIf="config.title == 'Accel'" [innerHTML]="shortDescription"></div> -->
                <input *ngIf="config.title !== 'Accel' && config.title !== 'Schift Cosmetics' && config.title !== 'LushNGreen' && config.title !=='Taazah'"  id="zipcode" class="zipcode" formControlName="zipcode"
                  [class.is-invalid]="validateForm && f.zipcode.errors" type="text" value="" style="height: 40px" />
                  <input *ngIf="config.title === 'LushNGreen'" placeholder="Enter PIN code"  id="zipcode" class="zipcode" formControlName="zipcode"
                  [class.is-invalid]="validateForm && f.zipcode.errors" type="text" value="" style="height: 40px;width: 50%;" />
                <button  *ngIf="config.title !== 'Accel'&& config.title !== 'Schift Cosmetics' && config.title !== 'LushNGreen' && config.title !=='Taazah'" class="btn btn-primary inq-btn-st ml-1" (click)="checkServiceAvailablity()">
                  Check<span *ngIf="showSpinner" class="spinner-border spinner-border-sm" style="
                      margin-left: 20px !important;
                      padding-top: 10px !important;
                    "></span>
                </button>
                <button  *ngIf="config.title === 'LushNGreen'" class="inq-btn-st" (click)="checkServiceAvailablity()" style="height: 40px;border: none;background-color: gray;color: white;">
                  Check<span *ngIf="showSpinner" class="spinner-border spinner-border-sm" style="
                      margin-left: 20px !important;
                      padding-top: 10px !important;
                    "></span>
                </button>
                <br *ngIf="config.title !== 'Accel'"  />
                <div class="invalid-feedback" *ngIf="f.zipcode.errors">
                  <div *ngIf="f.zipcode.errors.minlength">Invalid Pincode</div>
                  <div *ngIf="f.zipcode.errors.pattern">Invalid Pincode</div>
                  <div *ngIf="f.zipcode.errors.maxlength">Invalid Pincode</div>
                </div>
                <label class="hint-message note zipcode-nonavailable" *ngIf="notAvailableLocation">We are currently not
                  delivering at this location</label>
                <label class="hint-message note zipcode-available" *ngIf="availableLocation">Delivery available
                  <br *ngIf="config.title !== 'Accel'" />
                  <span class="hint-message addSize" style="font-size: large; color: black; font-weight: normal">
                    Get it by </span><span class="estd-delivery">{{ estdDelivery }}</span></label><br *ngIf="config.title !== 'Accel'" />
              </form>
              
            </div>

            <hr
              *ngIf="
                config.title !== 'BombayHardware' && config.title !== 'SriSenbaga' && config.title !== 'AvonSeals' && config.title !== 'SpecialWires' && config.title !== 'Deera' && config.title !== 'BestGifts' && config.title !=='Beaubelle' && config.title !=='ShubhCards' && config.title !=='Mayan' && config.title !=='Carience' && config.title !== 'Vimpro' && config.title !== 'Vistas' && config.title !== 'Babys Pride' && config.title !=='KatbookStore' && config.title !=='Taazah'" />
          </div>
        
        <!----------how to store and cook -->
        <div *ngIf="config.title !== 'AvonSeals' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !=='KatbookStore' && config.title !== 'SpecialWires' && config.title !== 'Vimpro' && config.title !=='Taazah' && newProductDetails.description.instruction_description != ''">
          <div class="row col-left">
            <div class="col-md-3" *ngIf="config.title !== 'Tams'"></div>
            <div class="col-md-7" id="instruction">
              {{ newProductDetails.description.instruction_title }}
            </div>
          </div>

          <div class="row col-left" style="    width: 90%;margin-left: -15%;" *ngIf="
              newProductDetails.description.instruction_description != '' &&
              config.title !== 'Deera' && config.title !== 'BestGifts' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !=='Taazah'
            ">
            <div class="col-md-9" *ngIf="config.title !== 'Accel' && config.title !== 'Schift Cosmetics' && config.title !== 'Carience'">
              <div class="inner-html-list" [innerHTML]="instructionDesc"></div>
            </div>
          </div>

          <hr class="mobile-only"
            *ngIf="config.title !== 'Deera' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !== 'AvonSeals' && config.title !== 'SpecialWires' && config.title !== 'BestGifts' && config.title !== 'ShubhCards' && config.title !== 'Mayan' && config.title !== 'Vistas' && config.title !=='Taazah'" />
        </div>
        <!-----------------How to store-->
        <div class="row" *ngIf="config.title == 'Tams'">
          <div class="col-md-12" *ngIf="showStorage">
            <div class="col-lg-12 storage">
              <div class="card-header">How To Store</div>
              <div class="col-sm-12">
                <p>{{ newProductDetails.additional_info.how_to_store }}</p>
              </div>
            </div>
            <hr />
          </div>
        </div>

        <!-----------------points-->
        <div class="row" *ngIf="config.title !== 'AvonSeals' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !== 'Accel' && config.title !== 'Vimpro' && config.title !== 'SpecialWires' && config.title !=='KatbookStore' && config.title !=='Taazah' && 
            newProductDetails.description.bullet_points != '' &&
            config.title !== 'Deera' && config.title !== 'BestGifts' && config.title !== 'Schift Cosmetics'
          ">
          <div class="col-md-8" *ngIf="config.title !== 'Mayan' && config.title !== 'Accel'&& config.title !== 'Carience'&& config.title !== 'Vimpro' && config.title !== 'AvonSeals' && config.title !== 'SpecialWires'">
            <div class="col-lg-12" style="color: #3b8c9c; font-weight: 900">
              <div class="col-sm-12">
                <div class="innerHTML" [innerHTML]="bulletPoints"></div>
              </div>
            </div>
            <hr />
          </div>
        </div>



        <div class="breadcurmb" *ngIf="config.title === 'Deera' || config.title === 'Mayan'">
          <h6  id="deeraChart">PRODUCT DIMENSIONS</h6>
          <div class="normalSize">
            <div class="product-addtional-details">
              <ul class="one-column">
                <li class="normalSize">
                  <label class="list-label">Width: </label>
                  <label class="list-value" *ngIf="config.title !== 'Mayan'">
                    {{ newProductDetails.shipping.product_width }} cm</label>
                  <label class="list-value" style=" color: #3c707c;" *ngIf="config.title === 'Mayan'">
                    {{ newProductDetails.shipping.product_width }} inches</label>
                </li>
                <li class="normalSize">
                  <label class="list-label">Height: </label>
                  <label class="list-value" *ngIf="config.title !== 'Mayan'">
                    {{ newProductDetails.shipping.product_height }} cm</label>
                  <label class="list-value" style=" color: #3c707c;" *ngIf="config.title === 'Mayan'">
                    {{ newProductDetails.shipping.product_height }} inches</label>
                </li>
                <li class="normalSize">
                  <label class="list-label">Length: </label>
                  <label class="list-value" *ngIf="config.title !== 'Mayan'">
                    {{ newProductDetails.shipping.product_length }} cm</label>
                  <label class="list-value" style=" color: #3c707c;" *ngIf="config.title === 'Mayan'">
                    {{ newProductDetails.shipping.product_length }} inches</label>
                </li>
                <li class="normalSize">
                  <label class="list-label">Weight: </label>
                  <label class="list-value" *ngIf="config.title !== 'Mayan'">
                    {{ newProductDetails.shipping.product_weight }} grams</label>
                  <label style=" color: #3c707c;" class="list-value" *ngIf="config.title === 'Mayan'">
                    {{ newProductDetails.shipping.product_weight }} Kg</label>
                </li>
                <li class="normalSize" *ngIf="this.newProductDetails.shipping.diameter">
                  <label class="list-label">Diameter: </label>
                 
                  <label style=" color: #3c707c;" class="list-value" *ngIf="config.title === 'Mayan'">
                    {{ newProductDetails.shipping.diameter }}inches</label>
                </li>
              </ul>
            </div>
            <hr />
          </div>
        </div>
        <div class="breadcurmb"  *ngIf="config.title === 'Babys Pride'">
          <img *ngIf="chartImages" class="avon-chart" [src]="chartImages">
        </div>
        <div class="breadcurmb"  *ngIf="config.title === 'LushNGreen'">
          <img *ngIf="chartImages" class="avon-chart" [src]="chartImages">
        </div>
        <hr *ngIf="config.title === 'LushNGreen'">
        <div class="breadcurmb"  *ngIf="config.title === 'Deera'">
          <!-- <img *ngIf="newProductDetails.name === 'X TYPE'" class="avon-chart" src="../../../../../assets/images/avonseals/X-Series.png">
          <img *ngIf="newProductDetails.name === 'G TYPE'" class="avon-chart" src="../../../../../assets/images/avonseals/G-Series.png">
          <img *ngIf="newProductDetails.name !== 'X TYPE' && newProductDetails.name !== 'G TYPE'" class="avon-chart" src="../../../../../assets/images/avonseals/avonseal chart.png"> -->
          <!-- <img *ngIf="chartImages" class="deera-chart" [src]="chartImages"> -->
          <!-- <img  class="deera-chart" src="../../../../../assets/images/deera/deera-size chart.PNG"> -->
          <img *ngIf="chartImages" class="avon-chart" [src]="chartImages">
        </div>
        <span *ngIf="config.title === 'Deera'" style="
        font-size: 16px !important;
        color: grey !important;
        margin-left: 5px;
      ">(If you find it difficult to decide on the size, please email to <strong>shopatdeera@gmail.com</strong> for clarification.)</span>
        <hr *ngIf="config.title === 'Deera'" />

        <div class="breadcurmb" *ngIf="config.title === 'BestGifts'">
          <h6>PRODUCT DIMENSIONS</h6>
          <div class="normalSize">
            <div class="product-addtional-details">
              <ul class="one-column">
                <li class="normalSize">
                  <label class="list-label">Print Size: </label>
                  <label class="list-value" *ngIf="newProductDetails.shipping.product_width">
                    {{ newProductDetails.shipping.product_width }}</label>
              
                <label class="list-value" *ngIf="!newProductDetails.shipping.product_width">
                  {{ newProductDetails.print_size }}</label>
              </li>
                <li class="normalSize">
                  <label class="list-label">Product Size: </label>
                  <label class="list-value" *ngIf="newProductDetails.shipping.product_height">
                    {{ newProductDetails.shipping.product_height }}</label>
                    <label class="list-value" *ngIf="!newProductDetails.shipping.product_height">
                      {{ newProductDetails.product_size }}</label>
                </li>
                <li class="normalSize">
                  <label class="list-label">Product Weight: </label>
                  <label class="list-value" *ngIf="newProductDetails.shipping.product_weight">
                    {{ newProductDetails.shipping.product_weight }}</label>
                    <label class="list-value" *ngIf="!newProductDetails.shipping.product_weight">
                      {{ newProductDetails.weight }}</label>
                </li>
              </ul>
            </div>
            <hr />
          </div>
        </div>
         
        <div class="breadcurmb" *ngIf="config.title === 'AvonSeals'">
          <!-- <img *ngIf="newProductDetails.name === 'X TYPE'" class="avon-chart" src="../../../../../assets/images/avonseals/X-Series.png">
          <img *ngIf="newProductDetails.name === 'G TYPE'" class="avon-chart" src="../../../../../assets/images/avonseals/G-Series.png">
          <img *ngIf="newProductDetails.name !== 'X TYPE' && newProductDetails.name !== 'G TYPE'" class="avon-chart" src="../../../../../assets/images/avonseals/avonseal chart.png"> -->
          <img *ngIf="chartImages" class="avon-chart" [src]="chartImages">
        </div>
        <hr *ngIf="config.title === 'AvonSeals'" />
        <div class="breadcurmb" *ngIf="config.title === 'AvonSeals'">
          <img class="avon-chart" [src]="product.assets[1].image_source">
        </div>
        <hr *ngIf="config.title === 'AvonSeals'" />
         
        <div class="col-right" *ngIf="config.title === 'Deera'">
          <!-- <h6>ABOUT THIS ITEM </h6> -->
          <h6>Product Features </h6>
          <!-- <div id="accordion"> -->
          <!-- <a class="sub-heading" data-toggle="collapse" data-target="#collapseContent" aria-expanded="true"
                        aria-controls="collapseContent" style="cursor: pointer;" style="color:black!important">ABOUT THIS ITEM<i
                        class="fa fa-angle-down arrow-size"></i> </a> -->

          <!-- </div> -->
          <!-- <div id="collapseContent" class="collapse" aria-labelledby="headingOne" data-parent="#accordion"> -->
          <!-- <div class="card-body"> -->
          <!-- <ng-container> -->

          <!-- <div class="collection-collapse-block"  style="padding-left: 30px;"> -->
          <!-- <div class="collection-collapse-block"> -->

          <div style="font-size:15px; padding-left: 30px;">
            <!-- <div class="innerHTML" style="display: list-item;list-style-type: disc;" [innerHTML]="bulletPoints"></div> -->
            <div class="innerHTML" [innerHTML]="bulletPoints"></div>
          </div>

          <!-- </div> -->
          <!-- </ng-container> -->
          <!-- </div> -->
          <!-- </div> -->
          <!-- <div class="product-detail">
                    <div class="product-addtional-details">
                        <ul class="one-column"> 
                                <div class="innerHTML" [innerHTML]="bulletPoints"></div>
                        </ul>
                    </div>
                </div> -->

          <!-- <div style="font-size:15px;"  >
                        <div class="innerHTML" [innerHTML]="bulletPoints"></div> 
                      </div> -->

          <hr *ngIf="config.title === 'Deera'">

        </div>

        <!-----product detailss-->
        <div class="col-right" *ngIf="config.title == 'Carience'" style="margin-top: 20px;">
          <h5>OFFERS</h5>
          <div class="container" style="background-color:lightgray ;">{{offers
            }}
          </div>
        </div>
        <div class="col-right" *ngIf="config.title == 'Carience'" style="margin-top: 20px;">
          <div>
            <h5>Features</h5>
            <div class="col-sm-12">
              <div class="innerHTML" [innerHTML]="bulletPoints"></div>
            </div>
          </div>
          <hr />
        </div>
        <div class="col-right" *ngIf="config.title == 'Accel'">
          <div>
            <h5>Selection Process:</h5>
            <p  *ngFor="let process of selection_process; let i = index" > {{process}}</p>
            <!-- <div class="col-sm-12">
              <div class="innerHTML" [innerHTML]="bulletPoints"></div>
            </div> -->
          </div>
          <hr />
        </div>
        <div class="col-right"
          *ngIf="groups[4].showondetailpage && config.title != 'Tams' && config.title != 'SriSenbaga' && config.title !== 'Taazah' &&  config.title != 'Carience' && config.title != 'Vimpro' && config.title != 'AvonSeals' && config.title !== 'Babys Pride' && config.title !== 'SpecialWires' && config.title !== 'LushNGreen' && config.title !=='KatbookStore'">
          <h6 *ngIf=" config.title !== 'Accel' && config.title !== 'ShubhCards'">PRODUCT DETAILS</h6>
          <h6 *ngIf=" config.title == 'Accel'">COURSE  DETAILS</h6>
          <div class="product-detail" *ngIf="config.title !== 'ShubhCards'" >
            <div class="product-addtional-details" *ngIf="config.title != 'BombayHardware'&& config.title!='AvonSeals' && config.title !== 'SpecialWires' && config.title !== 'Vistas'">
              <ul class="one-column">
               <div *ngIf="config.title !== 'Accel' && config.title !== 'Deera'">
                <li  class="normalSize schift-flec" *ngFor="let field of groups[4].fields">
                  <label class="list-label">{{field.labelname}}: </label>
                  <label class="list-value"
                    *ngIf="field.nestedinfo.type == 'object'">{{metaDataMapService.findData(newProductDetails,
                    field.nestedinfo)}} </label>
                  <label class="list-value"
                    *ngIf="field.nestedinfo.type == 'array' && field.labelname == 'Category' && config.title!='Mayan'  && config.title!='Schift Cosmetics' && config.title!='Deera'   ">{{product.categorynames[0].name}}11
                  </label>
                  <div>
                  <div *ngFor="let categories of newProductDetails.categories">
                  <label class="list-value"
                    *ngIf="field.nestedinfo.type == 'array' && field.labelname == 'Category' && config.title==='Schift Cosmetics'  ">{{categories.categories}}
                  </label>
                </div>
              </div>
                  <label class="list-value"
                    *ngIf="field.nestedinfo.type == 'array' && field.labelname == 'Category' && config.title=='Mayan'">{{listcategory}}
                  </label>

                  <label class="list-value"
                    *ngIf="field.nestedinfo.type == 'array' && field.labelname == 'Themes'">{{themes}}
                  </label>
                </li>
               </div>
              
                <li class="normalSize" *ngIf="config.title == 'Accel'">
                  <label class="list-label">Category: </label>
                  <label class="list-value"> {{product.categorynames[0].name}}</label>

                </li>
                <li class="normalSize" *ngIf="config.title == 'Accel'">
                  <label class="list-label">Duration: </label>
                  <label class="list-value"> {{product.course_duration.duration_in_months}}Months</label>

                </li>
                <li class="normalSize" *ngIf="config.title == 'Accel'">
                  <label class="list-label">CTC:</label>
                  <label class="list-value"> {{product.course_duration.min_course_placement_package}}</label>

                </li>
                <li class="normalSize" *ngIf="config.title === 'BestGifts'">
                  <label class="list-label">Brand: </label>
                  <label class="list-value"> {{newProductDetails.brand.name}}</label>

                </li>
                <!-- <li class="normalSize" *ngIf="config.title == 'Deera'">
                  <label class="list-label">Color: </label>
                  <label class="list-value"> {{newProductDetails.color.name}}</label>

                </li>
                <li class="normalSize" *ngIf="config.title == 'Deera'">
                  <label class="list-label">Material: </label>
                  <label class="list-value"> {{newProductDetails.product_material.name}}</label>

                </li>
                <li class="normalSize" *ngIf="config.title == 'Deera'">
                  <label class="list-label">Type: </label>
                  <label class="list-value"> {{newProductDetails.type.name}}</label>

                </li> -->
              </ul>
              <div class="breadcurmb">
                <div class="normalSize specialsize" [innerHTML]="instructionDescription">
                </div>
              </div>
            </div>
          </div>
          <hr *ngIf="config.title === 'AvonSeals'" />

          <div class="breadcurmb" *ngIf="config.title === 'AvonSeals'">
            <div class="normalSize">
              <div class="product-addtional-details">
                <ul class="one-column">
                  <!-- <li class="normalSize">
                    <label class="list-label">Pipe Type: </label>
                    <label class="list-value">UPVC</label>
                  </li> -->
                  <li class="normalSize">
                    <label class="list-label">Category: </label>
                    <label class="list-value">Seals</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label">Sale Price: </label>
                    <label class="list-value">{{avonSealsPrice}}</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label">Stock Status: </label>
                    <label class="list-value">Available</label>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
          </div>
          <div class="breadcurmb" *ngIf="config.title === 'Vistas'">
            <div class="normalSize">
              <div class="product-addtional-details">
                <ul class="one-column">
                  <li class="normalSize">
                    <label class="list-label">Brand: </label>
                    <label class="list-value">{{newProductDetails.brand.name}}</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label">Colour: </label>
                    <label class="list-value">White</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label">Packaging Size: </label>
                    <label class="list-value">500 Sheets per pack </label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label">Paper Finish: </label>
                    <label class="list-value">Smooth</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label">Sheet Size: </label>
                    <label class="list-value">A4 (29.7 x 21)</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label">Paper Weight: </label>
                    <label class="list-value">70</label>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
          </div>
          <div class="breadcurmb" *ngIf="config.title === 'BombayHardware'">
            <div class="normalSize">
              <div class="product-addtional-details">
                <ul class="one-column">
                  <!-- <li class="normalSize">
                    <label class="list-label">Pipe Type: </label>
                    <label class="list-value">UPVC</label>
                  </li> -->
                  <li class="normalSize">
                    <label class="list-label">Category: </label>
                    <label class="list-value">{{product.categories[0].categories}}</label>
                  </li>
                  <li class="normalSize">
                    <label class="list-label">Stock Status: </label>
                    <label class="list-value">{{product.stock_status}}</label>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
          </div>
        </div>
        <!-- <div class="col-right"
          *ngIf="groups[4].showondetailpage && config.title == 'AvonSeals'">
          <h6>PRODUCT FEATURES</h6>
          <div class="product-detail">
            <ul>
              <li style="margin-left: 12px;list-style-type: disc;">
              <h3><span style="font-size:16px;	font-family: 'proxima-regular','sans-serif'!important;">Standard APL682 arrangement 1 and type C seal</span></h3>
              </li>
              <li style="margin-left: 12px;list-style-type: disc;font-family: 'proxima-regular','sans-serif'!important;">
              <h3><span style="font-size:16px">The bellows are very strong, with a plate thickness of 0.08-0.17mm</span></h3>
              </li>
              <li style="margin-left: 12px;list-style-type: disc;font-family: 'proxima-regular','sans-serif'!important;">
              <h3><span style="font-size:16px">The heat treated bellows and bellows holder of alloy 718 have the strongest resistance to stress corrosion cracking</span></h3>
              </li>
              <li style="margin-left: 12px;list-style-type: disc;font-family: 'proxima-regular','sans-serif'!important;">
              <h3><span style="font-size:16px">Applications: low temperature, corrosion, hydrocarbons and heat transfer fluids</span></h3>
              </li>
              <li style="margin-left: 12px;list-style-type: disc;font-family: 'proxima-regular','sans-serif'!important;">
              <h3><span style="font-size:16px">The shrunk-fifted sealing surface design can eliminate the deformation of hot pressing fit</span></h3>
              </li>
              <li style="margin-left: 12px;list-style-type: disc;font-family: 'proxima-regular','sans-serif'!important;">
              <h3><span style="font-size:16px">Standard threaded bellows holder</span></h3>
              </li>
            </ul>
            
          </div>
            
        </div>   -->
        <div *ngIf="config.title ==='LushNGreen'">
          <div class="lush_distruck">
<div class="lush-truck">
  <img src="../../../../../assets/images/lushngreen/deliverytruck-removebg-preview.png" class="lush-truck-image">
  <p style="width: 120%;font-size: 11px;color: gray; margin-top: 10px;">Free Shipping above 499</p>
</div>
<div class="lush-truck">
  <img src="../../../../../assets/images/lushngreen/package-removebg-preview.png" class="lush-truck-image">
  <p style="width: 120%;font-size: 11px;color: gray; margin-top: 10px;">Garanteed Replacements if Damaged</p>
</div>
<div class="lush-truck">
  <img src="../../../../../assets/images/lushngreen/expert.png" class="lush-truck-image">
  <p style="width: 120%;font-size: 11px;color: gray; margin-top: 10px;">Expert Guidance</p>
</div>
          </div>
        </div>
        <hr *ngIf="config.title != 'Tams' && config.title != 'BombayHardware' && config.title != 'Carience'  && config.title != 'ShubhCards'&&  config.title != 'Vimpro' && config.title !== 'SpecialWires' && config.title != 'AvonSeals' && config.title != 'Vistas' && config.title !=='KatbookStore' && config.title !=='Taazah'  && config.title !=='SriSenbaga'" />
        <!------------------------additional info---------->
        <div  *ngIf="productViewVideo===true" class="video2">
          <h6  id="deeraChart">{{newProductDetails.name}} - Video</h6>
          <!-- <div *ngFor="let video of newProductDetails.video_assets">
      
            <div *ngIf="config.title==='BestGifts'" class="video2">
              <video class="video-js vjs-default-skin" width="375px" height="267px" controls preload="none"
            poster='https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Bestgifts/StoreGallery/1686546498578%20-%20bestgifts.png'
            data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
            <source src="{{video.link}}" type='video/mp4' />
          </video>
          <br>
          <br>
          <br>
            </div>
          </div> -->
          <div *ngIf="viewVideo===true">
            <video class="video-js vjs-default-skin" width="375px" height="267px" controls preload="none"
            poster='https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Bestgifts/StoreGallery/1686546498578%20-%20bestgifts.png'
            data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
            <source src="{{newProductDetails.video_assets[0].link}}" type='video/mp4' />
          </video>
          </div>

          <div *ngIf="viewVideo1===true">
            <video *ngIf="productViewVideo1" [src]="productViewVideo1" class="video-js vjs-default-skin" width="375px" height="267px" controls preload="none"
            poster='https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Bestgifts/StoreGallery/1686546498578%20-%20bestgifts.png'
            data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
            <!-- <source [src]="productViewVideo1" type='video/mp4' /> -->
          </video>
          </div>

      <div class="row" *ngIf="newProductDetails.video_assets.length>0" style="width: 100%;overflow-x: auto; white-space: nowrap;">
          <div *ngFor="let video of newProductDetails.video_assets; let i = index" style="margin-left: 2%;margin-top: 10px;margin-bottom: 10px;">
            <img  src="assets/images/bestgifts/playimage.jpg" class="image-preview-product" [class.active]="isActive1 === i" style="width: 80px; height: 80px"
             (click)="productVideoPreview1(video,i)" />
          </div>
        </div>
        </div>
   
   
    </div>

   
    <hr *ngIf="config.title != 'Carience' && config.title != 'Vimpro' && config.title != 'Accel'  && config.title !== 'SriSenbaga' && config.title !== 'LinenRaj' && config.title !=='KatbookStore'" />
   <div *ngIf="config.title === 'LinenRaj'">
    <hr _ngcontent-ept-c99="" class="mt__0">
    <div id="wrap_des_pr" style="background: aliceblue;">

      <div class="container container_des" style="margin-top: 20px !important;">
        <div class="row" id="tab_pr_deskl" style="margin-top: 20px;">
          
          <div class="col-12 col-md-4" style="margin-top: 30px;">
            <h6 class="m__0 mb__20" style="font-family: 'Lato', sans-serif !important;
            text-transform: uppercase;
            letter-spacing: 2.5px !important;
            font-size: 10px !important;
            font-weight: 600 !important;">Description</h6>
            <div class="inner-html-list"  style="font-size: 13px !important;
            font-family: 'Lato', sans-serif;
            font-style: italic !important;
            margin-top: 10px; color: gray;text-transform: lowercase!important;"
           [innerHTML]="otherDescription"></div>
          </div>
          
          <div class="col-12 col-md-1">
          </div>
          
          <div class="col-12 col-md-3 product_specs" style="margin-top: 30px;">
        
          <div class="row mb__20">
              <div class="col-3"><img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/f3_bee8027b-946e-4870-945b-e63f0ee770dd.png?v=1648536391" style="width: 100%;box-shadow:none"></div>
              <div class="col-9">
                <h6 style="margin-bottom: 0px !important;"><p style="font-family: 'Lato', sans-serif !important;
                  text-transform: uppercase;
                  letter-spacing: 2.5px !important;
                  font-size: 10px !important;
                  font-weight: 600 !important;">100% Linen</p></h6>
                <small class="block" style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Material</small>
              </div>
            </div>
            
            <div class="row mb__20" style="margin-top: 10px;">
              <div class="col-3"><img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/f1.png?v=1648535403" style="width: 100%;box-shadow:none"></div>
              <div class="col-9">
                <h6 style="font-family: 'Lato', sans-serif !important;
                text-transform: uppercase;
                letter-spacing: 2.5px !important;
                font-size: 10px !important;
                font-weight: 600 !important;">Medium Weight Fabric</h6>
                <small class="block" style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Weight</small>
              </div>
            </div>
            
            <div class="row mb__20" style="margin-top: 10px;">
              <div class="col-3"><img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/f4_6296240d-4388-4e2f-8e95-9c67d20c9ab8.png?v=1648536470" style="width: 100%;box-shadow:none"></div>
              <div class="col-9">
                <h6></h6>
                <small class="block" style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Style Suggestion</small>
              </div>
            </div>
            
            <div class="row mb__20" style="margin-top: 10px;">
              <div class="col-3"><img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/f2.png?v=1648535414" style="width: 100%;box-shadow:none"></div>
              <div class="col-9">
                <h6 style="font-family: 'Lato', sans-serif !important;
                text-transform: uppercase;
                letter-spacing: 2.5px !important;
                font-size: 10px !important;
                font-weight: 600 !important;">INDIA</h6>
                <small class="block" style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Country of Origin</small>
              </div>
            </div>
          </div>
          
          <div class="col-12 col-md-1" style="margin-top: 30px;">
          </div>
          
          <div class="col-12 col-md-3 product__desc"  style="margin-top: 30px;">
            <h6 class="m__0 mb__20" style="font-family: 'Lato', sans-serif !important;
            text-transform: uppercase;
            letter-spacing: 2.5px !important;
            font-size: 10px !important;
            font-weight: 600 !important;">MATERIAL & CAREeeee</h6>
             <div class="inner-html-list" 
           [innerHTML]="otherDescription"></div>
            <!-- <ul style="list-style-type: decimal;">
              <li style="font-size: 10px !important;
              font-family: 'Lato', sans-serif;
              font-style: italic !important;
              margin-top: 10px;">Rajan embroidery at chest</li>
              <li style="font-size: 10px !important;
              font-family: 'Lato', sans-serif;
              font-style: italic !important;
              margin-top: 10px;">Contrast tape at inner neckband</li>
              <li style="font-size: 10px !important;
              font-family: 'Lato', sans-serif;
              font-style: italic !important;
              margin-top: 10px;">Casual Button Down Collar</li>
            </ul> -->
            
            
            <h6 class="mt__40 mb__20" style="font-family: 'Lato', sans-serif !important;
            text-transform: uppercase;
            letter-spacing: 2.5px !important;
            font-size: 10px !important;
            font-weight: 600 !important; margin-top: 10px;">Wash Care</h6>
            <ul style="list-style-type: decimal;">
              <li><span style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Machine wash cold</span></li>
              <li><span style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Tumble dry</span></li>
              <li><span style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Gentle Cycle</span></li></ul>
          </div>
        </div>
      </div>
      
    </div>
    <hr _ngcontent-ept-c99="" class="mt__0">
    <div style="width: 90%; margin-left: 40px; margin-right: 40px;" class="detail_image">
      <img  src="../../../../../assets/images/linenraj/btfd.jpg" style="width: 105%; margin-top: 20px;height: 100%;">
    </div>
    <div style="width: 90%; margin-left: 14px; margin-right: 40px;" class="detail_image1">
      <img  src="../../../../../assets/images/linenraj/btfd.jpg" style="width: 105%; margin-top: 20px;">
    </div>
  
    
    <div style="display: flex; justify-content: center;">
    <h3 style="font-weight: 400;
    color: #111;
    line-height: 1.3;
    letter-spacing: 0.5px;
    font-family: 'Playfair Display', 'MillerBanner', serif !important;margin-top: 50px; margin-bottom: 10px;">Now Featuring</h3>
      
    </div>
    <div style="width: 100%;display: flex;justify-content: center;">
    <hr _ngcontent-ept-c99="" class="mt__0" style="width: 50px; display: flex; justify-content: center; margin-bottom: 30px; border: solid 1px black;">
  </div>
          <owl-carousel-o [options]="ProductSliderConfig" class="slider3 rounder-corner-nav">
          <ng-container *ngFor="let product of recommededProducts;let i =index">
          <ng-template carouselSlide >
              <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                <div style="overflow: hidden;"> <div class="linencard"> <img class="lin-content-image" [src]="product.assets[0].image_source" alt="{{ product.name }}"></div></div>
                      
                      <div class="linen_container product-list-description-special1">
                        <div class="grid_info" style="width: 100%;">
                          <p style="justify-content: center;
                          display: flex;">{{product.name}}</p>
                          <!-- <p style="justify-content: center;
                          display: flex;">₹ 2,000</p> -->
                        </div>
                      </div>
                  </a> </div>   
          </ng-template>
          <!-- <ng-template carouselSlide >
                <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                  <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_884b9d18-cb4f-45dd-b557-ab48cfb47e13_720x.jpg?v=1691169008&quot"></div></div>
                  <div class="linen_container product-list-description-special1">
                    <div class="grid_info" style="width: 100%;">
                      <p style="justify-content: center;
                      display: flex;">Geysers Valley Hotel</p>
                      <p style="justify-content: center;
                      display: flex;">₹ 2,000</p>
                    </div>
  
                  </div>
                    </a> </div>
          </ng-template>
            <ng-template carouselSlide >
                <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                  <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_f63ac386-08b1-4ba4-ace5-ba9e9a4dd548_540x.jpg?v=1691391149"></div></div>
                  <div class="linen_container product-list-description-special1">
                    <div class="grid_info" style="width: 100%;">
                      <p style="justify-content: center;
                      display: flex;">Geysers Valley Hotel</p>
                      <p style="justify-content: center;
                      display: flex;">₹ 2,000</p>
                    </div>
  
                  </div>
                    </a> </div>
          </ng-template>
            <ng-template carouselSlide >
              <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_0319c869-8eca-444d-a2a0-c49e067ff898_540x.jpg?v=1691168877&quot"></div></div>
                <div class="linen_container product-list-description-special1">
                  <div class="grid_info" style="width: 100%;">
                    <p style="justify-content: center;
                    display: flex;">Geysers Valley Hotel</p>
                    <p style="justify-content: center;
                    display: flex;">₹ 2,000</p>
                  </div>
  
                </div>
                  </a> </div>
        </ng-template>
          <ng-template carouselSlide >
            <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
              <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_d2933cbc-4898-460a-9009-461ed0342cba_540x.jpg?v=1691168793&quot"></div></div>
              <div class="linen_container product-list-description-special1">
                <div class="grid_info" style="width: 100%;">
                  <p style="justify-content: center;
                  display: flex;">Geysers Valley Hotel</p>
                  <p style="justify-content: center;
                  display: flex;">₹ 2,000</p>
                </div>
  
              </div>
                </a> </div>
      </ng-template>
        <ng-template carouselSlide >
          <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
            <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_6ff4fb71-f8b5-4f7b-82bb-de34cd3fc003_360x.jpg?v=1691168686&quot"></div></div>
            <div class="linen_container product-list-description-special1">
              <div class="grid_info" style="width: 100%;">
                <p style="justify-content: center;
                display: flex;">Geysers Valley Hotel</p>
                <p style="justify-content: center;
                display: flex;">₹ 2,000</p>
              </div>
  
            </div>
              </a> </div>
    </ng-template>
      <ng-template carouselSlide >
        <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
          <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_7b68c17a-ed9e-4224-b6f7-6cba7f4eaa35_540x.jpg?v=1691168732&quot"></div></div>
          <div class="linen_container product-list-description-special1">
            <div class="grid_info" style="width: 100%;">
              <p style="justify-content: center;
              display: flex;">Geysers Valley Hotel</p>
              <p style="justify-content: center;
              display: flex;">₹ 2,000</p>
            </div>
  
          </div>
            </a> </div>
  </ng-template>
    <ng-template carouselSlide >
      <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
        <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_cd354a57-a9ae-41ff-90ac-f0b0f88b3e99_720x.jpg?v=1691169028&quot"></div></div>
        <div class="linen_container product-list-description-special1">
          <div class="grid_info" style="width: 100%;">
            <p style="justify-content: center;
            display: flex;">Geysers Valley Hotel</p>
            <p style="justify-content: center;
            display: flex;">₹ 2,000</p>
          </div>
  
        </div>
          </a> </div>
  </ng-template>
  <ng-template carouselSlide >
                <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                  <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_924ddbaf-b76d-4b10-83f4-680378288a1b_720x.jpg?v=1691168988&quot"></div></div>
                  <div class="linen_container product-list-description-special1">
                    <div class="grid_info" style="width: 100%;">
                      <p >Geysers Valley Hotel</p>
                      <p >₹ 2,000</p>
                    </div>
  
                  </div>
                    </a> </div>
          </ng-template> -->
        </ng-container>
      </owl-carousel-o> 
  
    <div class="col-12" style="background-color: aliceblue;">
  
      <h3 class="text-center mb__30 mt__0" style="margin-top: 50px;padding-top: 33px; padding-bottom: 25px;">Need Help?</h3>
  
      <div class="row" style="padding-bottom: 30px;">
        <div class="col-2 hidden-xs"></div>
        <div class="col-12 col-md-3">
          <div class="row">
            <div class="col-2 col-md-2">
              <img src="https://cdn.shopify.com/s/files/1/0554/1419/4338/files/172517_phone_icon_b68229e3-5a4b-4b7b-ad96-fb6ee11bc8da.png?v=1631791927" style="width: 45px; box-shadow: none;">
            </div>
            <div class="col-10 col-md-10">
              <a href="tel:+919555263263">+91 978 777 13 59</a>978 777 13 59
              <small>(Mon - Fri, 10:00-6:30 IST)</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="row">
            <div class="col-2 col-md-2">
              <img src="https://cdn.shopify.com/s/files/1/0554/1419/4338/files/853339_whatsapp_icon_29be8559-1c55-41b3-85fd-ff7003598fb8.png?v=1631791926" style="width: 45px; box-shadow: none;">
            </div>
            <div class="col-10 col-md-10">
              <a href="tel:+919555263263">+91 978 777 13 59</a>
              <small>(Mon - Fri, 10:00-6:30 IST)</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="row">
            <div class="col-2 col-md-2">
              <img src="https://cdn.shopify.com/s/files/1/0554/1419/4338/files/185078_mail_email_icon_d5d54cdc-8c2f-40b7-b5a4-12b93eec568f.png?v=1631791927" style="width: 45px; box-shadow: none;">
            </div>
            <div class="col-10 col-md-10">
              <a href="mail-to:contact@andamen.com">care@linenraj.com</a>
              <small>(Typical response time: 24 hours)</small>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </div>
    <!-------tabs-------------------------->
    <div class="product-details-tabs" *ngIf="groups[5].showondetailpage && config.title !== 'BombayHardware' && config.title !== 'Babys Pride' && config.title !== 'LushNGreen' && config.title !=='KatbookStore' && config.title !=='ShubhCards' && config.title !== 'Taazah' &&  config.title !== 'SriSenbaga'">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-link headingTab" id="{{ 'nav-' + field.labelname + 'tab' }}"
            *ngFor="let field of groups[5].fields" data-toggle="tab" href="#nav-home" role="tab"
            aria-controls="nav-home" aria-selected="true" (click)="changeTab(field.labelname)">{{ field.labelname }}</a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade" *ngFor="let field of groups[5].fields" id="{{ 'nav-' + field.labelname }}"
          role="tabpanel" aria-labelledby="nav-home-tab">
          <!----------general info-->
          <div *ngIf="
              field.labelname == 'General Information' &&
              field.nestedinfo != undefined &&
              showData
            ">
            <div class="container" *ngFor="let item of groups[6].fields">
              <div class="row">
                <div class="col-md-3 general-info-label">
                  {{ item.labelname }}
                </div>
                <div class="col-md-4 general-info">
                  {{
                  metaDataMapService.findData(
                  newProductDetails,
                  item.nestedinfo
                  )
                  }}
                </div>
              </div>
            </div>
          </div>

                   <!-----reviews------>
                   <div *ngIf="field.labelname == 'Question And Answers'">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="inner-html-list" *ngIf="field.labelname == 'Question And Answers'" [innerHTML]="otherDescription"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--------------->
          <!----nutri facts-->
          <div *ngIf="field.labelname == 'Additional Information'">
            <span class="product-additional-info">{{ attributeTitle }}</span>
            <table *ngIf="config.title != 'Mayan'">
              <thead>
                <tr class="product-table-head">
                  <th *ngFor="let heads of tableHead" class="align">
                    {{ heads }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr class="productTableRow" *ngFor="let bodys of tableData; let i = index">
                  <td *ngFor="let body of bodys">{{ body }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-----reviews------>
          <div *ngIf="field.labelname == 'Reviews'" id="reviewcol">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <app-product-review></app-product-review>
                </div>
              </div>
            </div>
          </div>
          <!--------------->

          <!-----manufacture------>
          <div *ngIf="
              field.labelname == 'Manufacture Details' &&
              newProductDetails.additional_info.manufacture != ''
            ">
            <div class="container">
              <div class="row">
                <div class="col-md-7">
                  {{ newProductDetails.additional_info.manufacture }}
                </div>
              </div>
            </div>
          </div>
          <!--------------->

          <div *ngIf="
              field.labelname != 'General Information' &&
              field.labelname != 'Additional Information' &&
              field.labelname != 'Reviews' &&
              field.labelname != 'Manufacture Details' &&
              field.nestedinfo != undefined &&
              showData
            "></div>
          <div class="inner-html-list" *ngIf="
              field.labelname == 'Description' && config.title == 'EarthyWorthy'
            " [innerHTML]="shortDescription"></div>
          <div class="inner-html-list" *ngIf="
              field.labelname == 'Additional Informations' &&
              config.title == 'EarthyWorthy'
            " [innerHTML]="shortDescription"></div>
          <div class="inner-html-list" *ngIf="field.labelname == 'Description'" [innerHTML]="shortDescription"></div>
          <div class="inner-html-list" *ngIf="
              field.labelname == 'Additional Informations' &&
              config.title !== 'Deera' && config.title !== 'Babys Pride' && config.title !== 'BestGifts' && config.title !== 'Karupattiraja' && config.title !== 'SpecialWires' && config.title !== 'Vistas'
            " [innerHTML]="shortDescription"></div>
            <div class="inner-html-list" *ngIf="config.title === 'Vistas' && field.labelname == 'Additional Informations'" [innerHTML]="shortDescription"></div>
            <div class="inner-html-list" *ngIf="config.title === 'SpecialWires' && field.labelname == 'Additional Informations'" [innerHTML]="shortDescription"></div> 
          <div class="inner-html-list" *ngIf="
              field.labelname == 'Additional Informations' &&
              config.title === 'Deera' || config.title === 'Babys Pride' || config.title === 'BestGifts' || config.title === 'AvonSeals'|| config.title === 'Karupattiraja'
            " [innerHTML]="otherDescription"></div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
    <section class="quote vistas-homebackground" *ngIf="config.title == 'Vistas'">
      <div style="display: flex;justify-content: center; margin-top: 87px;">
        <div  style="border-left: 4px solid black;
        height: 36px;"> 
        </div>
    </div>
      <div class="title-div" style="margin-top: 20px; margin-left: 38px;text-align: center;">
        <p class="content-title3 title-box title main-title">
          Related Products
        </p>
      </div> 
      <br><br>
      <div>
      <owl-carousel-o [options]="ProductSliderConfig" class="slider3 rounder-corner-nav">   
           
        <ng-container class="prodinfo" *ngFor="let product of recommededProducts;let i =index">
          <ng-template carouselSlide >
          <div class="product-list-cards-specialwires4" style="color: lightgray;">
            <div class="special-img">
          <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
          class="product-list-image-specialwires" style="display: initial; max-height: 140px;"/>
        </div>
        <div class="product-list-description-special1">
          <div class="d-flex special_home_prodname" style="width: 100%; margin-bottom: 17px; display: flex; justify-content: center;">
                <p (click)="productDetails(product.id)" class="product-list-tile-vistas">{{product.name}}
                </p>
              </div>
              <div class="row4" style="display: flex;justify-content: center;">
                <div class="inner-star-icon review-mob2 pd-1">
                  <span  style="font-size: 13px !important;color: black !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                  <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                  <span  style="font-size: 13px !important;color: black !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                  <span  style="font-size: 13px !important;color: black !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                  <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                </div>
                </div>
              <div class="d-flex vistas-button1" style="margin-bottom: 10px; justify-content: center;">
                <button class="vistas-atc1"  (click)="productDetails(product.id)">
                        BUY NOW
                        <span> <i class="fa fa-shopping-cart"></i></span>
                      </button>
                    </div>
        </div>
        
        </div>
        </ng-template>
    </ng-container>          
    </owl-carousel-o>
    </div>
    </section>
    <section class="quote vistas-homebackground" *ngIf="config.title == 'LushNGreen'">
    <div class="col-md-12">
      <div>
        <div class="lushhomebes1">RELATED PRODUCTS</div>
        <div style="display: flex;justify-content: center;">
        <hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
      </div>
        <div class="lushbests">
        <div class="thumb2-lush">
          

    <div style="margin-right: 20px;width: 100%;">
      <div class="row inq-pro-sec-st listProducthome">

<div class="product-list-cards-baby2" style="margin-top: 15px;width: 100%;">

  <div class="deera-img button-overlay" style="width: 100%;">

    <img src="../../../../assets/images/lushngreen/LnG-P-image-2.jpg" class="newcollection-image-baby" width="100%" />
  </div>
  
  <div class="product-list-description-baby1" style="width: 100%;">
      <div class="d-flex justify-content-between">
        <div>
          <p class="baby-newcol-name"> Calathea Freddie
          </p>
        </div>
      </div>

    <div class="d-flex justify-content-between mt-1">

        <span class="col-right">
        <div style="display: flex;"> 
        
        <p class="baby-newcol-price"> ₹240.00
        </p>
        <span class="lush-strikehome">₹520.00</span>
      </div>  
    </span>
    </div>
  </div>
</div>     
</div>
</div>
<div style="margin-right: 20px;width: 100%;">
<!-- <div >Dresses for All</div> -->

<div class="row inq-pro-sec-st listProducthome">

<div class="product-list-cards-baby2" style=" margin-top: 15px;width: 100%;">

<div class="deera-img button-overlay" style="width: 100%;">

<img src="../../../../assets/images/lushngreen/LnG-P-image-3.jpg" class="newcollection-image-baby" width="100%" />
</div>

<div class="product-list-description-baby1" style="width: 100%;">
<div class="d-flex justify-content-between">
  <div>
    <p class="baby-newcol-name"> Aglaonema Butterfly
    </p>
  </div>
</div>

<div class="d-flex justify-content-between mt-1">

  <span class="col-right">
  <div style="display: flex;"> 
  
  <p class="baby-newcol-price"> ₹300.00
  </p>
  <span class="lush-strikehome">₹550.00</span>
</div>  
</span>
</div>
</div>
</div>     
</div>
</div>
<div style="margin-right: 20px;width: 100%;">
<!-- <div >Dresses for All</div> -->

<div class="row inq-pro-sec-st listProducthome">

<div class="product-list-cards-baby2" style=" margin-top: 15px;width: 100%;">

<div class="deera-img button-overlay" style="width: 100%;">

<img src="../../../../assets/images/lushngreen/LnG-P-image-4.jpg" class="newcollection-image-baby" width="100%" />
</div>

<div class="product-list-description-baby1" style="width: 100%;">
<div class="d-flex justify-content-between">
<div>
  <p class="baby-newcol-name"> Philodendron Broken Heart
  </p>
</div>
</div>

<div class="d-flex justify-content-between mt-1">

<span class="col-right">
<div style="display: flex;"> 

<p class="baby-newcol-price"> ₹220.00
</p>
<span class="lush-strikehome">₹430.00</span>
</div>  
</span>
</div>
</div>
</div>     
</div>
</div>
<div style="margin-right: 20px;width: 100%;">
  <!-- <div >Dresses for All</div> -->

  <div class="row inq-pro-sec-st listProducthome">

<div class="product-list-cards-baby2" style=" margin-top: 15px;width: 100%;">

<div class="deera-img button-overlay" style="width: 100%;">

<img src="../../../../assets/images/lushngreen/LnG-P-image-5.jpg" class="newcollection-image-baby" width="100%" />
</div>

<div class="product-list-description-baby1" style="width: 100%;">
  <div class="d-flex justify-content-between">
    <div>
      <p class="baby-newcol-name"> Monstera Deliciosa
      </p>
    </div>
  </div>

<div class="d-flex justify-content-between mt-1">

    <span class="col-right">
    <div style="display: flex;"> 
    
    <p class="baby-newcol-price"> ₹540.00
    </p>
    <span class="lush-strikehome">₹860.00</span>
  </div>  
</span>
</div>
</div>
</div>     
</div>
</div>
    </div>
  </div>
      </div>
    </div>
      
    </section>
    <section class="quote vistas-homebackground" *ngIf="config.title == 'ShubhCards'|| config.title == 'SriSenbaga'">
      <div class="col-md-12">
        <div>
          <h3  *ngIf="config.title == 'ShubhCards'" class="lushhomebes1 desktop-only" style="color: #fe6602;padding-left: 90px !important">View Similar Products</h3>
          <h3 *ngIf="config.title == 'SriSenbaga'" class="desktop-only" style="color: #27266a;padding-left: 75px !important;">View Similar Books</h3>
          <h5  *ngIf="config.title == 'ShubhCards'" class="lushhomebes1 mobile-only" style="color: #fe6602;padding-left: 90px !important">View Similar Products</h5>
          <h5  *ngIf="config.title == 'SriSenbaga'" class="lushhomebes1 mobile-only" style="color: #27266a;padding-left: 90px !important;margin-top: 5%;">View Similar Books</h5>
          <div style="display: flex;justify-content: center;" class="row desktop-only">
            <div col-1>

            </div >
                    <div class="vimpro-container1 col-10" style="display: flex;justify-content: center;padding-top: 2%;padding-bottom: 2%;" >
                      <div class="new-shub-grid">
                        <div class="container image-container-list d-flex justify-content-center align-items-center" *ngFor="let pro of recommededProducts | slice:0:3; 
                       let i=index">
                           
                              <img [src]="pro.assets[0].image_source" class="img-thumbnail" style="height: 100%; width: 100%;border: none;    object-fit: contain;" (click)="productDetails(pro.id)">
                
                             <div style="align-self: flex-end;height: 10%;position: absolute;">
                              <div  *ngIf="config.title == 'ShubhCards'" style="color:#fe6602 ;text-align: center;">{{pro.name}} </div>
                              <div  *ngIf="config.title == 'SriSenbaga'" style="color:#27266a ;text-align: center;">{{pro.name}} </div>
                              <!-- <div style="color: #6b6b6b;text-align: center;">₹ {{pro.pricing.raw.price}} </div> -->
                              <div *ngIf="config.title == 'ShubhCards'" style="text-align:center;"><button type="button" class="btn" style="background-color:#fe6602 ;color: white;" (click)="productDetails(pro.id)">Buy Now</button> </div>
                              <div *ngIf="config.title == 'SriSenbaga'" style="text-align:center;"><button type="button" class="btn" style="background-color:#27266a ;color: white;" (click)="productDetails(pro.id)">Buy Now</button> </div>

                             

                             </div>      
                         
                        </div>
                
                      </div>
                      
                      </div>
                      <div col-1>
            
                      </div >
                     
          
        </div>
        <div *ngIf="recommededProducts.length != 0" class="mobile_images mobile-only">
          <div class="container" style="width:94%!important">
            

        
        <owl-carousel-o [options]="ProductSliderConfig1" class="slider rounder-corner-nav"style="margin-top: 28px;position: relative;" >
          <ng-container 
            *ngFor="let product of recommededProducts; let i = index">
            <ng-template carouselSlide>
                <app-product-box-one [product]="product" [index]="i" style="display:block;width: 98%;margin-left: 1%;"></app-product-box-one>              
            </ng-template>                 
          </ng-container>
        </owl-carousel-o>
        
          </div>
        </div>

        <button   *ngIf="recommededProducts.length>3 && config.title == 'ShubhCards'" class="desktop-only" style="float: right;position: relative;left: -2%;border: none;background: none;color: #fe6602;" (click)="backToList()">More</button>
        <button  *ngIf="recommededProducts.length>3 && config.title == 'SriSenbaga'" class="desktop-only" style="float: right;position: relative;left: -2%;border: none;background: none;color: #27266a;" (click)="backToList()">More</button>
        </div>
      </div>
        
      </section>
    <section class="quote vistas-homebackground" *ngIf="config.title == 'Babys Pride'" style="margin-top: 60px;">
      <div class="title-div" style="margin-top: 20px; margin-left: 38px;text-align: center;">
        <p class="content-title3 title-box title main-title">
          YOU MAY ALSO LIKE
        </p>
      </div> 
      <br><br>
      <div class="desktop-only">
      <owl-carousel-o [options]="ProductSliderConfig7" class="slider3 rounder-corner-nav">   
           
        <ng-container class="prodinfo" *ngFor="let product of recommededProducts;let i =index">
          <ng-template carouselSlide >
            <div *ngIf="config.title === 'Babys Pride'" class="deera-container">
              <div class="product-list-cards-baby1" style="color: lightgray">
                <div class="deera-img">
            
                  <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                    class="product-list-image-baby1" />
                </div>
                
            
              </div>
        <div class="product-list-description-baby1">
            <div class="d-flex justify-content-between">
              <div>
                <p (click)="productDetails(product.id)" class="product-list-tile-baby1">{{product.name}}
                </p>
            </div>
          </div>
    
          <div class="d-flex justify-content-between mt-1">
    
              <span class="col-right" *ngFor="let items of product.variant.option_values; let j = index">
              <div *ngIf="(appService.productIdinCart.indexOf(items.id) == -1) || (product.product_type == 'Variation' &&
              appService.productIdinCart.indexOf(items.id) == -1)"  style="display: flex;"> 
              <span *ngIf="items.is_default" style="font-size: 14px !important;margin-right: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ items.pricing.raw.msrp }}.00</span>
                <p *ngIf="items.is_default" class="product-list-price-baby" >
                    ₹{{items.pricing.raw.price}}.00
                  
                   <!-- <span *ngIf="priceStrikeOutInDetailScreen === 'true' && strikeOutPriceKey === 'MSRP' && items.is_default" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ items.pricing.raw.msrp }}</span> -->

              </p>
            </div>  
          </span>
          </div>
      </div>     
            </div>
        
        </ng-template>
    </ng-container>          
    </owl-carousel-o>

    </div>
    <div class="mobile-only">
      <owl-carousel-o [options]="ProductSliderConfig6" class="slider3 rounder-corner-nav">   
           
        <ng-container class="prodinfo" *ngFor="let product of recommededProducts;let i =index">
          <ng-template carouselSlide >
            <div *ngIf="config.title === 'Babys Pride'" class="deera-container">
              <div class="product-list-cards-baby1" style="color: lightgray">
                <div class="baby-img-detail">
            
                  <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                    class="product-list-image-baby1" />
                </div>
                
            
              </div>
        <div class="product-list-description-baby1">
            <div class="d-flex justify-content-between">
              <div>
                <p (click)="productDetails(product.id)" class="product-list-tile-baby1">{{product.name}}
                </p>
            </div>
          </div>
    
          <div class="d-flex justify-content-between mt-1">
    
              <span class="col-right" *ngFor="let items of product.variant.option_values; let j = index">
              <div *ngIf="(appService.productIdinCart.indexOf(items.id) == -1) || (product.product_type == 'Variation' &&
              appService.productIdinCart.indexOf(items.id) == -1)"  style="display: flex;"> 
              <span *ngIf="items.is_default" style="font-size: 14px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ items.pricing.raw.msrp }}.00</span>
                <p *ngIf="items.is_default" class="product-list-price-baby" >
                    ₹{{items.pricing.raw.price}}.00
                  
                   
              </p>
            </div>  
          </span>
          </div>
      </div>     
            </div>
        
        </ng-template>
    </ng-container>          
    </owl-carousel-o>
    </div>
    </section>
    <section class="quote vistas-homebackground" *ngIf="config.title == 'KatbookStore'" style="margin-top: 40px;">
      <div style="margin-left: 3%;margin-right: 3%;margin-bottom: 40px;">
        <div style="border: 1px #dcdcdc solid;padding-top: 15px;">
      <div class="title-div" style="margin-top: 10px; margin-left: 3%;">
        <p class="Kat_detail_related_title2">
          Book Details :
        </p>
        <div class="normalSize specialsize" [innerHTML]="contentOtherDesc">
        </div>
      </div>
    </div>
  </div>
    </section>
    <section class="quote vistas-homebackground Kat_grid_wid" *ngIf="config.title == 'KatbookStore'" style="margin-top: 60px;">
      
      <div style="margin-top: 40px;margin-bottom: 100px;" class="desktop-only">
        <div class="kat_home_title">
          <span style="font-size: 30px;font-weight: 600;font-family: system-ui;margin-left: 3%;">Related Books</span>
          <!-- <a style="font-size: 26px;font-weight: 600;font-family: system-ui;color: #23a6f0 !important;cursor: pointer;" (click)="productsListNewarrival()">See all <i class="fa fa-arrow-right"  style="font-size: 16px !important;transform: translate(0px, -2px);"></i></a> -->
        </div>
  <div   style="display: grid; grid-template-columns: repeat(5, 1fr);margin-left: 5%;margin-right: 5%;">
  
  <div class="desktop-only card shadow-lg p-4 bg-body rounded kbookcrd" style="margin-left: 6%; margin-right: 6%; margin-bottom: 10px; box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);" *ngFor="let product of recommededProducts; let i = index">
    
  <div class="container">
  
      
      <div class="row">
        <div class="col">
          <div class="container container_kbook">
          <div>
            <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                    class="newcollection-image-baby"style="object-fit: contain;max-width: 100%; max-height: 100%;position: absolute;  top: 0;left: 0; right: 0;  bottom: 0; margin: auto;"  />
          </div>
           
          </div>
            </div>
      </div>
  
    
            </div>
            <div class="card-body">
              <div class="d-flex ">
                
                <div style="width: 100%;margin-bottom: 15px;">
                  <div style="display: flex;" class="justify-center-kat" (click)="productDetails(product.id)">
                    <p class="kat-newcol-sku1" style="text-transform: uppercase;"> {{product.name}}
                    </p>
                  </div>
                  <div style="display: flex;" class="justify-center-kat" (click)="productDetails(product.id)">
                  <p *ngIf="product.attributes[0]" class="kat-newcol-name" style="color: #a12a2a;"> {{product.attributes[0].section_title}}
                  </p>
                </div>
                  <div style="display: flex;" class="justify-center-kat kat_martop-col">
                    
                  <p   *ngIf="product.categorynames" class="kat-newcol-price" style="color: #23a6f0;"> {{product.categorynames[0].name}}
                    <!-- <span style="font-size: 11px !important;margin-left: 5px !important;text-decoration: line-through;color: #fa6464d9 !important;">₹{{ product.pricing.raw.msrp}}.00</span> -->
                  </p>
                </div>
                </div>
            </div>
            <div style="display: flex;justify-content: center;margin-bottom: 10px;">
              <button class="btn_kat_home" (click)="productDetails(product.id)" style="width: 100%;">Choose Book</button>
            </div>
            </div>
           
          </div>
        </div>
      </div> 
      <!-- <div class="desktop-only Kat_grid_related">

            
        <div style="margin-left: 6%; margin-right: 6%; margin-top: 20px; box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);" *ngFor="let product of recommededProducts; let i = index">
              
          <div style="">
          
              
              <div class="baby-newcollection">
                <div class="product-list-description-baby">
                  <div class="product-centering-baby">
                  <div  (click)="productDetails(product.id)">
                    <img [src]="product.assets[0].image_source" id="img-list"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                            class="newcollection-image-baby" style="width: 60%;"  />
                  </div>
                      <div class="d-flex Kat_newprodname">
                        
                        <div style="width: 100%;margin-bottom: 15px;">
                          <div style="display: flex;justify-content: center;cursor: pointer;" class="justify-center-kat">
                            <p class="product-deta-tile-kat" (click)="productDetails(product.id)"> {{product.sku}}
                            </p>
                          </div>
                          <div style="display: flex;justify-content: center;text-align: center; cursor: pointer;" class="justify-center-kat">
                          <p class="product-deta-tile-kat1" (click)="productDetails(product.id)"> {{product.name}}
                          </p>
                        </div>
                          <div style="display: flex;justify-content: center;" class="justify-center-kat kat_martop-col">
                            
                          <p class="product-deta-price-kat"> ₹{{product.pricing.raw.price}}.00
                            <span class="product-deta-price-kat1">₹{{ product.pricing.raw.msrp}}.00</span>
                          </p>
                        </div>
                        </div>
                    </div>
                    <div style="display: flex;justify-content: center;margin-bottom: 10px;">
                      <button class="btn_kat_home" (click)="productDetails(product.id)">Purchase</button>
                    </div>
                  </div>
                    </div>
              </div>
          
            
                    </div>
                  
                  </div>


    </div> -->
    
    <div class="mobile-only mar-Kat_lR">
      <owl-carousel-o [options]="ProductSliderConfig6" class="slider3 rounder-corner-nav">   
           
        <ng-container class="prodinfo" *ngFor="let product of recommededProducts;let i =index">
          <ng-template carouselSlide >
            <div class="Kat-newcollection">
              <div class="product-list-description-baby">
                <div class="product-centering-baby">
                <div  (click)="productDetails(product.id)">
                  <img [src]="product.assets[0].image_source" id="img-list"
                          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                          class="newcollection-image-baby" style="width: 60%;"  />
                </div>
                    <div class="d-flex Kat_newprodname">
                      
                      <div style="width: 100%;margin-bottom: 15px;">
                        <div style="display: flex;justify-content: center;cursor: pointer;" class="justify-center-kat">
                          <p class="product-deta-tile-kat" (click)="productDetails(product.id)"> {{product.sku}}
                          </p>
                        </div>
                        <div style="display: flex;justify-content: center;text-align: center; cursor: pointer;" class="justify-center-kat">
                        <p class="product-deta-tile-kat1" (click)="productDetails(product.id)"> {{product.name}}
                        </p>
                      </div>
                        <div style="display: flex;justify-content: center;" class="justify-center-kat kat_martop-col">
                          
                        <p class="product-deta-price-kat"> ₹{{product.pricing.raw.price}}.00
                          <span class="product-deta-price-kat1">₹{{ product.pricing.raw.msrp}}.00</span>
                        </p>
                      </div>
                      </div>
                  </div>
                  <div style="display: flex;justify-content: center;margin-bottom: 10px;padding-bottom: 10px;">
                    <button class="btn_kat_home" (click)="productDetails(product.id)">Purchase</button>
                  </div>
                </div>
                  </div>
            </div>
        
        </ng-template>
    </ng-container>          
    </owl-carousel-o>
    </div>
    </section>
    
</section>

<section *ngIf="config.title=='LinenRaj'">
  <style>
    .linencard {
  height: auto;
  /*min-width: 90%;*/
  background-color: white;
  margin: 0px auto 0px;
  background-size: contain;
  object-fit: cover;
  max-width: 600px;
  box-sizing: border-box;
  border-radius: 10px;
  background-repeat: no-repeat;
 
 
}

.linencard img {
  width: -webkit-fill-available;
  height: auto;
  border-radius: 10px;
  box-sizing: border-box;
}


.linencard img:hover {

  box-sizing: border-box;
  
 
}
/* .linencard:hover{
  width: 100%!important;
  animation: ani-fadeIn 1.25s cubic-bezier(.26,.54,.32,1) forwards;
  transform: scale(1.2);
  transition: opacity .3s,transform 8s cubic-bezier(.25,.30,.45,.94);
  height: 90%!important;
  max-height: 500px!important;
  border-radius: 10px;
  box-sizing: border-box;
 

} */
  </style>
  <!-- <div class="product_details" style="display: flex; margin-top: 40px;">
    <div class="productDetailImage" style="width: 60%;">
      <div style="display: grid; grid-template-columns: repeat(2, 1fr);margin-left: 30px;" >
        <div class="linen_img">
      <img class="linendetailimg" src="../../../../../assets/images/linenraj/detail1.jpg">
    </div>
    <div class="linen_img">
      <img class="linendetailimg" src="../../../../../assets/images/linenraj/detail2.jpg">
    </div>
      <div class="linen_img">
      <img class="linendetailimg" src="../../../../../assets/images/linenraj/detail3.jpg">
    </div>
      <div class="linen_img">
      <img class="linendetailimg" src="../../../../../assets/images/linenraj/detail4.jpg">
    </div>
      <div class="linen_img">
      <img class="linendetailimg" src="../../../../../assets/images/linenraj/detail5.jpg">
    </div>
      <div class="linen_img">
      <img class="linendetailimg" src="../../../../../assets/images/linenraj/detail6.jpg">
    </div>
    </div>
    </div>
    <div id="shopify-section-pr_summary" style="width: 40%;" class="shopify-section entry-summary mt__10"><h1 class="product_title entry-title" style="font-size: 36px; color: #a77737;
    margin: 30px 0 0 !important; text-align: center; font-family: 'Playfair Display', 'MillerBanner', serif;">Taupe Basket Linen</h1>
      <h6 class="product-subtitle"> <p style="font-size: 10px;text-align: center; font-family: 'Lato', sans-serif;">Beige Men's Semi Formal Shirt</p></h6><div class="flex wrap fl_between al_center price-review">
         <p class="price_range" id="price_ppr" style="text-align: center; font-size: 22px;font-style: italic;">₹ 2,000</p>

         </div>
         <div class="row4" style="display: flex;justify-content: center;">
          <div class="inner-star-icon review-mob2 pd-1">
            <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
            <span style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
            <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
            <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
            <span style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
          </div>
          <span class="jdgm-qa-badge__text" style="margin-top: 4px;">
            No reviews
          </span>
          <br>
          <span class="jdgm-qa-badge " style="height: 16px; transform: translate(0px, 6px);">
  
            <i class="fa fa-comments" style="color: #a77737; transform: translate(0px, -5px);"></i>

          <span class="jdgm-qa-badge__text" style=" transform: translate(0px, -5px);">
            No questions
          </span>
        </span>

        
          </div>
            <div style="display:flex;margin-left: 66px;margin-top: 20px;">
            <div class="swatch-button-title-text" swatch-inside="true"><span swatch-inside="true" style="border: 1px solid #868484; width: 60px; display: flex;justify-content: center;margin-right: 20px;height: 30px;border-radius: 7px;"><p style="text-align: center; font-size: 10px;margin-top: 7px;">S</p></span></div>
            <div class="swatch-button-title-text" swatch-inside="true"><span swatch-inside="true" style="border: 1px solid #868484; width: 60px; display: flex;justify-content: center;margin-right: 20px;height: 30px;border-radius: 7px;"><p style="text-align: center;font-size: 10px;margin-top: 7px;">M</span></div>
            <div class="swatch-button-title-text" swatch-inside="true"><span swatch-inside="true" style="border: 1px solid #868484; width: 60px; display: flex;justify-content: center;margin-right: 20px;height: 30px;border-radius: 7px;"><p style="text-align: center;font-size: 10px;margin-top: 7px;">L</span></div>
              <div class="swatch-button-title-text" swatch-inside="true"><span swatch-inside="true" style="border: 1px solid #868484; width: 60px; display: flex;justify-content: center;margin-right: 20px;height: 30px;border-radius: 7px;"><p style="text-align: center;font-size: 10px;margin-top: 7px;">XL</span></div>
                <div class="swatch-button-title-text" swatch-inside="true"><span swatch-inside="true" style="border: 1px solid #868484; width: 60px; display: flex;justify-content: center;height: 30px;border-radius: 7px;"><p style="text-align: center;font-size: 10px;margin-top: 7px;">XXL</span></div>
          </div>
          <p style="font-size: 10px !important; font-family: 'Lato', sans-serif; font-style: italic !important;margin-top: 10px; margin-left: 105px;">Our model is 187 cms, chest 37 and is wearing a size medium, slim fit.</p>
          <div style="width: 100%;">
          <button class="button-62" style="margin-left: 39%;margin-top: 20px;">
          Add to Cart
          </button>
        </div>
        <div class="row" style="justify-content: space-around !important; margin-left: 20px;">
                                    
                                    
          <div class="col-4" style="max-width: 23% !important;">
            <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/delivery-status.png?v=1660022911" width="40px" style="box-shadow: none;">
            <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">60 Day Returns</p>
          </div>

          <div class="col-4" style="max-width: 23% !important;">
            <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/delivery-truck.png?v=1660022911" width="40px" style="box-shadow: none;">
            <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">Free Shipping</p>
          </div>

          <div class="col-4" style="max-width: 23% !important;">
            <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-cash-on-delivery.png?v=1677139182" width="40px" style="box-shadow: none;">
            <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">Cash On Delivery</p>
          </div>
          
        </div>
        <hr class="mt__0">
        <h6 style="font-family: 'Lato', sans-serif !important;
        text-transform: uppercase;
        letter-spacing: 2.5px !important;
        font-size: 10px !important; margin-left: 20px;
        font-weight: 600 !important;">Check delivery</h6>
        <div class="form-wrapper flex" style="width: 70%; margin-left: 25px;">
          <input type="text" name="pincode_text" id="pincode_text" placeholder="Enter Pin Code" style="width: 80%; border-right: none;height: 37px;
          border-radius: 6px 0 0 6px;">
          <input type="button" name="checkPincode" id="checkPincode" value="Check" style="border-left: none;
          border-radius: 0 6px 6px 0;
          background: transparent;
          text-transform: uppercase;width: 67px;
          font-size: 10px;
          letter-spacing: 2.5px;
          font-weight: 600;
          color: #a77737 !important;transform: translate(0px, -3px);
    height: 38px;">
        </div>
        <div class="social-wrapper">
          <h6 class="text-light ml__10 mb__10" style="color: black !important;font-family: 'Lato', sans-serif !important;
          text-transform: uppercase;
          letter-spacing: 2.5px !important;
          font-size: 10px !important;
          margin-left: 20px;
          font-weight: 600 !important; margin-top: 10px;">Share</h6>
          <a data-no-instant="" rel="noopener noreferrer nofollow" href="https://www.facebook.com/sharer/sharer.php?u=https://www.andamen.com/products/lilac-grid-linen" target="_blank" class="facebook cb ttip_nt tooltip_top" data-bss-pl="active" data-position="5">
              
              <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/002-facebook_986e113b-f806-4c65-b6fd-e0d3e8809ad3.png?v=1646371857" style="height: 23px;margin-left: 20px; box-shadow: none;">
           </a><a data-no-instant="" rel="noopener noreferrer nofollow" href="mailto:?subject=Lilac%20Grid%20Linen&amp;body=https://www.andamen.com/products/lilac-grid-linen" target="_blank" class="email cb ttip_nt tooltip_top" data-bss-pl="active" data-position="6">
              
              <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-email.png?v=1646371636" style="height: 27px;margin-left: 20px; box-shadow: none;">
           </a><a data-no-instant="" rel="nofollow" target="_blank" class="whatsapp cb ttip_nt tooltip_top" href="https://wa.me/?text=Lilac%20Grid%20Linen https://www.andamen.com/products/lilac-grid-linen" data-bss-pl="active" data-position="7"> 
              
               <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-whatsapp.png?v=1646371846" style="height: 21px;margin-left: 20px; box-shadow: none;">
            </a></div>
            <h6 class="m__0 mb__20" style="    font-family: 'Lato', sans-serif !important;
            text-transform: uppercase;
            letter-spacing: 2.5px !important;
            font-size: 10px !important;
            margin-left: 20px;
            font-weight: 600 !important;
            margin-top: 22px;">Description</h6>
            <p style="font-size: 13.5px;
            letter-spacing: 0.5px;
            line-height: 1.7;margin-left: 16px;">Made from a linen blend in a timeless dobby weave. Crafted from one of Earth’s friendliest fibres, linen from European flax is a super crop that requires zero manual irrigation, is 100% biodegradable and enriches the soil as it grows. Features textured fabrics, a narrow cutaway collar &amp; Rajan, the mark of Andamen. Preferred care: Machine wash cold, gentle cycle &amp; tumble dry.</p>
  </div>
  </div> -->
  <div class="col-md-12 col-12 thumb_2" style="transform: none;">
    <div class="row mb__50 pr_sticky_content" style="transform: none;">
     
      <div class="col-md-7 col-12 pr product-images img_action_zoom pr_sticky_img" data-pr-single-media-group="">
          <div class="row theiaStickySidebar">
            
            <div class="productDetailImage" style="display: grid; grid-template-columns: repeat(2, 1fr);margin-left: 10%;
            margin-right: 5%;grid-column-gap: 2%;" >
              <div  *ngFor="let item of newProductDetails.assets; let i = index">
                <div class="linen_img title_message" *ngIf="newProductDetails.product_type=='Variable'">
              <img class="linendetailimg" [src]="item.image_source">
            </div>
            </div>
</div>
       </div>
       <div style="margin-bottom: 10px;" class="mobile-only">
        <span class="home-breadcrumb"  id="breadCrumbProductDetails" routerLink="">Home</span>
        <span class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="productListing()">
          <i class="px-2" id="breadCrumbProductDetails">/</i>Products</span>
          <span class="customer-breadcrumb" id="breadCrumbProductDetails">
            <i class="px-2" id="breadCrumbProductDetails" >/</i>{{product.name|titlecase}}</span></div>
       <div class="cle-bannerimage title_message1" style="height: 100%!important;">
        <div class="">
          <div class="special-homeslide">
            <div id="myCarousel" class="carousel slide" data-ride="carousel">
              <!-- Indicators -->
              <ol class="carousel-indicators special-carousel" style="margin-right: 10%!important;">
                <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
                <li data-target="#myCarousel" data-slide-to="1"></li>
                <li data-target="#myCarousel" data-slide-to="2"></li>
                <li data-target="#myCarousel" data-slide-to="3"></li>
              </ol>
            
              <!-- Slides -->
              <div class="carousel-inner" style="width: 85%;left: 8%;">
                <div class="carousel-item" [class.active]="i==0" style="" *ngFor="let item of newProductDetails.assets; let i = index">
                  <img class="img-fluid rounded-start img_shop cle-bannerimg" style="max-width: 100%;
                  height: auto;" id="precise_size" src="{{item.image_source}}" alt="{{item.alt_text}}">
                  
                </div>
               
              </div>
             
            </div>
            </div>
        </div>
      </div>
      </div>
      <div class="col-md-5 col-12 product-infors pr_sticky_su is_sticky" style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">              
         <div class="theiaStickySidebar linen_detail" style="">
          <div style="margin-bottom: 10px;" class="desktop-only">
            <span class="home-breadcrumb"  id="breadCrumbProductDetails" routerLink="">Home</span>
            <span class="customer-breadcrumb" id="breadCrumbProductDetails"(click)="productListing()">
              <i class="px-2" id="breadCrumbProductDetails">/</i>Products</span>
              <span class="customer-breadcrumb" id="breadCrumbProductDetails">
                <i class="px-2" id="breadCrumbProductDetails" >/</i>{{product.name|titlecase}}</span></div>
          <div id="shopify-section-pr_summary" style="width: 100%;" class="shopify-section entry-summary mt__10"><h2 class="product_title entry-title" style="font-size: 24px; color: #a77737;
            margin: 15px 0 0 !important; text-align: left; font-family: 'Playfair Display', 'MillerBanner', serif;">{{product.name|titlecase}}</h2>
              <!-- <h6 class="product-subtitle"> <p style="font-size: 10px;text-align: center; font-family: 'Lato', sans-serif;">Beige Men's Semi Formal Shirt</p></h6><div class="flex wrap fl_between al_center price-review"> -->
                
        
                 </div>
                 <div class="row4 linen-revpri" style="display: flex;">
                  <p class="price_range" id="price_ppr" style="font-size: 20px;">₹ {{linenRajPrice}}</p>
                  <!-- <div class="inner-star-icon review-mob2 pd-1" style="margin-top: 1%;margin-left: 5%;" (click)="productReview()">
                    <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                    <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                    <span  style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: #a77737 !important;"><i class="fa fa-star" aria-hidden="true"></i></span>
                  </div> -->

                  <!-- <form [formGroup]="productRating" style="text-align:center;">
                  <div class="form-group row">
                    <div class="rating">
                      <input type="radio" id="star5" formControlName="rating" value=5 /><label for="star5" title="Excellent">5 stars</label>
                      <input type="radio" id="star4" formControlName="rating" value=4 /><label for="star4" title="Good">4 stars</label>
                      <input type="radio" id="star3" formControlName="rating" value=3 /><label for="star3" title="Not bad">3 stars</label>
                      <input type="radio" id="star2" formControlName="rating" value=2 /><label for="star2" title="Bad">2 stars</label>
                      <input type="radio" id="star1" formControlName="rating" value=1 /><label for="star1" title="Worst">1 star</label>
                    </div>
                    </div>
                  </form> -->
                  <!-- <div [formGroup]="productRating">
                    <fieldset class="rating">
                        <input type="radio" id="star5" formControlName="rating" value=5 /><label class="full" for="star5"
                            title="Excellent"></label>
                        <input type="radio" id="star4half" formControlName="rating" value=4.5 /><label class="half"
                            for="star4half" title="Excellent"></label>
                        <input type="radio" id="star4" formControlName="rating" value=4 /><label class="full" for="star4"
                            title="Good"></label>
                        <input type="radio" id="star3half" formControlName="rating" value=3.5 /><label class="half"
                            for="star3half" title="Good"></label>
                        <input type="radio" id="star3" formControlName="rating" value=3 /><label class="full" for="star3"
                            title="Average"></label>
                        <input type="radio" id="star2half" formControlName="rating" value=2.5 /><label class="half"
                            for="star2half" title="Average"></label>
                        <input type="radio" id="star2" formControlName="rating" value=2 /><label class="full" for="star2"
                            title="Fair"></label>
                        <input type="radio" id="star1half" formControlName="rating" value=1.5 /><label class="half"
                            for="star1half" title="Fair"></label>
                        <input type="radio" id="star1" formControlName="rating" value=1 /><label class="full" for="star1"
                            title="Poor"></label>
                        <input type="radio" id="starhalf" formControlName="rating" value=0.5 /><label class="half"
                            for="starhalf" title="Poor"></label>
                    </fieldset>
                </div> -->
                <div class="star-rating" (click)="productReview()">
                  <span *ngFor="let star of fullStars" class="full-star">&#9733;</span>
                  <span *ngIf="halfStar" class="half-star">&#9733;</span>
                  <span *ngFor="let star of emptyStars" class="empty-star">&#9734;</span>
                </div>
                <!-- <div class="star-outer1">
                               
                  <div class="star-inner1" id="star-gold"></div>
               
                </div> -->
                  <!-- <div  *ngFor="let size of product.variant.option_values;let j=index">
                  <a style="font-size: small !important" class="linen_review" (click)="productReview()" *ngIf="groups[3].fields[1].visibility">{{ reviews }} reviews</a>
                </div> -->
                <!-- <a style="font-size: small !important" class="linen_review" routerLink="/product-review/{{newProductDetails.id}}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} reviews</a> -->
                <a style="font-size: small !important;margin-left: 3px;" class="linen_review" (click)="productReview()" *ngIf="groups[3].fields[1].visibility">{{ reviews }}  reviews</a>

                  <!-- <span class="jdgm-qa-badge__text" style="margin-top: 4px; margin-left: 5px;margin-top: 2%">
                    No reviews
                  </span> -->
                  <!-- <a
                      *ngIf="newProductDetails.pricing.raw.price!==0 ">
                      <h4 class="priceRange" *ngIf="
                          newProductDetails.product_type == 'Simple' ||
                          newProductDetails.product_type == 'Variation'
                        ">
                        {{ "₹" }}
                        {{ newProductDetails.pricing.raw.price }}<span style="font-size: 10px;">(per Ream)</span>
                        <div style="display: inline; margin-left: 8px !important" *ngIf="groups[3].showondetailpage">
                          <span [class]="
                              currentRating >= 1
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: #a77737  !important;
                            "></span>
                          <span [class]="
                              currentRating >= 2
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: #a77737  !important;
                            "></span>
                          <span [class]="
                              currentRating >= 3
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: #a77737  !important;
                            "></span>
                          <span [class]="
                              currentRating >= 4
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: #a77737  !important;
                            "></span>
                          <span [class]="
                              currentRating >= 5
                                ? 'fa fa-star checked'
                                : 'fa fa-star-o'
                            " style="
                              font-size: 15px !important;
                              color: #a77737  !important;
                            "></span>

                          <a style="font-size: small !important" routerLink="/product-review/{{
                              newProductDetails.id
                            }}" *ngIf="groups[3].fields[1].visibility">{{ reviews }} reviews</a>
                        </div>
                      </h4>
                    </a> -->
                  <span class="jdgm-qa-badge " style="height: 16px; transform: translate(0px, 6px);margin-top: 1%">
          
                    <i class="fa fa-comments" style="color: #a77737; transform: translate(0px, -5px);"></i>
                  <span class="jdgm-qa-badge__text" style=" transform: translate(0px, -5px); margin-left: 5px;">
                    No questions
                  </span>
                </span>
        
                
                  </div>
                  
                  <div class="title_message">
                    <div class="colour-select-image" style="margin-right: -16px;display: flex; margin-bottom: 50px;width: 67%;margin-top: 20px;">
                      <button id="two" class="dropdown-item special-dropitem" *ngFor="let size of product.variant.option_values;let j=index"
                              (click)="selectOptionLinenRaj(size.option,product.id,j)" [class.active]="size.is_default" style="display: flex;justify-content: center;width:13%;margin-right: 2%;border: 2px solid #a77737!important"
                              >{{size.option}}</button>           
                  </div>
                  </div>
                  

                  <div class="title_message1">
                      <div  class="colour-select-image" style="display: grid;
                      grid-template-columns: repeat(4, 1fr);
                      margin-left: 5%;
                      margin-right: 0%;
                      grid-column-gap: 2%;
                      margin-top:5%;width: 0%;">
                        <button id="two" class="dropdown-item special-dropitem" *ngFor="let size of product.variant.option_values;let j=index"
                                (click)="selectOptionLinenRaj(size.option,product.id,j)" [class.active]="size.is_default" style="display: flex;justify-content: center;width:13%;margin-right: 2%;margin-top:12%;border: 2px solid #a77737!important"
                                >{{size.option}}</button>           
                    </div>  
            </div>
                
                      <!-- </div>
                    </div> -->
                    <p style="font-size: 10px !important; font-family: 'Lato', sans-serif; font-style: italic !important;margin-top: 10px; margin-bottom: 15px !important;;">Our model is 187 cms, chest 37 and is wearing a size medium, slim fit.</p>
                    <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
                    ">
                      <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="button-62 special-addtocart" (click)="addToCartLinenRaj(price.id)" >
                      Add to Cart
                      </button>   
                      
                      
                      <div class="btn btn-primary inq-btn-st ml-1 DetailsviewCart" style="position: relative;
                          min-width: fit-content;
                          margin-bottom: 5%; width: 160px" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
                          
                            <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                                (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                            <span class="inq-sp-2"
                              style="padding-left: 10px;
                        padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
                            <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                                (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
        
        
                          </div>
                      </div>
                  
                <div >
                <div>
                  <h6 style="font-family: 'Playfair Display', 'MillerBanner', serif;
                 
                  letter-spacing: 1.5px !important;
                  font-size: 16px !important;
                 
                  font-weight: 600 !important;color: #a77737;" >Details</h6>
                  <div class="inner-html-list" style="font-family: 'Playfair Display', 'MillerBanner', serif;
                  font-style: italic !important;margin-left: 5%;"  [innerHTML]="bulletPoints"></div>

                </div>
                <div>
                  <h6 style="font-family: 'Playfair Display', 'MillerBanner', serif;
                 
                  letter-spacing: 1.5px !important;
                  font-size: 16px !important;
                  
                  font-weight: 600 !important;color: #a77737;">Benefits Of Wearing Linen</h6>
                  <div class="inner-html-list" style="font-family: 'Playfair Display', 'MillerBanner', serif;
                  font-style: italic !important;"  [innerHTML]="shortDescription"></div>

                </div>
                                            
                                            
                  <!-- <div class="col-4" style="max-width: 23% !important;">
                    <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/delivery-status.png?v=1660022911" width="40px" style="box-shadow: none;">
                    <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">601 Day Returns</p>
                  </div>
        
                  <div class="col-4" style="max-width: 23% !important;">
                    <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/delivery-truck.png?v=1660022911" width="40px" style="box-shadow: none;">
                    <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">Free Shipping</p>
                  </div>
        
                  <div class="col-4" style="max-width: 23% !important;">
                    <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-cash-on-delivery.png?v=1677139182" width="40px" style="box-shadow: none;">
                    <p style="opacity: 1;margin-top: 10px !important;font-size: 10px !important;margin-left: -10px;">Cash On Delivery</p>
                  </div> -->
                  
                </div>
                <hr class="mt__0">
                <!-- <h6 style="font-family: 'Lato', sans-serif !important;
                text-transform: uppercase;
                letter-spacing: 2.5px !important;
                font-size: 10px !important; margin-left: 20px;
                font-weight: 600 !important;">Check delivery</h6>
                <div class="form-wrapper flex" style="width: 72%; margin-left: 25px;">
                  <input type="text" name="pincode_text" id="pincode_text" placeholder="Enter Pin Code" style="width: 73%; border-right: none;height: 37px;
                  border-radius: 6px 0 0 6px;">
                  <input type="button" name="checkPincode" id="checkPincode" value="Check" style="border-left: none;
                  border-radius: 0 6px 6px 0;
                  background: transparent;
                  text-transform: uppercase;width: 67px;
                  font-size: 10px;
                  letter-spacing: 2.5px;
                  font-weight: 600;
                  color: #a77737 !important;transform: translate(0px, -3px);
            height: 38px;">
                </div> -->
                <!-- <div class="social-wrapper">
                  <h6 class="text-light ml__10 mb__10" style="color: black !important;font-family: 'Lato', sans-serif !important;
                  text-transform: uppercase;
                  letter-spacing: 2.5px !important;
                  font-size: 10px !important;
                  margin-left: 20px;
                  font-weight: 600 !important; margin-top: 10px;">Share</h6>
                  <a data-no-instant="" rel="noopener noreferrer nofollow" href="https://www.facebook.com/sharer/sharer.php?u=https://www.andamen.com/products/lilac-grid-linen" target="_blank" class="facebook cb ttip_nt tooltip_top" data-bss-pl="active" data-position="5">
                      
                      <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/002-facebook_986e113b-f806-4c65-b6fd-e0d3e8809ad3.png?v=1646371857" style="height: 23px;margin-left: 20px;margin-right: 40px; box-shadow: none;">
                   </a><a data-no-instant="" rel="noopener noreferrer nofollow" href="mailto:?subject=Lilac%20Grid%20Linen&amp;body=https://www.andamen.com/products/lilac-grid-linen" target="_blank" class="email cb ttip_nt tooltip_top" data-bss-pl="active" data-position="6">
                      
                      <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-email.png?v=1646371636" style="height: 27px;margin-left: 20px;margin-right: 40px; box-shadow: none;">
                   </a><a data-no-instant="" rel="nofollow" target="_blank" class="whatsapp cb ttip_nt tooltip_top" href="https://wa.me/?text=Lilac%20Grid%20Linen https://www.andamen.com/products/lilac-grid-linen" data-bss-pl="active" data-position="7"> 
                      
                       <img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/001-whatsapp.png?v=1646371846" style="height: 21px;margin-left: 20px; box-shadow: none;">
                    </a></div> -->
                    
          </div>
         </div></div>
    </div>
    <hr _ngcontent-ept-c99="" class="mt__0">
    <div id="wrap_des_pr" style="background: aliceblue;">

      <div class="container container_des" style="margin-top: 20px !important;">
        <div class="row" id="tab_pr_deskl" style="margin-top: 20px;">
          
          <div class="col-12 col-md-4" style="margin-top: 30px;">
            <h6 class="m__0 mb__20" style="font-family: 'Lato', sans-serif !important;
            text-transform: uppercase;
            letter-spacing: 2.5px !important;
            font-size: 10px !important;
            font-weight: 600 !important;">Description</h6>
            <p style="font-size: 13px !important;
            font-family: 'Lato', sans-serif;
            font-style: italic !important;
            margin-top: 10px; color: gray;"  [innerHTML]="description"></p>
          </div>
          
          <div class="col-12 col-md-1">
          </div>
          
          <div class="col-12 col-md-3 product_specs" style="margin-top: 30px;">
        
          <div class="row mb__20">
              <div class="col-3"><img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/f3_bee8027b-946e-4870-945b-e63f0ee770dd.png?v=1648536391" style="width: 100%;box-shadow:none"></div>
              <div class="col-9">
                <h6 style="margin-bottom: 0px !important;"><p style="font-family: 'Lato', sans-serif !important;
                  text-transform: uppercase;
                  letter-spacing: 2.5px !important;
                  font-size: 10px !important;
                  font-weight: 600 !important;">100% Linen</p></h6>
                <small class="block" style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Material</small>
              </div>
            </div>
            
            <div class="row mb__20" style="margin-top: 10px;">
              <div class="col-3"><img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/f1.png?v=1648535403" style="width: 100%;box-shadow:none"></div>
              <div class="col-9">
                <h6 style="font-family: 'Lato', sans-serif !important;
                text-transform: uppercase;
                letter-spacing: 2.5px !important;
                font-size: 10px !important;
                font-weight: 600 !important;">Medium Weight Fabric</h6>
                <small class="block" style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Weight</small>
              </div>
            </div>
            
            <div class="row mb__20" style="margin-top: 10px;">
              <div class="col-3"><img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/f4_6296240d-4388-4e2f-8e95-9c67d20c9ab8.png?v=1648536470" style="width: 100%;box-shadow:none"></div>
              <div class="col-9">
                <h6></h6>
                <small class="block" style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Style Suggestion</small>
              </div>
            </div>
            
            <div class="row mb__20" style="margin-top: 10px;">
              <div class="col-3"><img src="https://cdn.shopify.com/s/files/1/0618/3183/9957/files/f2.png?v=1648535414" style="width: 100%;box-shadow:none"></div>
              <div class="col-9">
                <h6 style="font-family: 'Lato', sans-serif !important;
                text-transform: uppercase;
                letter-spacing: 2.5px !important;
                font-size: 10px !important;
                font-weight: 600 !important;">INDIA</h6>
                <small class="block" style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Country of Origin</small>
              </div>
            </div>
          </div>
          
          <div class="col-12 col-md-3 product__desc"  style="margin-top: 30px;margin-left:2%">
            <h6 class="m__0 mb__20" style="font-family: 'Lato', sans-serif !important;
            text-transform: uppercase;
            letter-spacing: 2.5px !important;
            font-size: 10px !important;
            font-weight: 600 !important;">MATERIAL & CARE</h6>
              <div class="inner-html-list" 
              [innerHTML]="otherDescription"></div>
            <!-- <ul style="list-style-type: decimal;">
              <li style="font-size: 10px !important;
              font-family: 'Lato', sans-serif;
              font-style: italic !important;
              margin-top: 10px;">Rajan embroidery at chest</li>
              <li style="font-size: 10px !important;
              font-family: 'Lato', sans-serif;
              font-style: italic !important;
              margin-top: 10px;">Contrast tape at inner neckband</li>
              <li style="font-size: 10px !important;
              font-family: 'Lato', sans-serif;
              font-style: italic !important;
              margin-top: 10px;">Casual Button Down Collar</li>
            </ul> -->
            
<!--             
            <h6 class="mt__40 mb__20" style="font-family: 'Lato', sans-serif !important;
            text-transform: uppercase;
            letter-spacing: 2.5px !important;
            font-size: 10px !important;
            font-weight: 600 !important; margin-top: 10px;">Wash Care</h6>
            <ul style="list-style-type: decimal;">
              <li><span style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Machine wash cold</span></li>
              <li><span style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Tumble dry</span></li>
              <li><span style="font-size: 10px !important;
                font-family: 'Lato', sans-serif;
                font-style: italic !important;
                margin-top: 10px;">Gentle Cycle</span></li></ul> -->
          </div>
        </div>
      </div>
      
    </div>
    <hr _ngcontent-ept-c99="" class="mt__0">
    <div style="width: 90%; margin-left: 4%; margin-right: 4%;">
    <img src="../../../../../assets/images/linenraj/btfd.jpg" style="width: 105%; margin-top: 20px;">
  </div>

  
  <div style="display: flex; justify-content: center;">
    <h3 style="font-weight: 400;
    color: #111;
    line-height: 1.3;
    letter-spacing: 0.5px;
    font-family: 'Playfair Display', 'MillerBanner', serif !important;margin-top: 50px; margin-bottom: 10px;">Now Featuring</h3>
      
    </div>
    <div style="width: 100%;display: flex;justify-content: center;">
    <hr _ngcontent-ept-c99="" class="mt__0" style="width: 50px; display: flex; justify-content: center; margin-bottom: 30px; border: solid 1px black;">
  </div>
          <owl-carousel-o [options]="ProductSliderConfig" class="slider3 rounder-corner-nav">
          <ng-container *ngFor="let product of recommededProducts;let i =index">
          <ng-template carouselSlide >
              <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                <div style="overflow: hidden;"> <div class="linencard"> <img class="lin-content-image" [src]="product.assets[0].image_source" alt="{{ product.name }}"></div></div>
                      
                      <div class="linen_container product-list-description-special1">
                        <div class="grid_info" style="width: 100%;">
                          <p style="justify-content: center;
                          display: flex;">{{product.name}}</p>
                          <!-- <p style="justify-content: center;
                          display: flex;">₹ 2,000</p> -->
                        </div>
                      </div>
                  </a> </div>   
          </ng-template>
          <!-- <ng-template carouselSlide >
                <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                  <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_884b9d18-cb4f-45dd-b557-ab48cfb47e13_720x.jpg?v=1691169008&quot"></div></div>
                  <div class="linen_container product-list-description-special1">
                    <div class="grid_info" style="width: 100%;">
                      <p style="justify-content: center;
                      display: flex;">Geysers Valley Hotel</p>
                      <p style="justify-content: center;
                      display: flex;">₹ 2,000</p>
                    </div>
  
                  </div>
                    </a> </div>
          </ng-template>
            <ng-template carouselSlide >
                <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                  <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_f63ac386-08b1-4ba4-ace5-ba9e9a4dd548_540x.jpg?v=1691391149"></div></div>
                  <div class="linen_container product-list-description-special1">
                    <div class="grid_info" style="width: 100%;">
                      <p style="justify-content: center;
                      display: flex;">Geysers Valley Hotel</p>
                      <p style="justify-content: center;
                      display: flex;">₹ 2,000</p>
                    </div>
  
                  </div>
                    </a> </div>
          </ng-template>
            <ng-template carouselSlide >
              <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_0319c869-8eca-444d-a2a0-c49e067ff898_540x.jpg?v=1691168877&quot"></div></div>
                <div class="linen_container product-list-description-special1">
                  <div class="grid_info" style="width: 100%;">
                    <p style="justify-content: center;
                    display: flex;">Geysers Valley Hotel</p>
                    <p style="justify-content: center;
                    display: flex;">₹ 2,000</p>
                  </div>
  
                </div>
                  </a> </div>
        </ng-template>
          <ng-template carouselSlide >
            <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
              <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_d2933cbc-4898-460a-9009-461ed0342cba_540x.jpg?v=1691168793&quot"></div></div>
              <div class="linen_container product-list-description-special1">
                <div class="grid_info" style="width: 100%;">
                  <p style="justify-content: center;
                  display: flex;">Geysers Valley Hotel</p>
                  <p style="justify-content: center;
                  display: flex;">₹ 2,000</p>
                </div>
  
              </div>
                </a> </div>
      </ng-template>
        <ng-template carouselSlide >
          <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
            <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_6ff4fb71-f8b5-4f7b-82bb-de34cd3fc003_360x.jpg?v=1691168686&quot"></div></div>
            <div class="linen_container product-list-description-special1">
              <div class="grid_info" style="width: 100%;">
                <p style="justify-content: center;
                display: flex;">Geysers Valley Hotel</p>
                <p style="justify-content: center;
                display: flex;">₹ 2,000</p>
              </div>
  
            </div>
              </a> </div>
    </ng-template>
      <ng-template carouselSlide >
        <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
          <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_7b68c17a-ed9e-4224-b6f7-6cba7f4eaa35_540x.jpg?v=1691168732&quot"></div></div>
          <div class="linen_container product-list-description-special1">
            <div class="grid_info" style="width: 100%;">
              <p style="justify-content: center;
              display: flex;">Geysers Valley Hotel</p>
              <p style="justify-content: center;
              display: flex;">₹ 2,000</p>
            </div>
  
          </div>
            </a> </div>
  </ng-template>
    <ng-template carouselSlide >
      <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
        <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_cd354a57-a9ae-41ff-90ac-f0b0f88b3e99_720x.jpg?v=1691169028&quot"></div></div>
        <div class="linen_container product-list-description-special1">
          <div class="grid_info" style="width: 100%;">
            <p style="justify-content: center;
            display: flex;">Geysers Valley Hotel</p>
            <p style="justify-content: center;
            display: flex;">₹ 2,000</p>
          </div>
  
        </div>
          </a> </div>
  </ng-template>
  <ng-template carouselSlide >
                <div class="content product-list-cards-specialwires4"> <a (click)="productDetails(1)">
                  <div style="overflow: hidden;">    <div class="linencard"> <img class="lin-content-image" src="https://cdn.shopify.com/s/files/1/0618/3183/9957/products/01_924ddbaf-b76d-4b10-83f4-680378288a1b_720x.jpg?v=1691168988&quot"></div></div>
                  <div class="linen_container product-list-description-special1">
                    <div class="grid_info" style="width: 100%;">
                      <p >Geysers Valley Hotel</p>
                      <p >₹ 2,000</p>
                    </div>
  
                  </div>
                    </a> </div>
          </ng-template> -->
        </ng-container>
      </owl-carousel-o>


  <div class="col-12" style="background-color: aliceblue;">

    <h3 class="text-center mb__30 mt__0" style="margin-top: 50px;padding-top: 33px; padding-bottom: 25px;">Need Help?</h3>

    <div class="row" style="padding-bottom: 30px;">
      <div class="col-2 hidden-xs"></div>
      <div class="col-12 col-md-3">
        <div class="row linen_cont">
          <div class="col-2 col-md-2">
            <img src="https://cdn.shopify.com/s/files/1/0554/1419/4338/files/172517_phone_icon_b68229e3-5a4b-4b7b-ad96-fb6ee11bc8da.png?v=1631791927" style="width: 33px; box-shadow: none;">
          </div>
          <div class="col-10 col-md-10">
            <a >+91 984 222 96 39</a>
            <!-- <small>(Mon - Fri, 10:00-6:30 IST)</small> -->
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="row linen_cont">
          <div class="col-2 col-md-2">
            <img src="https://cdn.shopify.com/s/files/1/0554/1419/4338/files/853339_whatsapp_icon_29be8559-1c55-41b3-85fd-ff7003598fb8.png?v=1631791926" style="width: 33px; box-shadow: none;">
          </div>
          <div class="col-10 col-md-10">
            <a href="tel:+919555263263">+91 984 222 96 39</a>
            <!-- <small>(Mon - Fri, 10:00-6:30 IST)</small> -->
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="row linen_cont">
          <div class="col-2 col-md-2">
            <img src="https://cdn.shopify.com/s/files/1/0554/1419/4338/files/185078_mail_email_icon_d5d54cdc-8c2f-40b7-b5a4-12b93eec568f.png?v=1631791927" style="width: 33px; box-shadow: none;">
          </div>
          <div class="col-10 col-md-10">
            <a href="mail-to:contact@andamen.com">care@linenraj.com</a>
            <small>(Typical response time: 24 hours)</small>
          </div>
        </div>
      </div>
    </div>

  </div>
                </section>


<div (click)="closeVideo()">
  <button id="launch-video1" type="button" style="display: none !important" class="btn btn-primary" data-toggle="modal"
    data-target="#exampleModal12">
    Launch demo modal
  </button>
  <div class="modal fade" id="exampleModal12" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-primary" id="exampleModalLabel">
            iLY Flour Instruction Video
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeVideo()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="padding: 0px !important"  *ngIf="config.title !== 'Vistas' && config.title !== 'Mayan' && config.title !== 'LushNGreen' && config.title !== 'KatbookStore' && config.title !=='Taazah'">
          <iframe width="100%" height="325" [src]="mainViewVideo" title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal" style="padding: 5px 15px !important"
            (click)="closeVideo()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div  *ngIf="config.title==='BestGifts'" (click)="closeVideo()">
  <button id="launch-video2" type="button" style="display: none !important" class="btn btn-primary" data-toggle="modal"
    data-target="#exampleModal13">
    Launch demo modal
  </button>
  <div *ngIf="config.title == 'BestGifts'" class="modal fade" id="exampleModal13" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-primary" id="exampleModalLabel">
            {{newProductDetails.name}} - Video
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeVideo()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="padding: 0px !important">
            <!-- <div *ngIf="config.title==='BestGifts'" class="video1">
               <video class="video-js vjs-default-skin" width="640px" height="267px" controls preload="none"
            poster='https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Bestgifts/StoreGallery/1686546498578%20-%20bestgifts.png'
            data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
            <source src="{{productViewVideo}}" type='video/mp4' />
          </video>
            </div> -->
           
              <span *ngIf="config.title==='BestGifts' && newProductDetails.video_assets">
                <div *ngIf="config.title==='BestGifts' && newProductDetails.video_assets.length>0" class="video1" style="margin-left: 8%;">
                  <div *ngIf="viewVideo===true">
                    <!-- <video class="video-js vjs-default-skin" width="640px" height="267px" controls preload="none"
                    poster='https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Bestgifts/StoreGallery/1686546498578%20-%20bestgifts.png'
                    data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
                    <source src="{{newProductDetails.video_assets[0].link}}" type='video/mp4' />
                  </video> -->
                  <video class="video-js vjs-default-skin" width="640px" height="267px" controls preload="metadata"
                  data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
                  <source src="{{newProductDetails.video_assets[0].link}}#t=0.5" type='video/mp4' />
                </video>
                  </div>
  
                  <div *ngIf="viewVideo1===true">
                    <!-- <video *ngIf="productViewVideo1" [src]="productViewVideo1" class="video-js vjs-default-skin" width="640px" height="267px" controls preload="none"
                    poster='https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Bestgifts/StoreGallery/1686546498578%20-%20bestgifts.png'
                    data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'> -->
                    <!-- <source [src]="productViewVideo1" type='video/mp4' /> -->
                  <!-- </video> -->
                  <video *ngIf="productViewVideo1" src="{{productViewVideo1}}#t=0.5" class="video-js vjs-default-skin" width="640px" height="267px" controls preload="metadata"
                    data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
                    <!-- <source [src]="productViewVideo1" type='video/mp4' /> -->
                  </video>
                  </div>
  
              <div class="row" *ngIf="newProductDetails.video_assets.length>0" style="width: 100%;overflow-x: auto; white-space: nowrap;">
                  <div *ngFor="let video of newProductDetails.video_assets; let i = index" style="margin-left: 2%;margin-top: 10px;margin-bottom: 10px;">
                    <img  src="assets/images/bestgifts/playimage.jpg" class="image-preview-product"  [class.active]="isActive1 === i" style="width: 80px; height: 80px"
                     (click)="productVideoPreview1(video,i)" />
                  </div>
                </div>
              
       
              <!-- <div *ngIf="config.title==='BestGifts'" class="video2">
                <video class="video-js vjs-default-skin" width="375px" height="267px" controls preload="none"
              poster='https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Bestgifts/StoreGallery/1686546498578%20-%20bestgifts.png'
              data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
              <source src="{{video.link}}" type='video/mp4' />
            </video>
            <br>
            <br>
            <br>
              </div> -->
              </div>
              </span>
            
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal" style="padding: 5px 15px !important"
            (click)="closeVideo()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<button id="launch-model" style="display: none;" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel">
  Launch demo modal
</button>
<div *ngIf="config.title !== 'Vimpro'" class="modal fade" id="statusModel" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true" #closeModal data-dismiss="modal" aria-label="Close">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document"
    style="max-width: 640px !important;position: relative !important; -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;-moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important; -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;">
    <div class="modal-content status-model-container">
      <div class="modal-body" style="border: none !important;">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.6rem !important;" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container">
            <div class="m-title enquiry-title">{{ companyName }}</div>
            <div class="m-title">Enquiry Form</div>
          </div>
          <form [formGroup]="enquiryForm" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label">Name <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="(f2.name.invalid && validateForm)"
                  formControlName="name" required>
                <div class="invalid-feedback" *ngIf="f2.name.errors">
                  <div *ngIf="f2.name.errors.required">
                    Name is required.
                  </div>
                  <div *ngIf="f2.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label">Email <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email"
                  [class.is-invalid]="(f2.email.invalid && validateForm)" formControlName="email" maxlength="50" email>
                <div class="invalid-feedback" *ngIf="f2.email.errors">
                  <div *ngIf="f2.email.errors.required">
                    Email is required.
                  </div>
                  <div *ngIf="f2.email.errors.maxlength">
                    Seneder Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f2.email.errors.email || f2.email.errors.pattern">
                    Email must be a valid email address
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label">Mobile<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="phone_number"
                  [class.is-invalid]="f2.phone_number.invalid && validateForm" formControlName="phone_number" required>
                <div class="invalid-feedback" *ngIf="f2.phone_number.errors">
                  <div *ngIf="f2.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f2.phone_number.errors.maxlength">
                    Mobile Number can't be more than 10 characters long.
                  </div>
                  <div *ngIf="f2.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Category<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="category"
                  [class.is-invalid]="f2.category.invalid && validateForm" formControlName="category" required readonly>
                <div class="invalid-feedback" *ngIf="f2.category.errors">
                  <div *ngIf="f2.category.errors.required">
                    Category is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Message<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f2.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f2.message.errors">
                  <div *ngIf="f2.message.errors.required">
                    Message is required.
                  </div>
                  <div *ngIf="f2.message.errors.maxlength">
                    Message can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px;">
              <button class="btn btn-primary"
                style="border-radius: 5px !important; font-size: 1rem; padding: 5px 25px;float: right;"
                (click)="saveForm()">SUBMIT</button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal for Best gifts -->
<!-- Modal -->


<form #additem="ngForm">
  <div class="modal fade" id="bestGiftsUploadModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Confirm Order details</h5>
        </div>

        <div class="modal-body">

          <div class=" modal-container-bestgifts  container">  
            <!-- <div *ngIf='currentUserType == "business customer"' class="row"> -->
              <div *ngIf='customerType1 == "business customer"' class="row">
              <div class="col-4">
                <!-- <button class="btn btn-primary">Download Mask files <i class="fa fa-download"
                    aria-hidden="true"></i></button> -->
                    <a href="{{maskImages}}" target="_self" download>Download Mask</a>
              </div>
            </div>

            <hr>

            <div class="modal-container-bestgifts  container" *ngFor="let _ of [].constructor(numberOfProductsBestGifts); index as i">
              <div class="row">
                <div class="col-md-8">
                  <div class="row image-container-bestgifts" *ngFor="let _ of [].constructor(numberOfMaskUploads); index as j">
                    <div class="form-group col-md-3 col-5 upload-button-bestgifts" style="margin-top: 20px;">



                      <button class="btn btn-primary " (click)="imageupload1('maskImage_'+i+'_'+j)">Upload</button>
                      
                      

                      
                    </div>
                    <div class="form-group col-md-9 col-7 image-view-bestgifts"  id='{{"image-view-bestgifts-"+i}}'>
                      <div class="product-image-container">
                        <div *ngIf="!imagelist['maskImage_'+i+'_'+j]">
                          <i class="fa fa-upload text-primary uploadicon" aria-hidden="true"></i><br>
                          <div class="upload-text">No file chosen, yet!</div>
                        </div>
                        <div *ngIf="imagelist['maskImage_'+i+'_'+j]">
                          <img 
                          class="image-preview-bestgifts"
                          [src]="imagelist['maskImage_'+i+'_'+j]">
                        
                        </div>
                      </div>

                      <input type="file" [id]="'maskImage_'+i+'_'+j" style="display: none" (change)="imageupload($event,'maskImage_'+i+'_'+j, i)" name="{{'maskImage_'+i+'_'+j}}" ngModel>
                    </div>

                    <div class="text-content-model-bestgifts"><label class="image-help-text">( Maximum file size of 10MB, Supports JPEG, PNG, GIF )</label></div>
                  </div>
                  <div class="row text-content-model-bestgifts image-input-bestgifts">
                    <label class="product-upload-text-bestgifts" style="margin-right: 2%">
                      Text to be displayed in product: 
                    </label>
                    <input class="form-control"  maxlength="40" type="text" id="{{'bestGiftsText_'+i}}"  name="{{'text_' + i}}"  [(ngModel)]="modelForBindingTextInputs['text_'+i]">
                  </div>
                </div>
                <div class="col-md-4 buttons-modal-bestgifts">
                  <div class="row">

                    <div class="col-8">
                      <span>
                        <div class="btn btn-primary inq-btn-st ml-1">
                          <span>
                          <i class="fa fa-minus mr-2" (click)="decreaseBestGiftsIndividualQuantity(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                          <input type="number" value=1 id="{{'bestGiftsIndividualQuantity_'+i}}" (input)="bestGiftsChangeQuantity(i, 1, $event)"  min="1" style="width: 46%; text-align: center" name="{{'individualQuantity' + i}}" [(ngModel)]="modelForBindingInputs['individualQuantity_'+i]"/>
                          <span>
                            <i class="fa fa-plus ml-2" (click)="increaseBestGiftsIndividualQuantity(i)"
                            style="font-size: 12px; cursor: pointer"></i></span>
                        </div>
                      </span>
                    </div>
                    

                    <div *ngIf="numberOfProductsBestGifts > 1" class="col-2 px-2">
                      <button class="btn btn-danger" (click)="decreaseItemBestGifts(i+1, additem)">X</button>
                    </div>
                    <div class="col-2 px-2">
                      <button class="btn btn-secondary" (click)="incrementNumberOfProductsForBestGifts()">+</button>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
            </div>
          </div>


          <div class="modal-footer">
            <button type="button" style="display:none" id="bestgifts_close" class="btn btn-secondary" data-dismiss="modal" >Close</button>
            <button id="closebgbt"   type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModalWithRefresh()">Close</button>
            <button type="button" class="btn btn-danger"  (click)="resetBestGifts()">Reset</button>
            <button class="btn btn-primary" type="button" (click)="onClickSubmit(additem)">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<button id="launch-model-special" style="display: none" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel-special">
  Launch demo modal
</button>
  <div class="modal fade" *ngIf="config.title === 'SpecialWires'" id="statusModel-special" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" style="
      max-width: 640px !important;
      position: relative !important;
      bottom: -30px !important;
      -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
    ">
    <div *ngIf="config.title === 'SpecialWires'" class="modal-content status-model-container">
      <div class="modal-body" style="border: none !important">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container">
            <div class="m-title">Enquiry Form - {{special_pro_name}}</div>
            
          </div>
          <form [formGroup]="enquiryForm_special" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label">Name <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="f_special.name.invalid && validateForm"
                  formControlName="name" required />
                <div class="invalid-feedback" *ngIf="f_special.name.errors">
                  <div *ngIf="f_special.name.errors.required">Name is required.</div>
                  <div *ngIf="f_special.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label">Email<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email" [class.is-invalid]="f_special.email.invalid && validateForm"
                  formControlName="email" maxlength="50" email />
                <div class="invalid-feedback" *ngIf="f_special.email.errors">
                  <div *ngIf="f_special.email.errors.required">Email is required.</div>
                  <div *ngIf="f_special.email.errors.maxlength">
                    Sender Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f_special.email.errors.email || f_special.email.errors.pattern">
                    Email must be a valid email address
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label">Mobile<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="phone_number"
                  [class.is-invalid]="f_special.phone_number.invalid && validateForm" formControlName="phone_number" required />
                <div class="invalid-feedback" *ngIf="f_special.phone_number.errors">
                  <div *ngIf="f_special.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f_special.phone_number.errors.maxlength">
                    Mobile Number can't be more than 10 characters long.
                  </div>
                  <div *ngIf="f_special.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Category<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="category"
                  [class.is-invalid]="f_special.category.invalid && validateForm" formControlName="category" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f_special.category.errors">
                  <div *ngIf="f_special.category.errors.required">
                    Category is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="product_name" class="form-label">Product Name<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="product_name"
                  [class.is-invalid]="f_special.product_name.invalid && validateForm" formControlName="product_name" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f_special.product_name.errors">
                  <div *ngIf="f_special.product_name.errors.required">
                    Product Name is required.
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="form-group row">
              <div class="col-md-4">
                <label for="drawing" class="form-label">Upload Drawing</label>
              </div>
              <div class="col-md-7">
                <input type="file" class="form-control" id="drawing"
                   formControlName="drawing" accept=".jpeg,.jpeg,.png,.pdf"
                   />
                
              </div>
            </div> -->
            
            <div class="form-group row">
              <div class="col-md-4">
                <label for="drawing" class="form-label">Upload Chart</label>
              </div>
              <div class="col-md-7">
                <input type="file" (change)="imageupload2($event)" style="display: none;" #fileuploadinput />
                <div class="btn-group" name="imageFile" id="uploadButton"
                  [class.is-invalid]="validateForm && f_special.imageFile.errors">
                  <button type="file" class="btn btn-primary btn-md shadow-sm" accept="image/*"
                    (click)="fileuploadinput.click()">upload</button>{{imageName}}
                </div>
                <p style="font-size:xx-small;">maximum file size 2MB.Allowed file types JPEG/PNG/JPG</p>
        
                <div class="invalid-feedback" *ngIf="f_special.imageFile.errors">
                  <div *ngIf="f_special.imageFile.errors.invalid">invalid file name.</div>
                  <div *ngIf="f_special.imageFile.errors.type">invalid file type.</div>
                  <div *ngIf="f_special.imageFile.errors.sizezero">File size should be greater than zero.</div>
                  <div *ngIf="f_special.imageFile.errors.sizehigh">File size should be less than 2MB.</div>
                </div>
        
              </div>
          </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="diameter" class="form-label">Diameter</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="diameter"
                   formControlName="diameter"
                   />
                
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label for="e_length" class="form-label">Length</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="e_length"
                   formControlName="e_length"
                   />
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="quantity" class="form-label">Quantity</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="quantity"
                   formControlName="quantity"
                   />
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Enter Specification<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f_special.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f_special.message.errors">
                  <div *ngIf="f_special.message.errors.required">
                    Specification is required.
                  </div>
                  <div *ngIf="f_special.message.errors.maxlength">
                    Specification can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px">
              <button class="btn btn-primary" style="
                  border-radius: 5px !important;
                  font-size: 1rem;
                  padding: 5px 25px;
                  margin-top: 5px;
                  float: right;
                " (click)="saveForm_special()">
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<button id="launch-model-linen" style="display: none" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel-linen">
  Launch demo modal
</button>
  <div class="modal fade" id="statusModel-linen" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" style="
      max-width: 640px !important;
      position: relative !important;
      bottom: -30px !important;
      -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
    ">
    <div class="modal-content status-model-container">
      <div class="modal-body" style="border: none !important">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" id="linenclose" data-dismiss="modal" aria-label="Close" style="display: none;">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <button (click)="closeLinen()" type="button" class="close" aria-label="Close">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <div class="container-fluid px-1 py-5 mx-auto">
                <div class="col-12 text-center mb-5">
                        <div class="row justify-content-left d-flex">
                            <div class="col-md-4 d-flex flex-column linen-reviewbox">
                                <div class="rating-box">
                                    <h2 class="pt-4">{{product_rating}}</h2>
                                    <p class="">out of 5</p>
                                </div>
                                <div style="display: inline; margin-left: 8px !important" *ngIf="groups[3].showondetailpage">
                                  <!-- <ngb-rating [max]="5"  [(rate)]="currentRating" [readonly]="true"></ngb-rating> -->
                                  <span [class]="
                                      currentRating >= 1
                                        ? 'fa fa-star checked'
                                        : 'fa fa-star-o'
                                    " style="
                                      font-size: 15px !important;
                                      color: orange !important;
                                    "></span>
                                  <span [class]="
                                      currentRating >= 2
                                        ? 'fa fa-star checked'
                                        : 'fa fa-star-o'
                                    " style="
                                      font-size: 15px !important;
                                      color: orange !important;
                                    "></span>
                                  <span [class]="
                                      currentRating >= 3
                                        ? 'fa fa-star checked'
                                        : 'fa fa-star-o'
                                    " style="
                                      font-size: 15px !important;
                                      color: orange !important;
                                    "></span>
                                  <span [class]="
                                      currentRating >= 4
                                        ? 'fa fa-star checked'
                                        : 'fa fa-star-o'
                                    " style="
                                      font-size: 15px !important;
                                      color: orange !important;
                                    "></span>
                                  <span [class]="
                                      currentRating >= 5
                                        ? 'fa fa-star checked'
                                        : 'fa fa-star-o'
                                    " style="
                                      font-size: 15px !important;
                                      color: orange !important;
                                    "></span> </div>
                                <!-- <form [formGroup]="productRating" style="text-align:center;">
                                <div class="form-group row" *ngIf="review_list.length !== 0">
                                    <div class="rating">
                                      <input type="radio" id="star5" formControlName="rating" value=5 /><label for="star5" title="Excellent">5 stars</label>
                                      <input type="radio" id="star4" formControlName="rating" value=4 /><label for="star4" title="Good">4 stars</label>
                                      <input type="radio" id="star3" formControlName="rating" value=3/><label for="star3" title="Not bad">3 stars</label>
                                      <input type="radio" id="star2" formControlName="rating" value=2 /><label for="star2" title="Bad">2 stars</label>
                                      <input type="radio" id="star1" formControlName="rating" value=1 /><label for="star1" title="Worst">1 star</label>
                                    </div>
                                    </div>
                                </form> -->
                                <div style="display: flex; justify-content: center;">
                                <div class="star-outer">
                               
                                  <div class="star-inner" id="star-inner"></div>
                               
                                </div>
                              </div>
                            </div>
                            <div class="col-md-8">
                                <div class="rating-bar0 justify-content-center">
                                    <table class="text-left mx-auto">
                                        <tr>
                                            <td class="rating-label">Excellent</td>
                                            <td class="rating-bar">
                                                <div class="bar-container" (click)="starReview(5)">
                                                    <div class="bar-5" id="bar-5" [style.width.%]=width5></div>
                                                </div>
                                            </td>
                                            <td class="text-right">{{five_star}}</td>
                                        </tr>
                                        <tr>
                                            <td class="rating-label">Good</td>
                                            <td class="rating-bar">
                                                <div class="bar-container"  (click)="starReview(4)">
                                                    <div class="bar-4" id="bar-4" [style.width.%]=width4></div>
                                                </div>
                                            </td>
                                            <td class="text-right">{{four_star}}</td>
                                        </tr>
                                        <tr>
                                            <td class="rating-label">Average</td>
                                            <td class="rating-bar">
                                                <div class="bar-container"  (click)="starReview(3)">
                                                    <div class="bar-3" id="bar-3" [style.width.%]=width3></div>
                                                </div>
                                            </td>
                                            <td class="text-right">{{three_star}}</td>
                                        </tr>
                                        <tr>
                                            <td class="rating-label">Poor</td>
                                            <td class="rating-bar">
                                                <div class="bar-container">
                                                    <div class="bar-2" id="bar-2" [style.width.%]=width2></div>
                                                </div>
                                            </td>
                                            <td class="text-right">{{two_star}}</td>
                                        </tr>
                                        <tr>
                                            <td class="rating-label">Terrible</td>
                                            <td class="rating-bar">
                                                <div class="bar-container">
                                                    <div id="bar-1" class="bar-1" [style.width.%]=width1></div>
                                                </div>
                                            </td>
                                            <td class="text-right">{{one_star}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    <div *ngFor = "let list of review_list;let i=index;">
                    <div class="cardlinen">
                        <div class="row d-flex">
                            
                            <div class="d-flex linenreviewcomment">
                              <h4 class="blue-text" style="float: left !important;">{{list.title}} </h4>
                          </div>
                          <div class="d-flex flex-column linenreviewstar">
                            <h3 class="mt-2 mb-0">{{list.posted_by}}</h3>
                                <div class="row d-flex" style="margin-top: -1;">
                                    <div class="d-flex flex-column">
                                        <div class="inner-star-icon" style="padding-left: 15px;">
                                            <span [class]="list.rating >= 1 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                            <span [class]="list.rating >= 2 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                            <span [class]="list.rating >= 3 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                            <span [class]="list.rating >= 4 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                            <span [class]="list.rating >= 5 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                        </div>
                                    </div>
                                </div>
                        </div>
                          <div class="linenreviewcom">
                            <p class="content linenrevcom"  style="float: left !important;">{{list.comments}}</p>
                        </div>
                            <div class="ml-auto">
                                <p class="text-muted pt-5 pt-sm-3" style="font-size: 11px;">{{list.reviewed_date}}</p>
                            </div>
                        </div>
        
                        <!-- <div class="row d-flex" style="margin-top: -1;">
                            
                            
                        </div> -->
                    </div>
                    </div>
                </div>
        </div>
          <!-- <div *ngFor = "let list of review_list;let i=index;">
            <div class="card3">
                <div class="row d-flex"> 
                    <div class="d-flex flex-column">
                        <h3 class="mt-2 mb-0">{{list.posted_by}}</h3>
                            <div class="row d-flex" style="margin-top: -1;">
                                <div class="d-flex flex-column">
                                    <div class="inner-star-icon" style="padding-left: 15px;">
                                        <span [class]="list.rating >= 1 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                        <span [class]="list.rating >= 2 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                        <span [class]="list.rating >= 3 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                        <span [class]="list.rating >= 4 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                        <span  [class]="list.rating >= 5 ? 'fa fa-star checked' : 'fa fa-star unchecked'"></span>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="ml-auto">
                        <p class="text-muted pt-5 pt-sm-3">{{list.reviewed_date}}</p>
                    </div>
                </div>

                <div class="row d-flex" style="margin-top: -1;">
                    
                    <div class="d-flex flex-column">
                        <h4 class="blue-text mt-3" style="float: left !important;">{{list.title}}</h4>
                        <div>
                            <p class="content"  style="float: left !important;">{{list.comments}}</p>
                        </div>
                    </div>
                </div>
            </div>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
<button id="launch-model-vimpro" style="display: none" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel-vimpro">
  Launch demo modal
</button>
<div class="modal fade" id="statusModel-vimpro" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" style="
      max-width: 640px !important;
      position: relative !important;
      bottom: -30px !important;
      -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
    ">
    <div class="modal-content status-model-container" *ngIf="config.title === 'Vimpro'" >
      <div class="modal-body" style="border: none !important">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container">
            <div class="m-title">Enquiry Form - {{vimpro_pro_name}}</div>
            
          </div>
          <form [formGroup]="enquiryForm_vimpro" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label">Name <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="f_vimpro.name.invalid && validateForm"
                  formControlName="name" required />
                <div class="invalid-feedback" *ngIf="f_vimpro.name.errors">
                  <div *ngIf="f_vimpro.name.errors.required">Name is required.</div>
                  <div *ngIf="f_vimpro.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label">Email<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email" [class.is-invalid]="f_vimpro.email.invalid && validateForm"
                  formControlName="email" maxlength="50" email />
                <div class="invalid-feedback" *ngIf="f_vimpro.email.errors">
                  <div *ngIf="f_vimpro.email.errors.required">Email is required.</div>
                  <div *ngIf="f_vimpro.email.errors.maxlength">
                    Seneder Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f_vimpro.email.errors.email || f_vimpro.email.errors.pattern">
                    Email must be a valid email address 
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label">Mobile<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="phone_number"
                  [class.is-invalid]="f_vimpro.phone_number.invalid && validateForm" formControlName="phone_number" required />
                <div class="invalid-feedback" *ngIf="f_vimpro.phone_number.errors">
                  <div *ngIf="f_vimpro.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f_vimpro.phone_number.errors.maxlength">
                    Mobile Number can't be more than 15 characters long.
                  </div>
                  <div *ngIf="f_vimpro.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Category<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="category"
                  [class.is-invalid]="f_vimpro.category.invalid && validateForm" formControlName="category" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f_vimpro.category.errors">
                  <div *ngIf="f_vimpro.category.errors.required">
                    Category is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="product_name" class="form-label">Product Name<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="product_name"
                  [class.is-invalid]="f_vimpro.product_name.invalid && validateForm" formControlName="product_name" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f_vimpro.product_name.errors">
                  <div *ngIf="f_vimpro.product_name.errors.required">
                    Product Name is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="length" class="form-label">Length(mm)</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="length"
                   formControlName="length" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.length.errors">
                  <div *ngIf="f_vimpro.length.errors.required">
                    Length is required.
                  </div>
                </div> -->
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="thickness" class="form-label">Thickness(mm)</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="thickness"
                   formControlName="thickness" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.thickness.errors">
                  <div *ngIf="f_vimpro.thickness.errors.required">
                    Thickness is required.
                  </div>
                </div> -->
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="height" class="form-label">Height(mm)</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="height"
                   formControlName="height" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.height.errors">
                  <div *ngIf="f_vimpro.height.errors.required">
                    Height is required.
                  </div>
                </div> -->
              </div>
            </div>


            <div class="form-group row">
              <div class="col-md-4">
                <label for="Width" class="form-label">Width(mm)</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="Width"
                   formControlName="width" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.height.errors">
                  <div *ngIf="f_vimpro.height.errors.required">
                    Height is required.
                  </div>
                </div> -->
              </div>
            </div>


            <div class="form-group row">
              <div class="col-md-4">
                <label for="quantity" class="form-label">Quantity</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="quantity"
                   formControlName="quantity" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.quantity.errors">
                  <div *ngIf="f_vimpro.quantity.errors.required">
                    Quantity is required.
                  </div>
                </div> -->
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="material" class="form-label">Material</label>
              </div>
              <div class="col-md-7">
                <select  formControlName="material">
                  <option *ngFor="let c of material_vimpro">{{ c }}</option>
              </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="color" class="form-label">Color</label>
              </div>
              <div class="col-md-7">
                <select  formControlName="color">
                  <option *ngFor="let c of color_vimpro">{{ c }}</option>
              </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="color" class="form-label">Usage</label>
              </div>
              <div class="col-md-7">
                <select  formControlName="usage">
                  <option *ngFor="let c of usage_vimpro">{{ c }}</option>
              </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Message<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f_vimpro.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f_vimpro.message.errors">
                  <div *ngIf="f_vimpro.message.errors.required">
                    Message is required.
                  </div>
                  <div *ngIf="f_vimpro.message.errors.maxlength">
                    Message can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px">
              <button class="btn btn-primary" style="
                  border-radius: 5px !important;
                  font-size: 1rem;
                  padding: 5px 25px;
                  margin-top: 5px;
                  float: right;
                " (click)="saveForm_vimpro()">
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>





<button id="launch-model-accel" style="display: none;" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModelAccel">
  Launch demo modal
</button>
<div *ngIf="config.title == 'Accel'" class="modal fade" id="statusModelAccel" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true" #closeModal data-dismiss="modal" aria-label="Close">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document"
    style="max-width: 640px !important;position: relative !important; -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;-moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important; -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;">
    <div class="modal-content status-model-container">
      <div class="modal-body" style="border: none !important;">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.6rem !important;" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container">
            <div class="m-title enquiry-title" style="color: #0a1b4c!important;">{{ companyName }}</div>
            <div class="m-title">Enquiry Form</div>
          </div>
          <form [formGroup]="enquiryForm" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label">Name <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="(f2.name.invalid && validateForm)"
                  formControlName="name" required>
                <div class="invalid-feedback" *ngIf="f2.name.errors">
                  <div *ngIf="f2.name.errors.required">
                    Name is required.
                  </div>
                  <div *ngIf="f2.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label">Email <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email"
                  [class.is-invalid]="(f2.email.invalid && validateForm)" formControlName="email" maxlength="50" email>
                <div class="invalid-feedback" *ngIf="f2.email.errors">
                  <div *ngIf="f2.email.errors.required">
                    Email is required.
                  </div>
                  <div *ngIf="f2.email.errors.maxlength">
                    Seneder Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f2.email.errors.email || f2.email.errors.pattern">
                    Email must be a valid email address
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label">Mobile<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="phone_number"
                  [class.is-invalid]="f2.phone_number.invalid && validateForm" formControlName="phone_number" required>
                <div class="invalid-feedback" *ngIf="f2.phone_number.errors">
                  <div *ngIf="f2.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f2.phone_number.errors.maxlength">
                    Mobile Number can't be more than 10 characters long.
                  </div>
                  <div *ngIf="f2.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Category<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="category"
                  [class.is-invalid]="f2.category.invalid && validateForm" formControlName="category" required readonly>
                <div class="invalid-feedback" *ngIf="f2.category.errors">
                  <div *ngIf="f2.category.errors.required">
                    Category is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">12th Certificate</label>
              </div>
              <div class="col-md-7">
                <input type="file" id="myFile" name="filename">
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">UG Certificate</label>
              </div>
              <div class="col-md-7">
                <input type="file" id="myFile" name="filename">
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Higher Education Certificate</label>
              </div>
              <div class="col-md-7">
                <input type="file" id="myFile" name="filename">
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Message<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f2.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f2.message.errors">
                  <div *ngIf="f2.message.errors.required">
                    Message is required.
                  </div>
                  <div *ngIf="f2.message.errors.maxlength">
                    Message can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px;">
              <button class="btn btn-primary"
                style="border-radius: 5px !important; font-size: 1rem; padding: 5px 25px;float: right;"
                (click)="saveForm_accel()">SUBMIT</button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <ngx-spinner size="medium"></ngx-spinner> -->

